/* ============================================================================
Kanchan Cashmere — Premium Concierge Widget
KCC v47.18.68 — CLEAN EN/DE GERMAN-STOREFRONT DATA LOCK

Production scope:
- One EN/DE file for the current Kanchan Cashmere header + footer architecture
- Deterministic page families: Home / Product / Collection / Buyer / Private
- Homepage `/` and `/de` always open KCC as Ask Anything
- Product pages use Product Concierge
- Retail collection pages use Collection Concierge
- Buyer Studio, Buyer Services and Our Excellences use Buyer Concierge
- Library, The Kanchan, brand, customer-care and policy pages use Private Concierge
- Swatch products / swatch library remain Buyer Concierge
- Editorial collections remain Private Concierge
- Locale-safe UI, links, prompts, discovery, accessibility and Worker payload
- Verified Shopify product/price rendering, mobile scroll safety and no-flash mounting

This is a complete replacement build. No incremental patch block is required.
============================================================================ */
(function () {
  /* VERIFIED PUBLIC YARN KNOWLEDGE — FW 2026–27
     Used for exact concierge context and local presentation; live technical answers are validated by the Worker. */
  const KCC_YARN_PARTNERS = Object.freeze(["Cariaggi", "Consinee", "Top Line"]);
  const KCC_YARN_LIBRARY = Object.freeze([{"name":"CASHMERE","count":"NM 2/28","composition":"100% Cashmere","supplier":"Cariaggi"},{"name":"SOFFIO","count":"NM 2/60","composition":"100% Cashmere","supplier":"Cariaggi"},{"name":"JAIPUR","count":"NM 2/56","composition":"70% Cashmere / 30% Silk","supplier":"Cariaggi"},{"name":"DUEQUARANTASEI","count":"NM 2/46","composition":"100% Cashmere","supplier":"Cariaggi"},{"name":"ALBA","count":"NM 30000","composition":"50% Cashmere / 50% Silk","supplier":"Cariaggi"},{"name":"BOUCLE 1400","count":"NM 1400","composition":"93% Cashmere / 7% Silk","supplier":"Cariaggi"},{"name":"IGLOO","count":"NM 1400","composition":"90% Cashmere / 10% Silk","supplier":"Cariaggi"},{"name":"BOUCLE 4000","count":"NM 4000","composition":"72% Cashmere / 28% Silk","supplier":"Cariaggi"},{"name":"BOUCLE 7500","count":"NM 7500","composition":"80% Cashmere / 20% Silk","supplier":"Cariaggi"},{"name":"MEGEVE","count":"NM 7500","composition":"80% Cashmere / 20% Silk","supplier":"Cariaggi"},{"name":"CORTINA","count":"NM 1700","composition":"77% Cashmere / 23% Silk + Beads","supplier":"Cariaggi"},{"name":"CRAZY","count":"NM 1500","composition":"80% Cashmere / 20% Silk + Paillettes","supplier":"Cariaggi"},{"name":"DOT","count":"NM 7500","composition":"86% Cashmere / 14% Silk","supplier":"Cariaggi"},{"name":"FLLECE","count":"NM 2/12","composition":"100% Cashmere","supplier":"Cariaggi"},{"name":"GLAMOUR","count":"NM 2.87","composition":"51% Cashmere / 21% Silk / 20% PA / 7% PM","supplier":"Cariaggi"},{"name":"GRITTY","count":"NM 23000","composition":"59% Cashmere / 25% Silk / 12% PA / 4% PM + Paillettes","supplier":"Cariaggi"},{"name":"JUMPING","count":"NM 2/80","composition":"93% Cashmere / 7% PBT","supplier":"Cariaggi"},{"name":"WIND","count":"NM 2/54","composition":"90% Wool / 10% PBT","supplier":"Cariaggi"},{"name":"SURF","count":"NM 2/80","composition":"93% Wool / 7% PBT","supplier":"Cariaggi"},{"name":"PIUMA","count":"NM 3200","composition":"100% Cashmere","supplier":"Cariaggi"},{"name":"SUPERPIUMA","count":"NM 1100","composition":"100% Cashmere","supplier":"Cariaggi"},{"name":"PIUMINO","count":"NM 5000","composition":"100% Cashmere","supplier":"Cariaggi"},{"name":"TEDDY","count":"NM 3000","composition":"48% Cashmere / 32% Alpaca / 20% Silk","supplier":"Cariaggi"},{"name":"VOLUTA","count":"NM 2200","composition":"76% Cashmere / 24% Silk","supplier":"Cariaggi"},{"name":"WACKY","count":"NM 2800","composition":"53% Cashmere / 47% Silk + Paillettes","supplier":"Cariaggi"},{"name":"WAITAKI","count":"NM 2/52","composition":"70% Wool / 30% Silk","supplier":"Cariaggi"},{"name":"AURORA","count":"NM 2/26","composition":"100% Cashmere","supplier":"Consinee"},{"name":"CASHMERE TRADITION","count":"NM 2/26","composition":"100% Cashmere","supplier":"Consinee"},{"name":"ATLAS","count":"NM 2/26","composition":"100% Cashmere","supplier":"Consinee"},{"name":"ARAMIS","count":"NM 2/15","composition":"100% Cashmere","supplier":"Consinee"},{"name":"MINERVA","count":"NM 2/36","composition":"100% Cashmere","supplier":"Consinee"},{"name":"LUNA","count":"NM 2/48","composition":"100% Cashmere","supplier":"Consinee"},{"name":"HESTIA","count":"NM 2/26","composition":"70% Wool / 30% Cashmere","supplier":"Consinee"},{"name":"BABY CASHMERE","count":"NM 2/28","composition":"100% Cashmere","supplier":"Consinee"},{"name":"BOTANICA","count":"NM 2/26","composition":"100% Crown Cashmere","supplier":"Consinee"},{"name":"INTEGRO","count":"NM 2/26","composition":"100% Recycled Cashmere","supplier":"Consinee"},{"name":"VELLUTO","count":"NM 2/26","composition":"100% Brushed Cashmere","supplier":"Consinee"},{"name":"HELIA","count":"NM 2/15","composition":"100% Yak","supplier":"Consinee"},{"name":"AMARA","count":"NM 12","composition":"75% Cashmere / 25% Silk","supplier":"Top Line"},{"name":"AMARA MARL","count":"NM 12","composition":"75% Cashmere / 25% Silk","supplier":"Top Line"},{"name":"NIMBUS","count":"NM 5800","composition":"100% Cashmere","supplier":"Top Line"},{"name":"CASHFELT","count":"NM 8000","composition":"80% Cashmere / 18% PA / 2% Elastane","supplier":"Top Line"},{"name":"CASHSTAR","count":"NM 5500","composition":"56% Cashmere / 28% Cotton / 12% PA / 2% EA","supplier":"Top Line"},{"name":"BORA","count":"NM 5400","composition":"100% Cashmere","supplier":"Top Line"},{"name":"CAVAN","count":"NM 4000","composition":"100% Cashmere","supplier":"Top Line"},{"name":"CHERIE","count":"NM 3800","composition":"80% Cashmere / 20% Polyamide","supplier":"Top Line"},{"name":"DETTA","count":"NM 3000","composition":"100% Baby Alpaca","supplier":"Top Line"},{"name":"HONOR","count":"NM 2/16000","composition":"100% Royal Alpaca","supplier":"Top Line"}]);

  if (window.__KCC_V47_18_68_GERMAN_DATA_LOCK__) return;
  window.__KCC_V47_18_68_GERMAN_DATA_LOCK__ = true;

  const getThemeCfg = () =>
    window.KCC_CONFIG && typeof window.KCC_CONFIG === "object" ? window.KCC_CONFIG : {};
  const cfgFromTheme = getThemeCfg();

  const themeAi = (cfgFromTheme && cfgFromTheme.ai) || {};
  const WORKER_DEFAULT = "";
  const resolvedEndpoint = (themeAi && themeAi.endpoint) || WORKER_DEFAULT;
  const resolvedFallback =
    (themeAi && themeAi.fallbackEndpoint) || resolvedEndpoint || WORKER_DEFAULT;

  const uxHeader = (cfgFromTheme && cfgFromTheme.ux && cfgFromTheme.ux.header) || {};
  const KCI_OGL_LOGO = "https://cdn.shopify.com/s/files/1/0730/6231/8401/files/KCI_LOGO_7c07a619-9bd9-447c-8cbd-d825a4f28830.png?v=1769443572";
  const logoSrc = (uxHeader && uxHeader.logoSrc) || KCI_OGL_LOGO;
  const logoMaxH = Math.max(18, Math.min(30, Number(uxHeader && uxHeader.logoMaxH) || 24));

  const headerTitle = (uxHeader && (uxHeader.headerTitle || uxHeader.title)) || "KANCHAN CASHMERE";
  const headerSub = (uxHeader && (uxHeader.headerSub || uxHeader.subtitle)) || "Concierge";

  /* Always show close */
  const hideClose = false;

  /* HARD LOCK */
  const BUBBLE_LABEL_LOCK = "KCC";
  const BUBBLE_ROLE_LABELS = {
    buyer: "Buyer Concierge",
    d2c: "Collection Concierge",
    hybrid: "Private Concierge"
  };

  const CFG = Object.assign(
    {
      brand: "Kanchan Cashmere",
      bubbleText: BUBBLE_LABEL_LOCK,
      footerTagline:
        (cfgFromTheme && cfgFromTheme.footerTagline) ||
        "Kanchan Cashmere — Luxury with Integrity, Crafted in Nepal.",
      colors: {
        ink: "#2b211c",
        brand: "#2b211c",
        paper: "#ffffff",
        border: "#E6E0D8",
        wash: "#FAF7F2",
        accent: "#C6A564",
      },
      size: {
        maxW: (cfgFromTheme.ux && cfgFromTheme.ux.modalWidth) || 460,
        maxHvh: (cfgFromTheme.ux && cfgFromTheme.ux.modalHeightVh) || 96,
        sidePad: (cfgFromTheme.ux && cfgFromTheme.ux.bubbleOffset) || 14,
      },
      ux: {
        bubbleEnabled: cfgFromTheme.ux ? cfgFromTheme.ux.bubbleEnabled !== false : true,
        header: { logoSrc, logoMaxH, headerTitle, headerSub, hideClose },
      },
      ai: {
        enabled: themeAi ? themeAi.enabled !== false : true,
        endpoint: resolvedEndpoint,
        fallbackEndpoint: resolvedFallback,
        timeoutMs: (themeAi && themeAi.timeoutMs) || 20000,
      },
      page: (cfgFromTheme && cfgFromTheme.page) || {},
    },
    cfgFromTheme || {}
  );

  // Deep-merge nested UI configuration. A shallow top-level merge previously
  // replaced ux.header completely whenever theme.liquid supplied ux sizing.
  CFG.ux = Object.assign(
    {
      bubbleEnabled: cfgFromTheme.ux ? cfgFromTheme.ux.bubbleEnabled !== false : true,
      header: { logoSrc, logoMaxH, headerTitle, headerSub, hideClose },
    },
    (cfgFromTheme && cfgFromTheme.ux) || {}
  );
  CFG.ux.header = Object.assign(
    { logoSrc, logoMaxH, headerTitle, headerSub, hideClose },
    (cfgFromTheme && cfgFromTheme.ux && cfgFromTheme.ux.header) || {}
  );
  CFG.ux.header.logoSrc = CFG.ux.header.logoSrc || KCI_OGL_LOGO;
  CFG.ux.header.logoMaxH = Math.max(18, Math.min(30, Number(CFG.ux.header.logoMaxH) || 24));
  // V22 premium shell is intentionally consistent across Buyer, D2C and Hybrid modes.
  CFG.size = Object.assign({}, CFG.size || {}, { maxW: 460, maxHvh: 96, sidePad: 14 });

  try {
    CFG.bubbleText = BUBBLE_LABEL_LOCK;
  } catch (_) {}

  const FALLBACK = {
    polite: "Please share a little context and we’ll guide you precisely.",
    briefError:
      "Thank you — please share your brief (product, yarn direction, and target ship window), and we will guide the cleanest next step.",
    noEndpoint:
      "Thank you — the concierge connection is not configured yet. Please email info@kanchancashmere.com and we will assist promptly.",
  };

  function kccFallback(key) {
    if (!kccIsGerman()) return FALLBACK[key] || "";
    const de = {
      polite: "Bitte geben Sie uns etwas mehr Kontext, damit wir Sie präzise unterstützen können.",
      briefError: "Bitte senden Sie uns kurz Produkt, Garnrichtung und gewünschten Lieferzeitraum. Wir empfehlen anschließend den passenden nächsten Schritt.",
      noEndpoint: "Die Concierge-Verbindung ist derzeit nicht verfügbar. Bitte schreiben Sie an info@kanchancashmere.com."
    };
    return de[key] || FALLBACK[key] || "";
  }

  const $ = (s, r = document) => (r ? r.querySelector(s) : null);

  const escapeHtml = (str) =>
    String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  const nowISO = () => new Date().toISOString();

  function el(tag, cls, html) {
    const x = document.createElement(tag);
    if (cls) x.className = cls;
    if (html != null) x.innerHTML = html;
    return x;
  }

  function addStyle(cssText) {
    const st = document.createElement("style");
    st.setAttribute("data-kcc-style", "v47.18.68");
    st.textContent = cssText;
    document.head.appendChild(st);
    return st;
  }

  /* ============================================================================ */
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const raceTimeout = (p, ms) =>
    Promise.race([p, new Promise((r) => setTimeout(() => r("timeout"), ms))]);

  async function kccReadyGate() {
    // Keep this extremely light (mobile-safe)
    try {
      if (document && document.fonts && document.fonts.ready) {
        await raceTimeout(document.fonts.ready, 160);
      } else {
        await wait(24);
      }
    } catch (_) {}
    await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
  }

  // Scroll Lock v3: modal lock on mobile only. Desktop remains independently scrollable.
  const __KCC_SCROLL__ = {
    locked: false,
    htmlOv: "",
    bodyOv: "",
    htmlOverscroll: "",
    bodyOverscroll: ""
  };
  function shouldLockPageScroll() {
    try {
      return !!(window.matchMedia && window.matchMedia("(max-width: 767px)").matches);
    } catch (_) {
      return (window.innerWidth || 0) <= 767;
    }
  }
  function lockScroll() {
    if (!shouldLockPageScroll()) return;
    if (__KCC_SCROLL__.locked) return;
    __KCC_SCROLL__.locked = true;
    try {
      __KCC_SCROLL__.htmlOv = document.documentElement.style.overflow || "";
      __KCC_SCROLL__.bodyOv = document.body.style.overflow || "";
      __KCC_SCROLL__.htmlOverscroll = document.documentElement.style.overscrollBehavior || "";
      __KCC_SCROLL__.bodyOverscroll = document.body.style.overscrollBehavior || "";
    } catch (_) {}
    try {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      document.documentElement.style.overscrollBehavior = "none";
      document.body.style.overscrollBehavior = "none";
    } catch (_) {}
  }
  function unlockScroll() {
    if (!__KCC_SCROLL__.locked) return;
    __KCC_SCROLL__.locked = false;
    try {
      document.documentElement.style.overflow = __KCC_SCROLL__.htmlOv || "";
      document.body.style.overflow = __KCC_SCROLL__.bodyOv || "";
      document.documentElement.style.overscrollBehavior = __KCC_SCROLL__.htmlOverscroll || "";
      document.body.style.overscrollBehavior = __KCC_SCROLL__.bodyOverscroll || "";
    } catch (_) {}
  }

  // Compatibility release for obsolete theme-level KCC locks. This touches
  // KCC-specific classes only and therefore does not unlock menus or drawers.
  function releaseLegacyKccScrollLock() {
    try {
      const html = document.documentElement;
      const body = document.body;
      if (!html || !body) return;

      const legacyClasses = ["kci-kcc-scroll-locked", "kcc-scroll-locked", "kcc-lock"];
      const legacyLocked = legacyClasses.some((name) =>
        html.classList.contains(name) || body.classList.contains(name)
      );

      if (!legacyLocked) return;

      let restoreY = 0;
      const bodyTop = body.style.top || "";
      if (body.style.position === "fixed" && /^-?\d+px$/.test(bodyTop)) {
        restoreY = Math.abs(parseInt(bodyTop, 10)) || 0;
      }

      legacyClasses.forEach((name) => {
        html.classList.remove(name);
        body.classList.remove(name);
      });

      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      body.style.paddingRight = "";

      if (restoreY > 0) {
        requestAnimationFrame(() => {
          try { window.scrollTo(0, restoreY); } catch (_) {}
        });
      }
    } catch (_) {}
  }

  // LUX micro status (delayed "Connecting…", no "Ready")
  const __KCC_NET__ = { state: "idle", showTo: null, delayMs: 450 };
  function setNetState(state) {
    __KCC_NET__.state = state;
    const elNet = document.querySelector("[data-kcc-net]");
    if (!elNet) return;
    if (state === "idle") {
      elNet.textContent = "";
      elNet.style.display = "none";
      return;
    }
    elNet.style.display = "inline-flex";
    elNet.textContent = state === "connecting" ? kccCopy("Connecting…", "Verbindung wird hergestellt …") : kccCopy("Offline", "Offline");
  }
  function netBegin() {
    try {
      if (__KCC_NET__.showTo) clearTimeout(__KCC_NET__.showTo);
    } catch (_) {}
    __KCC_NET__.showTo = setTimeout(() => {
      if (__KCC_NET__.state !== "error") setNetState("connecting");
    }, __KCC_NET__.delayMs);
  }
  function netSuccess() {
    try {
      if (__KCC_NET__.showTo) clearTimeout(__KCC_NET__.showTo);
    } catch (_) {}
    __KCC_NET__.showTo = null;
    setNetState("idle");
  }
  function netFail() {
    try {
      if (__KCC_NET__.showTo) clearTimeout(__KCC_NET__.showTo);
    } catch (_) {}
    __KCC_NET__.showTo = null;
    setNetState("error");
  }

  function installKccComposerLocaleGuard() {
    try {
      if (!panel || panel.dataset.kccComposerLocaleGuard === "1" || !kccIsGerman()) return;
      panel.dataset.kccComposerLocaleGuard = "1";
      ["focusin", "click"].forEach((evt) => {
        panel.addEventListener(evt, () => lockKccComposerLocale(), true);
      });
      lockKccComposerLocale();
    } catch (_) {}
  }

  function installKccGermanUiObserver() {
    try {
      if (!panel || panel.dataset.kccDeObserver === "1" || !kccIsGerman()) return;
      panel.dataset.kccDeObserver = "1";
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node && node.nodeType === 1) {
              translateKccUi(node);
              enforceLocalizedKccLinks(node);
            } else if (node && node.parentElement) {
              translateKccUi(node.parentElement);
            }
          });
        });
      });
      observer.observe(panel, { childList: true, subtree: true });
    } catch (_) {}
  }

  function installLocaleNavigationGuard() {
    try {
      if (!panel || panel.dataset.kccLocaleGuard === "1") return;
      panel.dataset.kccLocaleGuard = "1";
      panel.addEventListener("click", (event) => {
        const a = event.target && event.target.closest ? event.target.closest("a[href]") : null;
        if (!a || !panel.contains(a)) return;
        const href = a.getAttribute("href") || "";
        const localized = localizedInternalHref(href);
        if (localized && localized !== href) a.setAttribute("href", localized);
      }, true);
    } catch (_) {}
  }

  function hookHistory(onChange) {
    if (window.__KCC_HISTORY_HOOKED__) return;
    window.__KCC_HISTORY_HOOKED__ = true;
    try {
      const _push = history.pushState;
      const _replace = history.replaceState;

      history.pushState = function () {
        const ret = _push.apply(this, arguments);
        try { onChange(); } catch (_) {}
        return ret;
      };

      history.replaceState = function () {
        const ret = _replace.apply(this, arguments);
        try { onChange(); } catch (_) {}
        return ret;
      };

      window.addEventListener("popstate", () => { try { onChange(); } catch (_) {} }, { passive: true });
    } catch (_) {}
  }

  const __KCC_CLARITY_SEEN__ = new Set();
  function trackKccEvent(eventName, onceKey) {
    try {
      const key = onceKey || "";
      if (key && __KCC_CLARITY_SEEN__.has(key)) return;
      if (key) __KCC_CLARITY_SEEN__.add(key);
      if (typeof window.clarity === "function") window.clarity("event", `KCC ${eventName}`);
    } catch (_) {}
  }

  addStyle(`
:root{
  --kcc-ink:#241c18;
  --kcc-paper:#fdfbf8;
  --kcc-border:#e6ddd2;
  --kcc-wash:#faf6f0;
  --kcc-accent:#b99662;
}

#kcc-ui-hook{
  position: fixed !important;
  z-index: 2147483647 !important;
  left: 0 !important;
  top: 0 !important;
  width: 0 !important;
  height: 0 !important;

  /* IMPORTANT: keep interactive for fixed children across themes */
  pointer-events: auto !important;

  opacity: 0 !important;
  visibility: hidden !important;
}
#kcc-ui-hook[data-kcc-mounted="1"]{
  opacity: 1 !important;
  visibility: visible !important;
}
#kcc-ui-hook:not([data-kcc-mounted="1"]),
#kcc-ui-hook[hidden]{
  display:none !important;
}

#kcc-bubble[data-kcc-hidden="1"]{
  display:none !important;
  visibility:hidden !important;
  opacity:0 !important;
  pointer-events:none !important;
}

/* default bubble: hidden until JS reveals on scroll */
#kcc-bubble{
  pointer-events:auto !important;
  position:fixed !important;
  z-index:2147483647 !important;
  right:calc(${CFG.size.sidePad}px + env(safe-area-inset-right, 0px)) !important;
  bottom:calc(${CFG.size.sidePad}px + env(safe-area-inset-bottom, 0px)) !important;
  width:224px;height:52px;min-width:224px;min-height:52px;border-radius:999px;
  border:1px solid rgba(43,33,28,.16);
  background:#fff;cursor:pointer;padding:5px 17px 5px 5px;overflow:hidden;
  transform:none !important; translate:none !important; margin:0 !important;
  box-shadow:0 8px 24px rgba(43,33,28,.13) !important;
  appearance:none !important;-webkit-appearance:none !important;
  background-image:none !important;text-indent:0 !important;line-height:1 !important;

  display:none !important;
  visibility:hidden !important;
  opacity:0 !important;
  pointer-events:none !important;
}
#kcc-bubble *{ box-sizing:border-box; }
#kcc-bubble::before,
#kcc-bubble::after,
#kcc-bubble *::before,
#kcc-bubble *::after{
  content:none !important;
  display:none !important;
  visibility:hidden !important;
}
.kcc-triggerInner{
  display:flex;align-items:center;justify-content:flex-start;gap:11px;
  width:100%;height:100%;white-space:nowrap;pointer-events:none;
}
.kcc-triggerMark{
  display:flex;align-items:center;justify-content:center;flex:0 0 40px;
  width:40px;height:40px;border-radius:999px;background:var(--kcc-ink);color:#fff;
  font:750 11px/1 ui-serif,"Cormorant Garamond","Garamond",Georgia,serif;
  letter-spacing:.07em;
}
.kcc-triggerCta{
  display:block;min-width:0;text-align:left;
  font:600 13.5px/1 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  letter-spacing:.005em;color:rgba(43,33,28,.90);
}


#kcc-panel{
  pointer-events:auto !important;
  position:fixed !important;
  z-index:2147483646 !important;
  right:calc(${CFG.size.sidePad}px + env(safe-area-inset-right, 0px)) !important;
  bottom:calc(${CFG.size.sidePad}px + env(safe-area-inset-bottom, 0px)) !important;
  width:min(${CFG.size.maxW}px, calc(100vw - ${CFG.size.sidePad * 2}px));
  height:min(${CFG.size.maxHvh}vh, 860px);
  max-height:calc(100svh - 28px);
  display:none !important; visibility:hidden !important; opacity:0 !important;
  flex-direction:column; overflow:hidden;
  background:var(--kcc-paper);border:1px solid var(--kcc-border);border-radius:16px;

  /* premium float (subtle) */
  box-shadow:0 20px 52px rgba(36,28,24,.11) !important;

  transform:none !important; translate:none !important; margin:0 !important;
}
#kcc-panel.open{
  display:flex !important;
  visibility:visible !important;
  opacity:1 !important;
}

.kcc-head{
  padding:12px 15px 11px;
  background:var(--kcc-paper);
  border-bottom:1px solid var(--kcc-border);
  position:relative;
}
.kcc-head::after{
  content:"";
  position:absolute;left:0;right:0;bottom:-1px;height:1px;
  background: color-mix(in srgb, var(--kcc-accent) 55%, transparent);
  opacity:.65;pointer-events:none;
}
.kcc-row{ display:grid; grid-template-columns:auto 1fr auto; align-items:center; column-gap:12px; }
.kcc-left{ justify-self:start; display:flex; align-items:center; gap:10px; min-width:0; }
.kcc-logoWrap{
  width:${logoMaxH + 4}px;height:${logoMaxH + 4}px;min-width:${logoMaxH + 4}px;
  display:flex;align-items:center;justify-content:center;overflow:hidden;
}
.kcc-logo{
  width:auto !important;height:auto !important;
  max-width:${logoMaxH}px !important;max-height:${logoMaxH}px !important;
  object-fit:contain !important;display:block !important;margin:0 !important;
}
.kcc-mark{
  width:34px;height:34px;border-radius:999px;display:flex;align-items:center;justify-content:center;
  border:1px solid color-mix(in srgb, var(--kcc-accent) 68%, var(--kcc-border));
  background:#fff;color:var(--kcc-ink);
  font:800 14px ui-serif,"Cormorant Garamond","Garamond",Georgia,serif;letter-spacing:.02em;
}
.kcc-center{ justify-self:stretch; min-width:0; display:flex; flex-direction:column; align-items:flex-start; text-align:left; line-height:1.05; }
.kcc-title{
  font:700 12px/1 ui-serif,"Cormorant Garamond","Garamond",Georgia,serif;
  letter-spacing:.16em;text-transform:uppercase;color:var(--kcc-ink);
  white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;
}
.kcc-sub{
  margin-top:6px;
  font:500 11.5px/1 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  letter-spacing:.02em;color:rgba(43,33,28,.66);
  white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;
}
.kcc-cue{
  display:none !important;
}
.kccH__meta{
  display:flex;justify-content:flex-start;gap:8px;padding-top:0;
}
.kccP [data-kcc-net]{
  display:inline-flex;
  align-items:center;
  gap:6px;
  font-size:11px;
  letter-spacing:.08em;
  text-transform:uppercase;
  padding:3px 8px;
  border:1px solid rgba(0,0,0,.14);
  border-radius:999px;
  background:transparent;
  color:rgba(0,0,0,.72);
  line-height:1;
  white-space:nowrap;
}
.kccP [data-kcc-net]{ display:none; }

.kcc-right{ justify-self:end; display:flex;align-items:center;justify-content:flex-end;gap:2px;min-height:28px; }
.kcc-headAction{
  width:30px !important;height:30px !important;min-width:30px !important;min-height:30px !important;
  display:flex !important;align-items:center !important;justify-content:center !important;
  padding:0 !important;margin:0 !important;border:0 !important;border-radius:999px !important;
  background:transparent !important;color:var(--kcc-ink) !important;box-shadow:none !important;
  text-decoration:none !important;cursor:pointer !important;appearance:none !important;
}
.kcc-headAction:hover{ background:var(--kcc-wash) !important; }
.kcc-headAction svg{ width:17px !important;height:17px !important;display:block !important;stroke:currentColor !important; }
#kcc-panel:not([data-kcc-role="d2c"]) [data-kcc-cart]{ display:none !important; }
#kcc-panel .kcc-close{
  width:32px !important;height:32px !important;min-width:32px !important;min-height:32px !important;
  border:0 !important;background:transparent !important;background-image:none !important;
  box-shadow:none !important;border-radius:0 !important;padding:0 !important;margin:0 !important;
  cursor:pointer !important;display:flex !important;align-items:center !important;justify-content:center !important;
  outline:none !important;text-indent:0 !important;letter-spacing:0 !important;
  -webkit-text-fill-color:var(--kcc-ink) !important;color:var(--kcc-ink) !important;opacity:.90 !important;
  -webkit-appearance:none !important;appearance:none !important;filter:none !important;transform:none !important;
  mask:none !important;-webkit-mask:none !important;
}
#kcc-panel .kcc-close::before,
#kcc-panel .kcc-close::after{ content:none !important; display:none !important; }
#kcc-panel .kcc-close svg,
#kcc-panel .kcc-close img,
#kcc-panel .kcc-close i{ display:none !important; visibility:hidden !important; opacity:0 !important; }
#kcc-panel .kcc-close .kcc-x{
  display:block !important;visibility:visible !important;opacity:1 !important;
  font:600 22px/1 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif !important;
  color:var(--kcc-ink) !important;transform:translateY(-1px) !important;pointer-events:none !important;
}
#kcc-panel .kcc-close:hover{ opacity:1 !important; }

.kcc-body{ flex:1; min-height:0; display:flex; flex-direction:column; background:var(--kcc-paper); }
.kcc-scroll{
  flex:1; min-height:0 !important;
  overflow-y:auto !important; overflow-x:hidden !important;
  padding:14px 16px 12px; background:var(--kcc-paper);
  overflow-anchor:none; overscroll-behavior-y:contain !important;
  touch-action:pan-y !important; scrollbar-gutter:stable;
  -webkit-overflow-scrolling:touch;
}
#kcc-panel[data-kcc-role="d2c"] .kcc-scroll{
  background:linear-gradient(180deg,#fff 0%,#fff 72%,#fcfaf6 100%);
}
#kcc-panel[data-kcc-role="d2c"] .kcc-head{
  background:#fdfbf7;
}
#kcc-panel[data-kcc-role="d2c"] .kcc-sub{
  color:color-mix(in srgb,var(--kcc-accent) 72%,var(--kcc-ink));
}
#kcc-panel[data-kcc-role="d2c"] .kcc-prompts{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:6px;
  overflow:visible;
  padding:1px 0 0;
}
#kcc-panel[data-kcc-role="d2c"] .kcc-prompts::-webkit-scrollbar{ display:none; }
#kcc-panel[data-kcc-role="d2c"] .kcc-prompts span,
#kcc-panel[data-kcc-role="d2c"] .kcc-prompts a{
  min-width:0;
  min-height:32px !important;
  padding:6px 12px !important;
  white-space:normal;
}
.kcc-msg{
  display:block !important;width:100% !important;max-width:100% !important;
  border:0 !important;border-left:1px solid color-mix(in srgb, var(--kcc-accent) 62%, transparent) !important;
  background:transparent !important;border-radius:0 !important;
  padding:3px 0 3px 15px !important;margin:16px 0 !important;
  box-shadow:none !important;opacity:0;animation:kccFade .18s ease forwards;
}
.kcc-msg.kcc-greeting{
  width:100% !important;max-width:100% !important;
  border:0 !important;
  border-left:1px solid color-mix(in srgb, var(--kcc-accent) 62%, transparent) !important;
  background:transparent !important;border-radius:0 !important;
  padding:2px 0 2px 13px !important;margin:1px 0 10px !important;
}
@keyframes kccFade{ from{opacity:0;transform:translateY(4px)} to{opacity:1;transform:none} }
.kcc-msg div{
  font-family:ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  font-size:14px; font-weight:430; line-height:1.5; color:var(--kcc-ink);
}
#kcc-panel .kcc-msg > div{
  margin:0 !important;padding:0 !important;border:0 !important;border-radius:0 !important;
  background:transparent !important;box-shadow:none !important;
}
.kcc-contextReply{ display:block; }
.kcc-contextParagraph{
  margin:0 0 11px !important;
  padding:0 !important;
  font:430 14px/1.56 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif !important;
  color:var(--kcc-ink) !important;
}
.kcc-contextParagraph:last-child{ margin-bottom:0 !important; }
.kcc-userline{
  display:block !important;width:100% !important;max-width:100% !important;
  margin:22px 0 10px !important;padding:0 0 9px !important;
  border:0 !important;border-bottom:1px solid color-mix(in srgb, var(--kcc-accent) 45%, transparent) !important;
  border-radius:0 !important;background:transparent !important;box-shadow:none !important;
  font:700 12px/1.45 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif !important;
  letter-spacing:.085em !important;text-transform:uppercase !important;
  color:var(--kcc-ink) !important;text-align:left !important;
}

/* premium divider + prompts (greeting) */
.kcc-divider{
  width:38px;height:1px;
  background:var(--kcc-accent);
  margin:8px 0 8px;
  opacity:.52;
}
.kcc-prompts{
  margin-top:1px;display:grid;grid-template-columns:1fr 1fr;gap:6px;
}
.kcc-prompts span,
.kcc-prompts a{
  display:flex !important;align-items:center !important;justify-content:center !important;
  min-height:32px !important;padding:6px 11px !important;
  border:1px solid color-mix(in srgb, var(--kcc-accent) 62%, var(--kcc-border)) !important;
  border-radius:999px !important;background:transparent !important;box-shadow:none !important;
  font:600 11.5px/1.25 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif !important;
  letter-spacing:.035em !important;color:rgba(43,33,28,.88) !important;
  text-align:center !important;cursor:pointer;text-decoration:none !important;
}
.kcc-prompts span:hover,
.kcc-prompts a:hover{
  border-color:var(--kcc-accent) !important;background:var(--kcc-wash) !important;color:var(--kcc-ink) !important;
}

.kcc-cardWrap{
  margin:10px 0 14px;
  display:grid;
  gap:10px;
}
.kcc-showcase{
  margin:10px 0 5px;
  padding-top:10px;
  border-top:1px solid color-mix(in srgb,var(--kcc-accent) 48%,var(--kcc-border));
}
.kcc-showcaseEyebrow{
  margin:0 0 3px;
  font:650 10.5px/1.2 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  letter-spacing:.13em;text-transform:uppercase;color:rgba(43,33,28,.58);
}
.kcc-showcaseTitle{
  margin:0 0 3px;
  font:500 18px/1.2 ui-serif,"Cormorant Garamond","Garamond",Georgia,serif;
  letter-spacing:.01em;color:var(--kcc-ink);
}
.kcc-showcaseText{
  margin:0 0 6px;
  font:430 12px/1.4 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  color:rgba(43,33,28,.72);
}
.kcc-collectionRail{
  display:flex;
  gap:9px;
  margin:8px -1px 4px;
  padding:0 1px 3px;
  overflow-x:auto;
  overscroll-behavior-x:contain;
  scroll-snap-type:x mandatory;
  scrollbar-width:none !important;
  -ms-overflow-style:none !important;
  overflow-y:hidden !important;
  -webkit-overflow-scrolling:touch;
}
.kcc-collectionRail::-webkit-scrollbar{ display:none !important;width:0 !important;height:0 !important; }
.kcc-collectionTile{
  flex:0 0 clamp(102px,30.5%,120px);
  color:inherit;text-decoration:none;
  scroll-snap-align:start;
}
.kcc-collectionImage{
  width:100%;aspect-ratio:1/1.12;overflow:hidden;border-radius:11px;
  background:#f4f0e9;
}
.kcc-collectionImage img{
  width:100%;height:100%;display:block;object-fit:cover;
  transition:transform .28s ease;
}
.kcc-collectionTile:hover .kcc-collectionImage img{ transform:scale(1.018); }
.kcc-collectionName{
  margin-top:5px;
  font:600 11.5px/1.25 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  letter-spacing:.015em;color:var(--kcc-ink);
}
.kcc-contextRail{
  display:flex;gap:9px;margin:8px -1px 4px;padding:0 1px 3px;
  overflow-x:auto;overscroll-behavior-x:contain;scroll-snap-type:x mandatory;
  scrollbar-width:none !important;-ms-overflow-style:none !important;
  overflow-y:hidden !important;-webkit-overflow-scrolling:touch;
}
.kcc-contextRail::-webkit-scrollbar{ display:none !important;width:0 !important;height:0 !important; }
.kcc-contextTile{
  flex:0 0 clamp(102px,30.5%,120px);color:inherit;text-decoration:none;
  scroll-snap-align:start;min-width:0;
}
.kcc-contextImage{
  width:100%;aspect-ratio:1/1.12;overflow:hidden;border-radius:11px;background:#f4f0e9;
}
.kcc-contextImage img{ width:100%;height:100%;display:block;object-fit:cover;transition:transform .28s ease; }
.kcc-contextTile:hover .kcc-contextImage img{ transform:scale(1.018); }
.kcc-contextName{
  margin:5px 0 0;font:600 11.2px/1.25 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  color:var(--kcc-ink);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;
}
.kcc-contextMeta{
  min-height:13px;margin-top:2px;font:500 10.5px/1.25 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  color:rgba(43,33,28,.64);
}
.kcc-railShell{ position:relative; }
.kcc-railNav{
  position:absolute;z-index:3;top:50%;transform:translateY(-58%);
  width:28px !important;height:28px !important;min-width:28px !important;min-height:28px !important;
  display:flex !important;align-items:center !important;justify-content:center !important;
  padding:0 !important;margin:0 !important;border-radius:999px !important;
  border:1px solid color-mix(in srgb,var(--kcc-accent) 55%,var(--kcc-border)) !important;
  background:rgba(255,253,250,.94) !important;color:var(--kcc-ink) !important;
  box-shadow:0 5px 16px rgba(43,33,28,.10) !important;cursor:pointer !important;
  font:500 19px/1 ui-serif,Georgia,serif !important;opacity:0;transition:opacity .2s ease,transform .2s ease;
}
.kcc-railShell:hover .kcc-railNav,.kcc-railShell:focus-within .kcc-railNav{ opacity:1; }
.kcc-railNav[data-kcc-prev]{ left:-5px; }
.kcc-railNav[data-kcc-next]{ right:-5px; }
.kcc-railNav[hidden],.kcc-railNav:disabled{ display:none !important; }
@media (hover:none){ .kcc-railNav{ opacity:.92; } }
.kcc-currentPiece{
  display:grid;grid-template-columns:88px 1fr;gap:12px;align-items:center;
  margin:7px 0 10px;padding:0;color:inherit;text-decoration:none;
}
.kcc-currentPieceImage{
  width:88px;height:108px;overflow:hidden;border-radius:11px;background:#f4f0e9;
}
.kcc-currentPieceImage img{ width:100%;height:100%;display:block;object-fit:cover;transition:transform .3s ease; }
.kcc-currentPiece:hover .kcc-currentPieceImage img{ transform:scale(1.018); }
.kcc-currentPieceTitle{
  font:600 14px/1.3 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;color:var(--kcc-ink);
}
.kcc-currentPiecePrice{ margin-top:5px;font:500 12px/1.3 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;color:rgba(43,33,28,.66); }
.kcc-currentPieceCta{ margin-top:9px;font:700 10.5px/1 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;letter-spacing:.08em;text-transform:uppercase; }
.kcc-relatedLabel{ margin:5px 0 2px;font:650 10px/1.2 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;letter-spacing:.13em;text-transform:uppercase;color:rgba(43,33,28,.58); }
@keyframes kccEditorialReveal{ from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:none} }
.kcc-showcase.kcc-is-ready .kcc-currentPiece,
.kcc-showcase.kcc-is-ready .kcc-collectionTile,
.kcc-showcase.kcc-is-ready .kcc-contextTile{ opacity:0;animation:kccEditorialReveal .38s cubic-bezier(.22,.61,.36,1) forwards; }
.kcc-showcase.kcc-is-ready :is(.kcc-collectionTile,.kcc-contextTile):nth-child(2){animation-delay:.07s}
.kcc-showcase.kcc-is-ready :is(.kcc-collectionTile,.kcc-contextTile):nth-child(3){animation-delay:.14s}
.kcc-showcase.kcc-is-ready :is(.kcc-collectionTile,.kcc-contextTile):nth-child(4){animation-delay:.21s}
.kcc-showcase.kcc-is-ready :is(.kcc-collectionTile,.kcc-contextTile):nth-child(n+5){animation-delay:.28s}
.kcc-card{
  display:grid;
  grid-template-columns:72px 1fr;
  gap:12px;
  align-items:start;
  padding:12px 0 14px;
  border:0;
  border-bottom:1px solid var(--kcc-border);
  border-radius:0;
  background:transparent;
  text-decoration:none;
  color:inherit;
  box-shadow:none !important;
}
.kcc-card:hover{
  border-color:var(--kcc-accent);
}
.kcc-cardImg{
  width:72px;
  height:88px;
  border-radius:8px;
  overflow:hidden;
  background:var(--kcc-wash);
  border:0;
}
.kcc-cardImg img{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}
.kcc-cardBody{
  min-width:0;
}
.kcc-cardTitle{
  font:650 14px/1.35 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  color:var(--kcc-ink);
  margin:0 0 4px;
}
.kcc-cardMeta{
  font:500 12.5px/1.5 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  color:rgba(43,33,28,.72);
  margin:0 0 6px;
}
.kcc-cardPrice{
  font:700 12.5px/1 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  color:var(--kcc-ink);
  letter-spacing:.02em;
}
.kcc-cardSpec{
  font:600 12px/1.45 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  color:rgba(43,33,28,.76);
  margin:0 0 4px;
}
.kcc-cardCta{
  margin-top:6px;
  display:inline-flex;
  align-items:center;
  gap:6px;
  font:700 11.5px/1 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  letter-spacing:.08em;
  text-transform:uppercase;
  color:rgba(43,33,28,.80);
}
#kcc-panel[data-kcc-role="d2c"] .kcc-cardWrap{
  grid-template-columns:1fr 1fr;
  gap:12px;
  margin:16px 0 18px;
}
#kcc-panel[data-kcc-role="d2c"] .kcc-card{
  display:flex;
  flex-direction:column;
  gap:0;
  padding:0 0 13px;
  border:0;
  border-bottom:1px solid color-mix(in srgb,var(--kcc-accent) 48%,var(--kcc-border));
}
#kcc-panel[data-kcc-role="d2c"] .kcc-cardImg{
  width:100%;
  height:auto;
  aspect-ratio:4/5;
  border-radius:12px;
  margin-bottom:11px;
  background:#f5f1eb;
}
#kcc-panel[data-kcc-role="d2c"] .kcc-cardBody{ width:100%; }
#kcc-panel[data-kcc-role="d2c"] .kcc-cardTitle{
  font:600 13.5px/1.35 ui-serif,"Cormorant Garamond","Garamond",Georgia,serif;
  letter-spacing:.015em;
  min-height:36px;
}
#kcc-panel[data-kcc-role="d2c"] .kcc-cardMeta{
  font-size:11.5px;
  min-height:18px;
}
#kcc-panel[data-kcc-role="d2c"] .kcc-cardPrice{
  font-size:12px;
  margin-top:4px;
}
#kcc-panel[data-kcc-role="d2c"] .kcc-cardCta{
  margin-top:10px;
  color:var(--kcc-ink);
}
.kcc-collectionCta{
  margin:4px 0 6px;
  display:inline-flex;
  align-items:center;
  gap:6px;
  font:700 11.5px/1 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  letter-spacing:.08em;
  text-transform:uppercase;
  color:var(--kcc-ink);
  text-decoration:none;
}
.kcc-collectionCta:hover{
  color: color-mix(in srgb, var(--kcc-accent) 72%, var(--kcc-ink));
}
.kcc-promptRow{
  display:flex;
  flex-wrap:wrap;
  gap:8px;
  margin:10px 0 0;
}
.kcc-promptChip{
  display:inline-flex;
  align-items:center;
  min-height:34px;
  padding:0 13px;
  border-radius:999px;
  border:1px solid color-mix(in srgb, var(--kcc-accent) 62%, rgba(43,33,28,.16));
  background:transparent;
  font:600 11px/1 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  letter-spacing:.055em;
  color:rgba(43,33,28,.82);
  cursor:pointer;
}
.kcc-promptChip:hover{
  border-color:var(--kcc-accent);background:var(--kcc-wash);
  color:var(--kcc-ink);
}

.kcc-compose{
  display:flex;
  gap:8px;
  padding:8px 10px;
  border-top:1px solid var(--kcc-border);
  background:var(--kcc-paper);
}
.kcc-input{
  flex:1;
  height:44px;
  border-radius:10px;
  border:1px solid rgba(43,33,28,.22);
  background:#fffdfa;
  padding:0 13px;
  font:500 13.5px/1 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  color:var(--kcc-ink);
  outline:none;
  box-shadow:none !important;
}
.kcc-input::placeholder{ color:rgba(43,33,28,.48); }
.kcc-input:focus{
  border-color: color-mix(in srgb, var(--kcc-accent) 55%, rgba(43,33,28,.22));
  box-shadow:none !important;
}
#kcc-panel #kcc-send.kcc-send{
  flex:0 0 60px !important;
  width:60px !important;min-width:60px !important;height:44px !important;
  padding:0 7px !important;
  border-radius:10px !important;
  border:1px solid rgba(43,33,28,.92) !important;
  background:rgba(43,33,28,.92) !important;
  color:#fff !important;
  font:700 10.5px/1 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif !important;
  letter-spacing:.08em !important;
  text-transform:uppercase !important;
  opacity:1 !important;
  visibility:visible !important;
  -webkit-text-fill-color:#fff !important;
}
#kcc-panel #kcc-send.kcc-send:hover{ border-color:var(--kcc-accent) !important; }

.kcc-foot{
  padding:6px 12px 7px;
  border-top:1px solid var(--kcc-border);
  background:var(--kcc-wash);
  color:rgba(43,33,28,.58);
  font:550 10.5px/1.4 ui-sans-serif,system-ui,-apple-system,"Inter",Arial,sans-serif;
  letter-spacing:.08em;text-transform:uppercase;
  text-align:center;
}
@media (max-width:767px){
  #kcc-bubble{
    width:52px !important;height:52px !important;
    min-width:52px !important;min-height:52px !important;
    padding:5px !important;background:#fff !important;
  }
  .kcc-triggerCta{ display:none !important; }
  .kcc-triggerMark{ width:40px;height:40px;flex-basis:40px;font-size:11px;letter-spacing:.05em; }

  /* MOBILE WIDTH LOCK — prevents theme/input/grid rules from widening KCC beyond viewport */
  #kcc-panel{
    left:12px !important;right:12px !important;bottom:12px !important;
    width:calc(100vw - 24px) !important;
    max-width:calc(100vw - 24px) !important;
    min-width:0 !important;
    height:calc(100svh - 24px) !important;max-height:none !important;
    border-radius:16px !important;
    box-sizing:border-box !important;
    overflow:hidden !important;
  }
  #kcc-panel,
  #kcc-panel *{ box-sizing:border-box !important; }
  #kcc-panel .kcc-head,
  #kcc-panel .kcc-body,
  #kcc-panel .kcc-scroll,
  #kcc-panel .kcc-compose,
  #kcc-panel .kcc-foot,
  #kcc-panel .kcc-row,
  #kcc-panel .kcc-center,
  #kcc-panel .kcc-msg,
  #kcc-panel .kcc-userline,
  #kcc-panel .kcc-contextReply,
  #kcc-panel .kcc-showcase,
  #kcc-panel .kcc-cardWrap,
  #kcc-panel .kcc-cardBody,
  #kcc-panel .kcc-prompts{
    width:100% !important;
    max-width:100% !important;
    min-width:0 !important;
  }
  #kcc-panel .kcc-body{ overflow:hidden !important; }
  #kcc-panel .kcc-scroll{
    padding:12px 13px 10px;
    overflow-x:hidden !important;
    max-width:100% !important;
  }
  #kcc-panel .kcc-row{
    grid-template-columns:auto minmax(0,1fr) auto !important;
  }
  #kcc-panel .kcc-left,
  #kcc-panel .kcc-right,
  #kcc-panel .kcc-center{ min-width:0 !important; }
  #kcc-panel .kcc-title,
  #kcc-panel .kcc-sub{
    max-width:100% !important;
    min-width:0 !important;
  }

  /* Prompt/action buttons must stay inside the mobile sheet */
  #kcc-panel .kcc-prompts,
  #kcc-panel[data-kcc-role="d2c"] .kcc-prompts{
    grid-template-columns:minmax(0,1fr) minmax(0,1fr) !important;
    gap:7px !important;
    overflow:visible !important;
  }
  #kcc-panel .kcc-prompts span,
  #kcc-panel .kcc-prompts a,
  #kcc-panel[data-kcc-role="d2c"] .kcc-prompts span,
  #kcc-panel[data-kcc-role="d2c"] .kcc-prompts a{
    width:100% !important;
    max-width:100% !important;
    min-width:0 !important;
    white-space:normal !important;
    overflow-wrap:anywhere !important;
  }

  /* Conversation text wraps instead of creating intrinsic horizontal width */
  #kcc-panel .kcc-msg,
  #kcc-panel .kcc-msg > div,
  #kcc-panel .kcc-msg div,
  #kcc-panel .kcc-contextParagraph,
  #kcc-panel .kcc-userline{
    max-width:100% !important;
    min-width:0 !important;
    white-space:normal !important;
    overflow-wrap:anywhere !important;
    word-break:normal !important;
  }

  /* Composer: input flexes down; Send remains fully visible */
  #kcc-panel .kcc-compose{
    display:flex !important;
    align-items:center !important;
    gap:7px !important;
    padding:8px 10px !important;
    overflow:hidden !important;
  }
  #kcc-panel .kcc-input{
    flex:1 1 0 !important;
    width:0 !important;
    min-width:0 !important;
    max-width:none !important;
  }
  #kcc-panel #kcc-send.kcc-send{
    flex:0 0 58px !important;
    width:58px !important;
    min-width:58px !important;
    max-width:58px !important;
    margin:0 !important;
  }
  #kcc-panel .kcc-foot{
    padding-left:10px !important;
    padding-right:10px !important;
    white-space:normal !important;
    overflow-wrap:anywhere !important;
  }

  /* Keep intentional product/swatch rails horizontally scrollable inside KCC only */
  #kcc-panel .kcc-collectionRail,
  #kcc-panel .kcc-contextRail{
    max-width:100% !important;
    min-width:0 !important;
  }
}
@media (max-width:420px){
  .kcc-title,.kcc-sub{ max-width:200px; }
  .kcc-cue{ display:none; }
  .kcc-prompts{ grid-template-columns:1fr 1fr; }
  #kcc-panel[data-kcc-role="d2c"] .kcc-cardWrap{ grid-template-columns:1fr 1fr;gap:9px; }
}
@media (max-height:700px){
  .kcc-head{ padding-top:9px;padding-bottom:8px; }
  .kcc-scroll{ padding-top:9px;padding-bottom:8px; }
  .kcc-showcaseText{ display:none; }
  .kcc-collectionTile,.kcc-contextTile{ flex-basis:104px; }
  .kcc-collectionImage,.kcc-contextImage{ aspect-ratio:1/1.02; }
  .kcc-prompts span,#kcc-panel[data-kcc-role="d2c"] .kcc-prompts span,
#kcc-panel[data-kcc-role="d2c"] .kcc-prompts a{ min-height:28px !important;padding:5px 9px !important; }
  .kcc-compose{ padding-top:6px;padding-bottom:6px; }
  .kcc-foot{ padding-top:4px;padding-bottom:5px; }
}
@media (prefers-reduced-motion:reduce){
  #kcc-panel *,#kcc-bubble *{ animation:none !important;transition:none !important;scroll-behavior:auto !important; }
}
  `);

  const hook = el("div");
  hook.id = "kcc-ui-hook";
  hook.setAttribute("data-kcc-ui", "1");
  hook.setAttribute("hidden", "hidden");

  const bubble = el(
    "button",
    "kcc-bubble",
    `<span class="kcc-triggerInner">
       <span data-kcc-bubble-label="1" class="kcc-triggerMark">${BUBBLE_LABEL_LOCK}</span>
       <span data-kcc-bubble-role="1" class="kcc-triggerCta">Private Concierge</span>
     </span>`
  );
  bubble.id = "kcc-bubble";
  bubble.setAttribute("data-kcc-version", "v47.18.68");
  bubble.setAttribute("aria-label", kccCopy("Open Kanchan Cashmere Concierge", "Kanchan Cashmere Concierge öffnen"));
  applyBubblePresentation();


  const panel = el("section");
  panel.id = "kcc-panel";
  panel.className = "kccP";
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-label", "Kanchan Cashmere Concierge");
  panel.setAttribute("aria-modal", "true");
  panel.setAttribute("hidden", "hidden");
  panel.setAttribute("aria-hidden", "true");

  const logoHtml =
    CFG.ux && CFG.ux.header && CFG.ux.header.logoSrc
      ? `<div class="kcc-logoWrap"><img class="kcc-logo" src="${escapeHtml(
          CFG.ux.header.logoSrc
        )}" alt="${escapeHtml(CFG.brand || "Kanchan Cashmere")}" loading="eager" decoding="async"></div>`
      : `<div class="kcc-mark" aria-hidden="true">K</div>`;

  const actionsHtml = `
    <a class="kcc-headAction" data-kcc-cart="1" href="${escapeHtml(localizedInternalHref("/cart"))}" aria-label="${escapeHtml(kccCopy("View shopping bag", "Warenkorb ansehen"))}" title="${escapeHtml(kccCopy("Shopping bag", "Warenkorb"))}">
      <svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" aria-hidden="true"><path d="M6.5 8.5h11l-.7 11H7.2l-.7-11Z"/><path d="M9 9V6.8a3 3 0 0 1 6 0V9"/></svg>
    </a>
    <button class="kcc-headAction" data-kcc-reset="1" type="button" aria-label="${escapeHtml(kccCopy("Start a new conversation", "Neue Konversation starten"))}" title="${escapeHtml(kccCopy("New conversation", "Neue Konversation"))}">
      <svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.35-5.65L4 8.7"/><path d="M4 4.8v3.9h3.9"/></svg>
    </button>`;
  const closeHtml = `<button class="kcc-close" data-kcc-close="1" type="button" aria-label="${escapeHtml(kccCopy("Close", "Schließen"))}"><span class="kcc-x" aria-hidden="true">×</span></button>`;

  const header = el(
    "header",
    "kcc-head",
    `
    <div class="kcc-row">
      <div class="kcc-left">${logoHtml}</div>
      <div class="kcc-center" aria-label="${escapeHtml(kccCopy("Header title", "Kopfzeilentitel"))}">
        <div class="kcc-title">${escapeHtml(
          (CFG.ux && CFG.ux.header && CFG.ux.header.headerTitle) || "KANCHAN CASHMERE"
        )}</div>
        <div class="kcc-sub" id="kcc-sub">${escapeHtml(
          (CFG.ux && CFG.ux.header && CFG.ux.header.headerSub) || "Concierge"
        )}</div>
        <div class="kcc-cue" id="kcc-cue">Private concierge • Support & enquiries</div>

        <div class="kccH__meta">
          <span data-kcc-net style="display:none"></span>
        </div>
      </div>
      <div class="kcc-right">${actionsHtml}${closeHtml}</div>
    </div>
  `
  );

  const body = el(
    "main",
    "kcc-body",
    `
    <div class="kcc-scroll" id="kcc-scroll"></div>
    <div class="kcc-compose" id="kcc-compose">
      <input id="kcc-input" class="kcc-input" type="text" placeholder="${escapeHtml(kccCopy("Ask KCC anything…", "Fragen Sie KCC ..."))}" aria-label="${escapeHtml(kccCopy("Type your question", "Ihre Frage eingeben"))}">
      <button id="kcc-send" class="kcc-send" type="button" aria-label="${escapeHtml(kccCopy("Send message", "Nachricht senden"))}">${escapeHtml(kccCopy("Send", "Senden"))}</button>
    </div>
    <div class="kcc-foot">${escapeHtml(kccCopy("Luxury with Integrity · Crafted in Nepal", "Luxus mit Integrität · Gefertigt in Nepal"))}</div>
  `
  );

  panel.appendChild(header);
  panel.appendChild(body);

  hook.appendChild(bubble);
  hook.appendChild(panel);

  const SCROLL = $("#kcc-scroll", panel);
  const INPUT = $("#kcc-input", panel);
  const COMPOSE = $("#kcc-compose", panel);
  const SUB = $("#kcc-sub", panel);
  const CUE = $("#kcc-cue", panel);

  // Keep wheel/touch gestures inside the concierge without cancelling native scroll.
  try {
    ["wheel", "touchmove"].forEach((eventName) => {
      SCROLL.addEventListener(eventName, (event) => event.stopPropagation(), { passive: true });
    });
  } catch (_) {}

  /* ---------------------------------------------------------------------------
     DUAL CONTEXT (SILENT) — changes ONLY header sub + cue + payload.intent
  --------------------------------------------------------------------------- */
  function normalizedPath() {
    let p = String(location.pathname || "/").toLowerCase();
    p = p.replace(/\/{2,}/g, "/");

    // Current production language architecture is EN root + DE /de.
    // Exact /de MUST normalize to / so the German homepage behaves exactly
    // like the English homepage at the page-family level.
    p = p.replace(/^\/de(?=\/|$)/, "");

    if (p.length > 1) p = p.replace(/\/+$/, "");
    return p || "/";
  }

  function activeLocalePrefix() {
    try {
      return kccIsGerman() ? "/de" : "";
    } catch (_) {
      return /^\/de(?:\/|$)/i.test(String(location.pathname || "")) ? "/de" : "";
    }
  }

  function localizedInternalHref(href) {
    const raw = String(href || "").trim();
    if (!raw) return raw;
    if (/^(?:https?:|mailto:|tel:|sms:|#|javascript:)/i.test(raw)) return raw;

    const prefix = activeLocalePrefix();
    if (!prefix) return raw;

    if (raw === prefix || raw.indexOf(`${prefix}/`) === 0) return raw;

    // Shopify internal paths only. Keep assets, CDN and non-navigation endpoints untouched.
    if (/^\/(?:pages|products|collections|cart|search|account|apps)(?:\/|$|\?)/i.test(raw)) {
      return `${prefix}${raw}`;
    }
    return raw;
  }

  function kccIsGerman() {
    try {
      const pathDe = /^\/de(?:\/|$)/i.test(String(location.pathname || ""));
      const htmlLang = String(document.documentElement && document.documentElement.lang || "").toLowerCase();
      const shopifyLocale = String(
        window.Shopify && window.Shopify.locale ? window.Shopify.locale : ""
      ).toLowerCase();
      return pathDe || htmlLang === "de" || htmlLang.startsWith("de-") || shopifyLocale === "de" || shopifyLocale.startsWith("de-");
    } catch (_) {
      return /^\/de(?:\/|$)/i.test(String(location.pathname || ""));
    }
  }

  const KCC_DE_UI = {
    "Good morning — welcome to Kanchan Cashmere. Explore our collections, craftsmanship, or private-label capabilities.": "Guten Morgen — willkommen bei Kanchan Cashmere. Entdecken Sie unsere Kollektionen, Handwerkskunst oder Private-Label-Möglichkeiten.",
    "Good afternoon — welcome to Kanchan Cashmere. Explore our collections, craftsmanship, or private-label capabilities.": "Guten Tag — willkommen bei Kanchan Cashmere. Entdecken Sie unsere Kollektionen, Handwerkskunst oder Private-Label-Möglichkeiten.",
    "Good evening — welcome to Kanchan Cashmere. Explore our collections, craftsmanship, or private-label capabilities.": "Guten Abend — willkommen bei Kanchan Cashmere. Entdecken Sie unsere Kollektionen, Handwerkskunst oder Private-Label-Möglichkeiten.",
    "Explore Kanchan Cashmere": "Kanchan Cashmere entdecken",
    "Women": "Damen",
    "Men": "Herren",
    "Accessories": "Accessoires",
    "Best Sellers": "Bestseller",
    "Explore Collections": "Kollektionen entdecken",
    "Our Craftsmanship": "Unsere Handwerkskunst",
    "Private Label & Production": "Private Label & Produktion",
    "Speak with Kanchan Cashmere": "Mit Kanchan Cashmere sprechen",
    "Ask KCC anything...": "Fragen Sie KCC ...",
    "SEND": "SENDEN",
    "Send": "Senden",
    "Start a Project": "Projekt starten",
    "Contact Kanchan Cashmere": "Kanchan Cashmere kontaktieren",
    "View collection": "Kollektion ansehen",
    "View Collection": "Kollektion ansehen",
    "View product": "Produkt ansehen",
    "View Product": "Produkt ansehen",
    "View all products": "Alle Produkte ansehen",
    "Learn More": "Mehr erfahren",
    "Explore the Library": "Bibliothek entdecken",
    "Buyer Studio": "Buyer Studio",
    "Private Concierge": "Privater Concierge",
    "Buyer Concierge": "Käufer Concierge",
    "Product Concierge": "Produkt Concierge",
    "Collection Concierge": "Kollektion Concierge",
    "Ask Anything": "Alles fragen",
    "Private concierge • Programmes & sampling": "Private Concierge • Programme & Sampling",
    "Private concierge • Collections & care": "Private Concierge • Kollektionen & Pflege",
    "Private concierge • Collections & partnerships": "Private Concierge • Kollektionen & Partnerschaften",
    "Ask about sampling or production…": "Fragen Sie zu Sampling oder Produktion …",
    "Ask about this piece…": "Fragen Sie zu diesem Produkt …",
    "Ask about styles, sizing or care…": "Fragen Sie zu Modellen, Größen oder Pflege …",
    "Ask KCC anything…": "Fragen Sie KCC ...",
    "Close concierge": "Concierge schließen",
    "Reset conversation": "Konversation zurücksetzen",
    "Loading": "Wird geladen",
    "Something went wrong. Please try again.": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."
  };

  Object.assign(KCC_DE_UI, {
  "3GG–16GG": "3GG–16GG",
  "AQL 2.5": "AQL 2.5",
  "Accessories": "Accessoires",
  "Approval Discipline": "Freigabeprozess",
  "Approved Specification": "Freigegebene Spezifikation",
  "Baby & Child": "Baby & Kind",
  "Best Sellers": "Bestseller",
  "Browse All Categories": "Alle Kategorien entdecken",
  "Cable swatches": "Zopfmuster-Swatches",
  "Care Guide": "Pflegeleitfaden",
  "Cashmere & Blends": "Cashmere & Mischungen",
  "Certification Scope": "Zertifizierungsumfang",
  "Certified Yarns": "Zertifizierte Garne",
  "Commercial Framework": "Kommerzielle Rahmenbedingungen",
  "Complex Structures": "Komplexe Strukturen",
  "Contact Kanchan Cashmere": "Kanchan Cashmere kontaktieren",
  "Design & Development": "Design & Entwicklung",
  "Design References": "Designreferenzen",
  "Development": "Entwicklung",
  "Drying & Storage": "Trocknen & Aufbewahren",
  "Explore Collections": "Kollektionen entdecken",
  "Fit & Measurement": "Passform & Maße",
  "From Brief to Proto": "Vom Briefing zum Prototyp",
  "Fully Fashioned Construction": "Fully-Fashioned-Konstruktion",
  "Information to Prepare": "Benötigte Informationen",
  "Integrated Development": "Integrierte Entwicklung",
  "Jacquard swatches": "Jacquard-Swatches",
  "Knitting to Finishing": "Vom Stricken bis zum Finishing",
  "Labels & Accessories": "Labels & Zubehör",
  "Lead-Time Planning": "Lieferzeitplanung",
  "MOQ & Costing": "MOQ & Kalkulation",
  "MOQ & Production": "MOQ & Produktion",
  "Manufacturing": "Fertigung",
  "Manufacturing Capability": "Fertigungskompetenz",
  "Manufacturing Excellence": "Fertigungsexzellenz",
  "Material Direction": "Materialrichtung",
  "Material Directions": "Materialrichtungen",
  "Materials": "Materialien",
  "Materials & Swatches": "Materialien & Swatches",
  "Men": "Herren",
  "Modern Capability": "Moderne Fertigungskompetenz",
  "Nepalese Craft": "Nepalesisches Handwerk",
  "Our Craftsmanship": "Unsere Handwerkskunst",
  "Packaging Programme": "Verpackungsprogramm",
  "Pilling": "Pilling",
  "Pointelle swatches": "Pointelle-Swatches",
  "Private Label & Production": "Private Label & Produktion",
  "Product Scope": "Produktspektrum",
  "Production Control": "Produktionskontrolle",
  "Production Timeline": "Produktionszeitplan",
  "Quality Assurance": "Qualitätssicherung",
  "Quality Checkpoints": "Qualitätsprüfpunkte",
  "Quality Framework": "Qualitätsrahmen",
  "Recycled Cashmere": "Recyceltes Cashmere",
  "Responsible Production": "Verantwortungsvolle Produktion",
  "Rib swatches": "Rippen-Swatches",
  "Sampling Route": "Sampling-Ablauf",
  "Sampling Timeline": "Sampling-Zeitplan",
  "Seasonal Development": "Saisonale Entwicklung",
  "Shipment Readiness": "Versandbereitschaft",
  "Speak with Kanchan Cashmere": "Mit Kanchan Cashmere sprechen",
  "Start a Project": "Projekt starten",
  "Structure & Gauge": "Struktur & Gauge",
  "Studio Overview": "Studio-Übersicht",
  "Supplier & Yarn Selection": "Lieferanten- & Garnauswahl",
  "Swatch Gallery": "Swatch-Galerie",
  "Traceability": "Rückverfolgbarkeit",
  "Verified Claims": "Verifizierte Aussagen",
  "Washing": "Waschen",
  "Women": "Damen",
  "Yarn & Gauge": "Garn & Gauge",
  "Yarn Partners": "Garnpartner",
  "About Kanchan Cashmere": "Über Kanchan Cashmere",
  "Business Terms": "Geschäftsbedingungen",
  "Buyer Partnerships": "Käuferpartnerschaften",
  "Capabilities": "Kompetenzen",
  "Cashmere Care": "Cashmere-Pflege",
  "Cashmere Manufacturing": "Cashmere-Fertigung",
  "Craftsmanship": "Handwerkskunst",
  "Customer Support": "Kundenservice",
  "Development Process": "Entwicklungsprozess",
  "Ethical Production": "Ethische Produktion",
  "Innovation": "Innovation",
  "Kanchan Cashmere Design Studio": "Kanchan Cashmere Design Studio",
  "Kanchan Heritage": "Kanchan Heritage",
  "Kanchan Philosophy": "Kanchan Philosophie",
  "Library · Business & Sourcing": "Bibliothek · Business & Sourcing",
  "Library · Care & Maintenance": "Bibliothek · Pflege & Erhaltung",
  "Library · Development": "Bibliothek · Entwicklung",
  "Library · Inspiration": "Bibliothek · Inspiration",
  "Library · Knit Engineering": "Bibliothek · Knit Engineering",
  "Library · Manufacturing": "Bibliothek · Fertigung",
  "Library · Materials": "Bibliothek · Materialien",
  "Library · Quality": "Bibliothek · Qualität",
  "Library · Sustainability": "Bibliothek · Nachhaltigkeit",
  "Library · Why Nepal": "Bibliothek · Warum Nepal",
  "Luxury Knitwear Manufacturing": "Luxus-Strickwarenfertigung",
  "Order Tracking": "Sendungsverfolgung",
  "Our Excellences": "Unsere Exzellenz",
  "Our People": "Unsere Menschen",
  "Our Story": "Unsere Geschichte",
  "Packaging Solutions": "Verpackungslösungen",
  "Privacy": "Datenschutz",
  "Private Buyer Portal": "Privates Käuferportal",
  "Private Label": "Private Label",
  "Production Excellence": "Produktionsexzellenz",
  "Responsibility": "Verantwortung",
  "Returns & Exchanges": "Rückgabe & Umtausch",
  "Sampling & Development": "Sampling & Entwicklung",
  "Shipping & Delivery": "Versand & Lieferung",
  "Size Guide": "Größenberatung",
  "Sourcing": "Beschaffung",
  "Standards": "Standards",
  "Sustainability": "Nachhaltigkeit",
  "Terms of Service": "Nutzungsbedingungen",
  "The Essence of Kanchan Cashmere": "Die Essenz von Kanchan Cashmere",
  "The Library": "Die Bibliothek",
  "Vision & Future": "Vision & Zukunft",
  "Why Nepal": "Warum Nepal",
  "Our Company": "Unser Unternehmen",
  "Manufacturing Capabilities": "Fertigungskompetenzen",
  "Materials & Yarns": "Materialien & Garne",
  "Our Journey": "Unsere Reise",
  "Nepalese Craftsmanship": "Nepalesische Handwerkskunst",
  "Quality Philosophy": "Qualitätsphilosophie",
  "Discuss Your Collection": "Ihre Kollektion besprechen",
  "Quiet Luxury": "Quiet Luxury",
  "Material Integrity": "Materialintegrität",
  "Future Direction": "Zukünftige Ausrichtung",
  "Responsible Growth": "Verantwortungsvolles Wachstum",
  "Global Partnerships": "Globale Partnerschaften",
  "Why Partner With Kanchan Cashmere": "Warum mit Kanchan Cashmere arbeiten",
  "MOQ & Lead Time": "MOQ & Lieferzeit",
  "Development Support": "Entwicklungsunterstützung",
  "Private Label Programme": "Private-Label-Programm",
  "Yarn Options": "Garnoptionen",
  "Request a Quote": "Angebot anfragen",
  "Design Support": "Designunterstützung",
  "Swatch Development": "Swatch-Entwicklung",
  "Custom Knit Structures": "Individuelle Strickstrukturen",
  "Begin Development": "Entwicklung starten",
  "Sample Process": "Sampling-Prozess",
  "Yarn Selection": "Garnauswahl",
  "Submit a Brief": "Briefing senden",
  "Development Stages": "Entwicklungsstufen",
  "Approval Process": "Freigabeprozess",
  "Timelines": "Zeitpläne",
  "Start Development": "Entwicklung starten",
  "Manufacturing Process": "Fertigungsprozess",
  "Gauge Capability": "Gauge-Kompetenz",
  "Production Lead Time": "Produktionszeit",
  "Quality Control": "Qualitätskontrolle",
  "Production Standards": "Produktionsstandards",
  "Finishing & Inspection": "Finishing & Prüfung",
  "Discuss Production": "Produktion besprechen",
  "Product Categories": "Produktkategorien",
  "Knit Structures": "Strickstrukturen",
  "Production Scale": "Produktionsumfang",
  "Request Costing": "Kalkulation anfragen",
  "Responsible Materials": "Verantwortungsvolle Materialien",
  "Certifications": "Zertifizierungen",
  "Eco Packaging": "Ökologische Verpackung",
  "People & Workplace": "Menschen & Arbeitsplatz",
  "Responsible Manufacturing": "Verantwortungsvolle Fertigung",
  "Yarn Origin": "Garnherkunft",
  "Production Records": "Produktionsunterlagen",
  "Certification Documents": "Zertifizierungsunterlagen",
  "Buyer Documentation": "Käuferdokumentation",
  "Responsible Sourcing": "Verantwortungsvolle Beschaffung",
  "People": "Menschen",
  "Waste Reduction": "Abfallreduzierung",
  "Product Longevity": "Produktlanglebigkeit",
  "Quality Standards": "Qualitätsstandards",
  "Documentation": "Dokumentation",
  "Pure Cashmere": "Reines Cashmere",
  "Cashmere Blends": "Cashmere-Mischungen",
  "Yarn Certifications": "Garnzertifizierungen",
  "Yarn Availability": "Garnverfügbarkeit",
  "Colour Development": "Farbentwicklung",
  "Certification Options": "Zertifizierungsoptionen",
  "Knit Expertise": "Strickkompetenz",
  "Linking & Finishing": "Linking & Finishing",
  "Handfeel Development": "Handfeel-Entwicklung",
  "Quality Details": "Qualitätsdetails",
  "Nepalese Heritage": "Nepalesisches Erbe",
  "Atelier Craft": "Atelier-Handwerk",
  "Explore Our Story": "Unsere Geschichte entdecken",
  "Care & Longevity": "Pflege & Langlebigkeit",
  "Knit Innovation": "Strickinnovation",
  "Technical Development": "Technische Entwicklung",
  "New Materials": "Neue Materialien",
  "Custom Programmes": "Individuelle Programme",
  "Specialist Skills": "Spezialisiertes Können",
  "Workplace Values": "Arbeitsplatzwerte",
  "Skilled Craftsmanship": "Qualifiziertes Handwerk",
  "Production Advantages": "Produktionsvorteile",
  "Partner With Kanchan Cashmere": "Mit Kanchan Cashmere zusammenarbeiten",
  "Washing Cashmere": "Cashmere waschen",
  "Drying & Reshaping": "Trocknen & Formgebung",
  "Pilling Care": "Pilling-Pflege",
  "Storage": "Aufbewahrung",
  "Women's Sizing": "Damengrößen",
  "Men's Sizing": "Herrengrößen",
  "How to Measure": "Richtig messen",
  "Size Assistance": "Größenberatung",
  "Track My Order": "Bestellung verfolgen",
  "Tracking Not Updated": "Tracking nicht aktualisiert",
  "Delivery Question": "Frage zur Lieferung",
  "Contact Support": "Support kontaktieren",
  "Orders": "Bestellungen",
  "Shipping": "Versand",
  "Product Care": "Produktpflege",
  "Product Enquiry": "Produktanfrage",
  "Private Label Enquiry": "Private-Label-Anfrage",
  "Order Support": "Bestellservice",
  "Email Kanchan Cashmere": "Kanchan Cashmere per E-Mail kontaktieren",
  "Delivery Times": "Lieferzeiten",
  "International Shipping": "Internationaler Versand",
  "Duties & Taxes": "Zölle & Steuern",
  "Track Order": "Bestellung verfolgen",
  "Return Eligibility": "Rückgabeberechtigung",
  "Exchange Process": "Umtauschprozess",
  "Return Instructions": "Rücksendeanweisungen",
  "MOQ & Sampling": "MOQ & Sampling",
  "Payment Terms": "Zahlungsbedingungen",
  "Quality & Claims": "Qualität & Reklamationen",
  "Information Collected": "Erhobene Informationen",
  "How Data Is Used": "Verwendung der Daten",
  "Cookies": "Cookies",
  "Contact": "Kontakt",
  "Website Terms": "Website-Bedingungen",
  "Orders & Payments": "Bestellungen & Zahlungen",
  "Intellectual Property": "Geistiges Eigentum",
  "Explore Swatches": "Swatches entdecken",
  "Request Sampling": "Sampling anfragen",
  "Find My Size": "Meine Größe finden",
  "How Does It Feel?": "Wie fühlt es sich an?",
  "Similar Pieces": "Ähnliche Modelle",
  "Explore This Collection": "Diese Kollektion entdecken",
  "Shop Collections": "Kollektionen shoppen",
  "Find a Cashmere Style": "Cashmere-Modell finden",
  "Order & Delivery": "Bestellung & Lieferung",
  "Lead Times": "Lieferzeiten",
  "View Collections": "Kollektionen ansehen",
  "View Our Story": "Unsere Geschichte ansehen",
  "Discuss Partnership": "Partnerschaft besprechen",
  "Contact Development Team": "Entwicklungsteam kontaktieren",
  "Submit Your Brief": "Briefing senden",
  "Send Development Brief": "Entwicklungsbriefing senden",
  "Request Documentation": "Dokumentation anfragen",
  "Open Tracking": "Tracking öffnen",
  "View Quality Assurance": "Qualitätssicherung ansehen",
  "View Certified Yarns": "Zertifizierte Garne ansehen",
  "Explore Materials": "Materialien entdecken",
  "Explore Development": "Entwicklung entdecken",
  "Explore Manufacturing": "Fertigung entdecken",
  "Open Swatch Gallery": "Swatch-Galerie öffnen",
  "View Cashmere Care": "Cashmere-Pflege ansehen",
  "View Swatch Library": "Swatch-Galerie ansehen",
  "View full collection": "Gesamte Kollektion ansehen",
  "Explore all collections": "Alle Kollektionen entdecken",
  "Explore full collection": "Gesamte Kollektion entdecken",
  "View current piece": "Aktuelles Modell ansehen",
  "Current Piece": "Aktuelles Modell",
  "Related Pieces": "Ähnliche Modelle",
  "Buyer Guidance": "Käuferberatung",
  "Development Direction": "Entwicklungsrichtung",
  "Selected Knit Swatches": "Ausgewählte Strick-Swatches",
  "The Collections": "Die Kollektionen",
  "Explore Kanchan Cashmere": "Kanchan Cashmere entdecken",
  "Selected cashmere pieces": "Ausgewählte Cashmere-Modelle",
  "Selected knit swatches": "Ausgewählte Strick-Swatches",
  "Previous collections": "Vorherige Kollektionen",
  "Next collections": "Nächste Kollektionen",
  "Previous pieces": "Vorherige Modelle",
  "Next pieces": "Nächste Modelle",
  "Previous swatches": "Vorherige Swatches",
  "Next swatches": "Nächste Swatches",
  "Shopping bag": "Warenkorb",
  "View shopping bag": "Warenkorb ansehen",
  "New conversation": "Neue Konversation",
  "Start a new conversation": "Neue Konversation starten",
  "Close": "Schließen",
  "Type your question": "Ihre Frage eingeben",
  "Send message": "Nachricht senden",
  "Connecting…": "Verbindung wird hergestellt …",
  "Offline": "Offline"
});

  Object.assign(KCC_DE_UI, {
  "Header title": "Kopfzeilentitel",
  "Open Kanchan Cashmere Concierge": "Kanchan Cashmere Concierge öffnen",
  "Selected Kanchan Cashmere pieces": "Ausgewählte Kanchan Cashmere Modelle",
  "Explore Kanchan Cashmere collections": "Kanchan Cashmere Kollektionen entdecken",
  "The Collection": "Die Kollektion",
  "Selected for you": "Für Sie ausgewählt",
  "A considered edit of Kanchan Cashmere pieces available to explore.": "Eine kuratierte Auswahl an Kanchan Cashmere Modellen.",
  "Explore the collection": "Kollektion entdecken",
  "The piece and related styles": "Das Modell und passende Styles",
  "View the current piece alongside a small edit of complementary cashmere styles.": "Entdecken Sie das aktuelle Modell zusammen mit einer kleinen Auswahl passender Cashmere-Styles.",
  "Current Collection": "Aktuelle Kollektion",
  "Selected pieces": "Ausgewählte Modelle",
  "A focused edit from the collection currently in view.": "Eine kuratierte Auswahl aus der aktuell angezeigten Kollektion.",
  "Explore full collection": "Gesamte Kollektion entdecken",
  "Related cashmere pieces": "Ähnliche Cashmere-Modelle",
  "Cashmere poncho": "Cashmere-Poncho",
  "Cashmere sweater": "Cashmere-Pullover",
  "Cashmere pullover": "Cashmere-Pullover",
  "Cashmere cardigan": "Cashmere-Cardigan",
  "Cashmere scarf": "Cashmere-Schal",
  "Cashmere wrap": "Cashmere-Stola",
  "Cashmere knit dress": "Cashmere-Strickkleid",
  "Cashmere robe": "Cashmere-Robe",
  "Cashmere hoodie": "Cashmere-Hoodie",
  "Cashmere coat": "Cashmere-Mantel",
  "Cashmere shawl": "Cashmere-Shawl",
  "Cashmere swatch": "Cashmere-Swatch",
  "Plain / Minimal Knit": "Glatt / Minimal",
  "Cable": "Zopfmuster",
  "Rib": "Rippe",
  "Lace": "Spitze",
  "Mesh": "Mesh",
  "Stripe": "Streifen",
  "Texture": "Textur",
  "Selected cashmere pieces": "Ausgewählte Cashmere-Modelle",
  "View Piece": "Produkt ansehen",
  "View Swatch": "Swatch ansehen",
  "Luxury with Integrity · Crafted in Nepal": "Luxus mit Integrität · Gefertigt in Nepal"
});

  function lockKccComposerLocale() {
    if (!kccIsGerman()) return;
    try {
      const inputs = panel ? panel.querySelectorAll('input, textarea') : [];
      inputs.forEach((el) => {
        const p = String(el.getAttribute("placeholder") || "").trim();
        if (/^Ask KCC anything/i.test(p) || p === "Ask KCC anything...") {
          el.setAttribute("placeholder", "Fragen Sie KCC ...");
          try { el.placeholder = "Fragen Sie KCC ..."; } catch (_) {}
        }
      });
    } catch (_) {}
  }

  function localizedKccText(value) {
    const s = String(value == null ? "" : value);
    if (!kccIsGerman()) return s;
    return KCC_DE_UI[s.trim()] || s;
  }

  function kccCopy(en, de) {
    return kccIsGerman() ? de : en;
  }

  function germanWorkerPromptFromContext(item) {
    if (!item) return "";
    const label = localizedKccText(item.label || "");
    const source = String(item.reply || "").trim();
    return [
      `Bitte beantworte die folgende Anfrage vollständig auf Deutsch: ${label}.`,
      source ? `Verwende diesen bestätigten Kanchan-Cashmere-Kontext als sachliche Grundlage: ${source}` : "",
      "Behalte Kanchan Cashmere, Produktnamen, Garnartikel, Eigennamen und technische Fachbegriffe korrekt bei.",
      "Erfinde keine Zertifizierungen, Preise, Verfügbarkeiten, Liefertermine oder kommerziellen Zusagen."
    ].filter(Boolean).join("\n\n");
  }

  function translateKccUi(root) {
    if (!kccIsGerman()) return;
    try {
      const scope = root && root.querySelectorAll ? root : panel;
      if (!scope) return;

      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach((node) => {
        const raw = String(node.nodeValue || "");
        const trimmed = raw.trim();
        if (!trimmed) return;
        const translated = localizedKccText(trimmed);
        if (translated === trimmed) return;
        node.nodeValue = raw.replace(trimmed, translated);
      });

      scope.querySelectorAll('input[placeholder], textarea[placeholder]').forEach((el) => {
        const p = String(el.getAttribute("placeholder") || "").trim();
        const translated = localizedKccText(p);
        if (translated && translated !== p) el.setAttribute("placeholder", translated);
      });

      scope.querySelectorAll('[aria-label], [title]').forEach((el) => {
        ["aria-label", "title"].forEach((attr) => {
          const v = String(el.getAttribute(attr) || "").trim();
          const translated = localizedKccText(v);
          if (translated && translated !== v) el.setAttribute(attr, translated);
        });
      });
      lockKccComposerLocale();
    } catch (_) {}
  }

  function enforceLocalizedKccLinks(root) {
    try {
      const scope = root && root.querySelectorAll ? root : panel;
      if (!scope || !scope.querySelectorAll) return;
      scope.querySelectorAll('a[href]').forEach((a) => {
        const href = a.getAttribute("href") || "";
        const localized = localizedInternalHref(href);
        if (localized && localized !== href) a.setAttribute("href", localized);
      });
      translateKccUi(scope);
    } catch (_) {}
  }


  const KCC_PAGE_CONTEXT = {"/pages/kci-about":{"heading":"About Kanchan Cashmere","pills":[{"label":"Our Company","reply":"Kanchan Cashmere is a premium cashmere knitwear manufacturer based in Kathmandu, Nepal, established in 2008.\n\nWe work with boutique retailers, independent designers, and established luxury brands across North America and Europe, supporting projects from initial concept through yarn selection, sampling, production, quality control, and shipment preparation.\n\nOur focus is long-term partnership, technical expertise, material quality, and dependable execution rather than volume-driven mass production."},{"label":"Manufacturing Capabilities","reply":"Kanchan Cashmere combines computerized knitting technology from 3GG to 16GG with skilled linking, washing, blocking, finishing, and final quality control.\n\nWe manufacture sweaters, cardigans, dresses, trousers, scarves, shawls, ponchos, accessories, and selected baby or home cashmere products in both development quantities and larger seasonal runs.\n\nOur team supports fully custom developments, private-label programmes, exclusive knit structures, and technically demanding constructions according to the buyer’s approved specifications."},{"label":"Materials & Yarns","reply":"Kanchan Cashmere sources yarns through established approved partners, including public yarn partners Cariaggi, Consinee, and Top Line. Applicable certification is confirmed for the specific yarn article, supplier documentation, lot, colour and programme requirements.\n\nOur verified FW 2026–27 yarn library includes pure cashmere, Consinee INTEGRO NM 2/26 recycled cashmere, baby cashmere, brushed cashmere, cashmere-silk, yak, alpaca, and selected technical luxury blends. Exact article, composition, count, colour, certification scope, allocation, and availability are confirmed against the current supplier lot.\n\nOur team recommends the yarn and gauge after reviewing the target weight, structure, handfeel, drape, colour plan, and programme requirements."},{"label":"Start a Project","reply":"Starting a project with Kanchan Cashmere is straightforward.\n\nBuyers can share a technical pack, reference image, sketch, existing garment, or concept direction. Our development team reviews yarn options, gauge suitability, construction, measurements, timelines, and production feasibility before recommending the next step.\n\nWhether the programme is a new capsule collection or an extension of an established line, we can guide the process from initial development through production and shipment preparation.","href":"/pages/kci-contact","cta":"Contact Kanchan Cashmere"}]},"/pages/our-story":{"heading":"Our Story","pills":[{"label":"Our Journey","reply":"Kanchan Cashmere was established in Kathmandu in 2008 with a focus on refined cashmere knitwear and close buyer collaboration.\n\nOver time, the company developed from a focused local operation into an international manufacturing partner serving boutique retailers, independent designers, and established brands across North America and Europe.\n\nThe business has grown through technical learning, long-term relationships, disciplined production, and a continued respect for Nepalese craftsmanship."},{"label":"Nepalese Craftsmanship","reply":"Nepalese craftsmanship is central to the identity of Kanchan Cashmere.\n\nOur knitters, linkers, washers, finishers, and quality specialists combine hand judgement with modern production methods to shape the structure, handfeel, proportion, and final presentation of each garment.\n\nMany of these skills are developed through years of repetition and practical experience, making craftsmanship an operational capability rather than a marketing statement."},{"label":"Quality Philosophy","reply":"Kanchan Cashmere’s quality philosophy is based on material integrity, technical accuracy, disciplined production, and careful finishing.\n\nQuality is reviewed through yarn selection, knitting consistency, linking, measurements, washing, blocking, surface appearance, labels, packing, and final shipment preparation.\n\nThe aim is not simply to pass inspection, but to produce garments that feel refined, perform reliably, and represent the buyer’s brand correctly."},{"label":"Discuss Your Collection","reply":"Please share your concept, target market, yarn direction, quantity and delivery requirement.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel.","href":"/pages/kci-contact","cta":"Speak with Kanchan Cashmere"}]},"/pages/kci-essence":{"heading":"The Essence of Kanchan Cashmere","pills":[{"label":"Quiet Luxury","reply":"For Kanchan Cashmere, quiet luxury is expressed through fibre quality, proportion, handfeel, workmanship and restraint rather than excessive branding.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Material Integrity","reply":"Material integrity begins with appropriate yarn selection and continues through knitting tension, construction, washing, finishing and final inspection.\n\nKanchan Cashmere sources yarns and accessories through approved partners. Any certification claim is confirmed against the specific article, supplier documentation, lot and programme requirements.\n\nMaterial selection and any related claim are aligned with the specific supplier documentation and programme requirements."},{"label":"Craftsmanship","reply":"Kanchan Cashmere combines technical knitting with specialist linking, washing, blocking, finishing and handwork.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Explore Collections","reply":"Explore Kanchan Cashmere collections and product categories.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly.","href":"/pages/kci-shop","cta":"View Collections"}]},"/pages/kci-vision":{"heading":"Vision & Future","pills":[{"label":"Future Direction","reply":"Kanchan Cashmere aims to grow as a technically capable, responsible and dependable luxury knitwear partner while preserving its craftsmanship and material discipline.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Responsible Growth","reply":"Responsible growth means realistic production planning, careful sourcing, dependable quality and long-term relationships.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Innovation","reply":"Innovation at Kanchan Cashmere includes new knit structures, yarn combinations, gauges, finishing methods and technically feasible interpretations of buyer concepts.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Global Partnerships","reply":"Kanchan Cashmere develops long-term partnerships with international buyers who value technical clarity, material quality, responsible production, and dependable delivery.\n\nWe support both emerging brands and established companies, adapting the development and production route according to the scale, complexity, and commercial objectives of each programme.\n\nThe strongest partnerships are built through realistic commitments, transparent communication, and consistent order and payment discipline.","href":"/pages/kci-contact","cta":"Discuss Partnership"}]},"/pages/kci-buyer-partnership":{"heading":"Buyer Partnerships","pills":[{"label":"Why Partner With Kanchan Cashmere","reply":"Kanchan Cashmere supports buyers from concept through yarn selection, swatch development, proto sampling, fit refinement, production planning, quality control and shipment preparation.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel."},{"label":"MOQ & Lead Time","reply":"Kanchan Cashmere’s standard minimum order quantity is 30 pieces per style, with a minimum of 10 pieces per colour.\n\nSample development normally requires 7–14 working days once certified materials, measurements, design direction, and technical inputs are confirmed. Bulk production typically requires 35–45 days, with a practical tolerance of ±5 days, from cleared advance payment, yarn readiness, final specification approval, and written production confirmation.\n\nThe final timeline is reviewed programme by programme and confirmed in writing before development or bulk production begins."},{"label":"Development Support","reply":"Development support can include silhouette review, yarn and gauge direction, stitch selection, swatches, measurements, proto sampling and fit corrections.\n\nTechnical feasibility is reviewed against certified material availability, gauge, construction, measurements, finishing, quality requirements, quantity, and delivery timing.\n\nThe agreed route is confirmed before sampling or production begins."},{"label":"Start a Project","reply":"To begin a project with Kanchan Cashmere, please share the style reference or technical pack, yarn direction, target quantity, size range, colour plan, and required delivery window.\n\nOur team will review the design, gauge, construction, yarn availability, sampling route, and production feasibility before recommending the next step.\n\nClear information at the beginning helps reduce revisions, improve costing accuracy, and establish a realistic development and production schedule.","href":"/pages/kci-contact","cta":"Contact Kanchan Cashmere"}]},"/pages/kci-private-label":{"heading":"Private Label","pills":[{"label":"Private Label Programme","reply":"Kanchan Cashmere provides private-label development and manufacturing for boutique retailers, independent designers, and established luxury brands.\n\nA programme may include design interpretation, yarn and gauge selection, swatch development, proto sampling, fit corrections, labels, packaging coordination, bulk production, quality control, and shipment preparation.\n\nWe support both compact capsule collections and larger seasonal programmes, subject to technical feasibility, yarn availability, and agreed commercial terms. Each project is reviewed individually so the development route remains clear, realistic, and commercially workable."},{"label":"MOQ & Lead Time","reply":"Kanchan Cashmere’s standard minimum order quantity is 30 pieces per style, with a minimum of 10 pieces per colour.\n\nSample development normally requires 7–14 working days once certified materials, measurements, design direction, and technical inputs are confirmed. Bulk production typically requires 35–45 days, with a practical tolerance of ±5 days, from cleared advance payment, yarn readiness, final specification approval, and written production confirmation.\n\nThe final timeline is reviewed programme by programme and confirmed in writing before development or bulk production begins."},{"label":"Yarn Options","reply":"Kanchan Cashmere works only with certified yarns and accessories sourced from certified and approved suppliers.\n\nMaterial directions include premium pure cashmere, recycled cashmere, baby cashmere, cashmere-silk, and other suitable luxury blends. Selection is based on gauge, weight, drape, handfeel, colour availability, performance, certification scope, continuity, and target pricing.\n\nWhere required, our team recommends the most suitable yarn count and develops a swatch before proto sampling."},{"label":"Request a Quote","reply":"To prepare an accurate quotation, Kanchan Cashmere requires the style or technical pack, yarn composition, gauge or target weight, size range, quantity by colour, finishing details, packaging requirements, and target delivery window.\n\nCosting can change materially according to yarn, consumption, structure, workmanship, washing, labels, packaging, and order volume. Once the information is complete, our team reviews technical feasibility and prepares the most commercially realistic quotation for the programme.","href":"/pages/kci-contact","cta":"Submit Your Brief"}]},"/pages/kci-design-studio":{"heading":"Kanchan Cashmere Design Studio","pills":[{"label":"Design Support","reply":"The Kanchan Cashmere Design Studio supports silhouette development, stitch selection, gauge direction, certified yarn and accessory recommendations, measurements, and technical feasibility.\n\nBuyers may provide a technical pack, sketch, reference garment, mood board, or concept direction. Our team reviews the design from both creative and manufacturing perspectives.\n\nThe objective is to preserve the design intent while developing a stable, refined, and commercially practical garment."},{"label":"Swatch Development","reply":"Swatch development is used to evaluate certified yarn behaviour, gauge suitability, stitch definition, weight, drape, handfeel, and finishing performance before proto sampling.\n\nKanchan Cashmere develops swatches across structures, gauges, and material directions so buyers can compare options and make informed decisions.\n\nWhere necessary, more than one swatch route may be prepared before the final structure is approved."},{"label":"Custom Knit Structures","reply":"Kanchan Cashmere develops jersey, rib, cable, links-links, Milano, fisherman, tuck, pointelle, jacquard, intarsia, lace, mesh, and other technically feasible structures.\n\nStructure selection affects appearance, weight, stretch, drape, yarn consumption, and production complexity.\n\nNew or technically complex structures are normally validated through swatching before proto development."},{"label":"Begin Development","reply":"To begin development, please share the concept, reference images or technical pack, preferred material direction, target quantity, size range, and delivery window.\n\nOur team will review certified yarn and accessory availability, gauge, construction, swatch needs, timeline, and production feasibility.\n\nThe proposed development route is then confirmed before work begins.","href":"/pages/kci-contact","cta":"Start Development"}]},"/pages/kci-sampling-development":{"heading":"Sampling & Development","pills":[{"label":"Sampling Timeline","reply":"Sample development at Kanchan Cashmere normally requires 7–14 working days once the yarn, design direction, measurements, and technical inputs have been confirmed.\n\nThe exact timing depends on yarn availability, gauge, stitch complexity, finishing requirements, and whether a swatch or construction trial is needed before the first prototype.\n\nWhere revisions are required, additional time is agreed according to the scope of the comments. Our team confirms the working timeline in writing so the buyer has a clear approval path before bulk production."},{"label":"Sample Process","reply":"The sample process normally covers brief review, yarn and gauge confirmation, swatch approval where required, proto development, measurements, fit comments and final approval.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"Yarn Selection","reply":"Kanchan Cashmere works only with certified yarns and accessories sourced from certified and approved suppliers.\n\nMaterial directions include premium pure cashmere, recycled cashmere, baby cashmere, cashmere-silk, and other suitable luxury blends. Selection is based on gauge, weight, drape, handfeel, colour availability, performance, certification scope, continuity, and target pricing.\n\nWhere required, our team recommends the most suitable yarn count and develops a swatch before proto sampling."},{"label":"Submit a Brief","reply":"Please provide the style reference or tech pack, yarn direction, size specification, target quantity and delivery window.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel.","href":"/pages/kci-contact","cta":"Send Development Brief"}]},"/pages/kci-development-process":{"heading":"Development Process","pills":[{"label":"Development Stages","reply":"Development normally moves through brief review, yarn and gauge selection, swatch confirmation, proto sampling, fit review, revisions and final approval.\n\nTechnical feasibility is reviewed against certified material availability, gauge, construction, measurements, finishing, quality requirements, quantity, and delivery timing.\n\nThe agreed route is confirmed before sampling or production begins."},{"label":"Approval Process","reply":"Approvals should confirm measurements, fit, construction, yarn, colour, labels, packaging and buyer-specific quality requirements before bulk production.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"Timelines","reply":"Kanchan Cashmere’s standard minimum order quantity is 30 pieces per style, with a minimum of 10 pieces per colour.\n\nSample development normally requires 7–14 working days once certified materials, measurements, design direction, and technical inputs are confirmed. Bulk production typically requires 35–45 days, with a practical tolerance of ±5 days, from cleared advance payment, yarn readiness, final specification approval, and written production confirmation.\n\nThe final timeline is reviewed programme by programme and confirmed in writing before development or bulk production begins."},{"label":"Start Development","reply":"Please share your technical pack or reference, yarn direction, expected quantity and target ship date.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel.","href":"/pages/kci-contact","cta":"Contact Development Team"}]},"/pages/kci-manufacturing":{"heading":"Cashmere Manufacturing","pills":[{"label":"Manufacturing Process","reply":"Kanchan Cashmere manages production through a controlled sequence beginning with yarn allocation and technical confirmation.\n\nThe main stages include knitting, linking, washing, blocking, finishing, measurement inspection, appearance review, labelling, packing, and shipment preparation.\n\nEach stage is monitored against the approved sample and specification. The process combines computerized knitting from 3GG to 16GG with skilled hand-finishing and quality control to achieve consistent structure, handfeel, proportion, and presentation."},{"label":"Gauge Capability","reply":"Kanchan Cashmere works across gauges from 3GG to 16GG, allowing the development of heavy sculptural knitwear, classic mid-gauge garments, and lightweight fine-gauge cashmere.\n\nGauge selection affects weight, drape, stitch definition, yarn consumption, handfeel, and overall cost. Our team reviews the intended silhouette, yarn count, construction, and seasonal use before recommending the most suitable gauge.\n\nWhere necessary, a swatch is developed first so the buyer can approve the structure and handfeel before the prototype is made."},{"label":"Production Lead Time","reply":"Kanchan Cashmere’s standard minimum order quantity is 30 pieces per style, with a minimum of 10 pieces per colour.\n\nSample development normally requires 7–14 working days once certified materials, measurements, design direction, and technical inputs are confirmed. Bulk production typically requires 35–45 days, with a practical tolerance of ±5 days, from cleared advance payment, yarn readiness, final specification approval, and written production confirmation.\n\nThe final timeline is reviewed programme by programme and confirmed in writing before development or bulk production begins."},{"label":"Quality Control","reply":"Quality control at Kanchan Cashmere is integrated throughout production rather than treated only as a final inspection.\n\nChecks cover yarn allocation, knitting consistency, linking, seam construction, measurements, surface appearance, washing, blocking, finishing, labels, packing, and shipment readiness.\n\nBulk orders are reviewed against approved specifications, reference samples, and buyer requirements. Kanchan Cashmere applies AQL 2.5 as its standard final inspection framework, supported by in-process controls designed to identify issues before final packing."}]},"/pages/kci-production-excellence":{"heading":"Production Excellence","pills":[{"label":"Production Standards","reply":"Kanchan Cashmere applies defined controls across yarn allocation, knitting, linking, washing, finishing, measurement, appearance, packing and shipment preparation.\n\nControls cover certified material verification, knitting, linking, measurements, washing, finishing, labels, accessories, packing, and shipment readiness.\n\nKanchan Cashmere applies AQL 2.5 as its standard final inspection framework unless otherwise agreed in writing."},{"label":"AQL 2.5","reply":"Kanchan Cashmere applies AQL 2.5 as its standard final inspection framework for bulk production.\n\nThis is supported by in-process checks during knitting, linking, washing, finishing, measurement control, appearance review, labelling, and packing.\n\nThe purpose is not only to assess the finished shipment, but also to identify and correct issues during production. Buyer-specific inspection requirements can be incorporated when they are confirmed in the approved specifications or signed agreement."},{"label":"Finishing & Inspection","reply":"Finishing develops the intended handfeel, shape and surface. Final inspection checks measurements, construction, appearance, labels and packing.\n\nControls cover certified material verification, knitting, linking, measurements, washing, finishing, labels, accessories, packing, and shipment readiness.\n\nKanchan Cashmere applies AQL 2.5 as its standard final inspection framework unless otherwise agreed in writing."},{"label":"Discuss Production","reply":"Please share the approved style, yarn, quantity and target ship date.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel.","href":"/pages/kci-contact","cta":"Contact Kanchan Cashmere"}]},"/pages/kci-capabilities":{"heading":"Capabilities","pills":[{"label":"Product Categories","reply":"Kanchan Cashmere manufactures a broad range of premium knitwear including sweaters, cardigans, dresses, trousers, outerwear, scarves, shawls, ponchos, accessories, and selected baby or home cashmere products.\n\nProduct feasibility depends on yarn, gauge, structure, construction, finishing, size range, and order quantity.\n\nOur team reviews each category at development stage so the intended design can be translated into a stable and production-ready garment."},{"label":"Knit Structures","reply":"Kanchan Cashmere develops knit structures including jersey, rib, cable, links-links, Milano, fisherman, tuck, pointelle, jacquard, intarsia, lace, mesh, and other technically feasible constructions.\n\nThe most suitable structure depends on the yarn count, gauge, garment weight, stretch, drape, surface definition, and intended use.\n\nWhere the structure is new or technically complex, a swatch is developed first to confirm appearance, handfeel, and production stability."},{"label":"Production Scale","reply":"Kanchan Cashmere supports sampling, development quantities, capsule collections, and larger seasonal programmes.\n\nStandard production can begin from 30 pieces per style with at least 10 pieces per colour, while larger runs are planned according to style complexity, yarn requirements, machine allocation, finishing capacity, and delivery timing.\n\nCapacity is confirmed programme by programme so commitments remain realistic and quality is not compromised."},{"label":"Request Costing","reply":"Please share the style or tech pack, yarn composition, gauge, quantity by colour and target delivery date.\n\nAccurate costing requires the style or technical pack, certified material specification, gauge, quantity by colour, size range, finishing, labels, accessories, packaging, and target delivery window.\n\nKanchan Cashmere confirms the quotation after technical feasibility and material availability are reviewed.","href":"/pages/kci-contact","cta":"Request a Quote"}]},"/pages/kci-sustainability":{"heading":"Sustainability","pills":[{"label":"Responsible Materials","reply":"Kanchan Cashmere sources yarns and accessories through approved partners. Any certification claim is confirmed against the specific article, supplier documentation, lot and programme requirements.\n\nMaterial selection considers fibre quality, performance, continuity, traceability, colour, gauge suitability, and programme requirements.\n\nAll sustainability and certification statements are aligned with the specific supplier documentation before development, labelling, production, or external communication."},{"label":"Certifications","reply":"Kanchan Cashmere sources yarns and accessories through approved partners. Any certification claim is confirmed against the specific article, supplier documentation, lot and programme requirements.\n\nDepending on the selected material and programme, supporting frameworks may include SFA, GRS, OEKO-TEX®, GOTS, OCS, and other applicable standards. Documentation is checked against the specific yarn, accessory, lot, and supplier record before any claim is used.\n\nThis sourcing policy does not mean every finished product carries every certification. The applicable scope is confirmed for each programme before development, labelling, production, or external communication."},{"label":"Recycled Cashmere","reply":"Kanchan Cashmere develops recycled cashmere programmes using certified recycled yarns sourced from certified and approved suppliers.\n\nComposition, yarn count, colour availability, minimum requirements, handfeel, performance, and documentation are reviewed before sampling.\n\nAny GRS or related claim is confirmed against the specific yarn, supplier record, lot, and programme documentation."},{"label":"Eco Packaging","reply":"Kanchan Cashmere uses certified and approved accessories and can coordinate lower-impact packaging directions such as recyclable paper components, reduced plastic use, and buyer-specific systems.\n\nPackaging is reviewed according to product protection, presentation, destination, logistics, supplier availability, quantity, and commercial requirements. Samples may be required before approval.\n\nFinal materials, specifications, and supporting claims are verified with the certified supplier before production."}]},"/pages/kci-ethical-production":{"heading":"Ethical Production","pills":[{"label":"People & Workplace","reply":"Luxury knitwear depends on the skill and judgement of the people who make it.\n\nKanchan Cashmere recognises the contribution of knitters, linkers, washers, finishers, quality specialists, packers, and production coordinators. Many of these skills are developed through years of repetition, technical understanding, and careful practice.\n\nA calm, organised, and respectful working environment supports better concentration, more dependable workmanship, and stronger product consistency for the brands that work with us."},{"label":"Responsible Manufacturing","reply":"Responsible manufacturing at Kanchan Cashmere is based on careful sourcing, realistic production planning, controlled processes, waste reduction, durable product development, and disciplined quality management.\n\nWe do not position responsibility as a general marketing statement. The approach is applied through yarn planning, sampling control, production efficiency, responsible finishing, product longevity, and long-term supplier and buyer relationships.\n\nProgramme-specific requirements are reviewed in advance so the production method, documentation, packaging, and delivery plan remain commercially and operationally realistic."},{"label":"Certifications","reply":"Kanchan Cashmere sources yarns and accessories through approved partners. Any certification claim is confirmed against the specific article, supplier documentation, lot and programme requirements.\n\nDepending on the selected material and programme, supporting frameworks may include SFA, GRS, OEKO-TEX®, GOTS, OCS, and other applicable standards. Documentation is checked against the specific yarn, accessory, lot, and supplier record before any claim is used.\n\nThis sourcing policy does not mean every finished product carries every certification. The applicable scope is confirmed for each programme before development, labelling, production, or external communication."},{"label":"Traceability","reply":"Kanchan Cashmere can maintain programme-specific traceability records covering yarn allocation, supplier information, production progress, quality inspection, and shipment documentation.\n\nThe exact traceability scope depends on the selected yarn, certification framework, buyer requirements, and the supporting documents available from the supply chain.\n\nWhere formal documentation is required, buyers should specify the required records before development begins so the correct yarn, lot references, production files, and shipment documents can be maintained."}]},"/pages/kci-traceability":{"heading":"Traceability","pills":[{"label":"Yarn Origin","reply":"Kanchan Cashmere confirms yarn origin through certified and approved suppliers, using the specific yarn specification, lot reference, and available supplier documentation.\n\nRecords may include composition, yarn count, colour, supplier reference, certification status, and supporting documents.\n\nThe available traceability scope is confirmed before development so the buyer understands what can be verified and documented."},{"label":"Production Records","reply":"Kanchan Cashmere maintains production records covering certified material allocation, knitting, linking, washing, finishing, quality inspection, packing, and shipment preparation.\n\nThese records support internal control, buyer reporting, and programme traceability.\n\nThe level of detail is aligned with the product, certification requirements, buyer procedures, and programme complexity."},{"label":"Certification Documents","reply":"Certification documents are provided where applicable and verified for the selected certified yarn, accessory, supplier, lot, and programme.\n\nDepending on the material, documentation may relate to SFA, GRS, OEKO-TEX®, GOTS, OCS, or other applicable frameworks.\n\nDocuments are checked before they are issued, referenced, or used for labelling and external communication."},{"label":"Buyer Documentation","reply":"Kanchan Cashmere can support buyer documentation requests relating to material specifications, certification records, packing information, shipment documents, and production records where applicable.\n\nThe exact documentation package depends on the selected certified materials, certification scope, buyer procedures, and programme requirements.\n\nBuyers should confirm documentation needs during development so the correct records can be maintained from the beginning.","href":"/pages/kci-contact","cta":"Contact Kanchan Cashmere"}]},"/pages/kci-responsibility":{"heading":"Responsibility","pills":[{"label":"Responsible Sourcing","reply":"Kanchan Cashmere evaluates yarn and supplier options according to quality, continuity, documentation, performance and programme requirements.\n\nKanchan Cashmere sources yarns and accessories through approved partners. Any certification claim is confirmed against the specific article, supplier documentation, lot and programme requirements.\n\nMaterial selection and any related claim are aligned with the specific supplier documentation and programme requirements."},{"label":"People","reply":"Skilled production teams are central to luxury knitwear. Kanchan Cashmere values organised work, specialist knowledge and careful execution.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Waste Reduction","reply":"Waste reduction begins with accurate yarn planning, controlled sampling, careful handling and production discipline.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Product Longevity","reply":"Longevity depends on appropriate fibre, construction, finishing, care and repair. Kanchan Cashmere prioritises quality and durability.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."}]},"/pages/kci-standards":{"heading":"Standards","pills":[{"label":"Quality Standards","reply":"Kanchan Cashmere applies structured quality controls through development, production, finishing and final shipment inspection.\n\nControls cover certified material verification, knitting, linking, measurements, washing, finishing, labels, accessories, packing, and shipment readiness.\n\nKanchan Cashmere applies AQL 2.5 as its standard final inspection framework unless otherwise agreed in writing."},{"label":"Certification Scope","reply":"Kanchan Cashmere sources yarns and accessories through approved partners. Any certification claim is confirmed against the specific article, supplier documentation, lot and programme requirements.\n\nDepending on the selected material and programme, supporting frameworks may include SFA, GRS, OEKO-TEX®, GOTS, OCS, and other applicable standards. Documentation is checked against the specific yarn, accessory, lot, and supplier record before any claim is used.\n\nThis sourcing policy does not mean every finished product carries every certification. The applicable scope is confirmed for each programme before development, labelling, production, or external communication."},{"label":"AQL 2.5","reply":"Kanchan Cashmere applies AQL 2.5 as its standard final inspection framework for bulk production.\n\nThis is supported by in-process checks during knitting, linking, washing, finishing, measurement control, appearance review, labelling, and packing.\n\nThe purpose is not only to assess the finished shipment, but also to identify and correct issues during production. Buyer-specific inspection requirements can be incorporated when they are confirmed in the approved specifications or signed agreement."},{"label":"Documentation","reply":"Please advise the required quality or certification documents so Kanchan Cashmere can confirm availability.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly.","href":"/pages/kci-contact","cta":"Request Documentation"}]},"/pages/kci-materials":{"heading":"Materials","pills":[{"label":"Pure Cashmere","reply":"Kanchan Cashmere works with premium certified pure-cashmere yarns sourced from certified and approved spinning partners, including Cariaggi, Consinee, Top Line, and other programme-approved sources.\n\nAvailable yarn counts support developments ranging from lightweight fine-gauge knitwear to heavier fully-fashioned sweaters, cardigans, dresses, scarves, shawls, and accessories.\n\nYarn selection is guided by gauge, weight, drape, handfeel, season, performance, colour availability, documentation, and target price."},{"label":"Recycled Cashmere","reply":"Kanchan Cashmere develops recycled cashmere programmes using certified recycled yarns from certified and approved suppliers.\n\nRecycled cashmere can be used for sweaters, cardigans, dresses, scarves, shawls, and accessories when the selected yarn and construction are technically appropriate.\n\nComposition, yarn count, colour, handfeel, performance, minimum requirements, and GRS or related documentation are confirmed before sampling."},{"label":"Cashmere Blends","reply":"Kanchan Cashmere works with certified luxury blends developed for specific drape, weight, handfeel, durability, and commercial objectives.\n\nDirections may include cashmere-silk and other approved fibre combinations suitable for fine-gauge, structured, seasonal, or performance-led products.\n\nThe final blend is selected according to the garment, gauge, target market, certified supplier availability, and required price position."},{"label":"Yarn Certifications","reply":"Kanchan Cashmere sources yarns and accessories through approved partners. Any certification claim is confirmed against the specific article, supplier documentation, lot and programme requirements.\n\nDepending on the selected material and programme, supporting frameworks may include SFA, GRS, OEKO-TEX®, GOTS, OCS, and other applicable standards. Documentation is checked against the specific yarn, accessory, lot, and supplier record before any claim is used.\n\nThis sourcing policy does not mean every finished product carries every certification. The applicable scope is confirmed for each programme before development, labelling, production, or external communication."}]},"/pages/kci-sourcing":{"heading":"Sourcing","pills":[{"label":"Yarn Partners","reply":"Kanchan Cashmere works only with certified and approved yarn and accessory suppliers.\n\nEstablished spinning partners include Cariaggi, Consinee, Top Line, and other qualified sources selected according to fibre quality, yarn count, colour range, certification, stock service, special blends, and continuity.\n\nThe final supplier is selected according to the intended garment, gauge, handfeel, performance, colour plan, documentation, quantity, timing, and target price."},{"label":"Yarn Availability","reply":"Yarn availability depends on composition, count, colour, supplier stock, minimum requirements, and the timing of the programme.\n\nStock-service colours can shorten development and production timelines, while special counts, custom colours, or certified qualities may require advance planning and supplier minimums.\n\nKanchan Cashmere confirms yarn availability before final sampling or bulk commitment so the buyer receives a realistic development and delivery schedule."},{"label":"Colour Development","reply":"Stock colours can reduce development time and minimum requirements.\n\nCustom colour development may be possible depending on the yarn supplier, required quantity, colour standard, lab-dip process, and lead time. Custom shades normally require review and approval before bulk yarn is reserved or produced.\n\nKanchan Cashmere confirms colour feasibility, supplier conditions, and the practical development schedule before the programme moves forward."},{"label":"Certification Options","reply":"Kanchan Cashmere sources yarns and accessories through approved partners. Any certification claim is confirmed against the specific article, supplier documentation, lot and programme requirements.\n\nDepending on the selected material and programme, supporting frameworks may include SFA, GRS, OEKO-TEX®, GOTS, OCS, and other applicable standards. Documentation is checked against the specific yarn, accessory, lot, and supplier record before any claim is used.\n\nThis sourcing policy does not mean every finished product carries every certification. The applicable scope is confirmed for each programme before development, labelling, production, or external communication."}]},"/pages/kci-craftsmanship":{"heading":"Craftsmanship","pills":[{"label":"Knit Expertise","reply":"Kanchan Cashmere combines computerized knitting from 3GG to 16GG with specialist linking, washing, blocking, finishing, and handwork.\n\nTechnical expertise is applied to gauge selection, yarn count, stitch structure, tension, shaping, measurements, and garment construction.\n\nThe objective is to translate the design into a stable, repeatable, and refined product rather than relying on appearance alone.\n\nTechnical feasibility is reviewed against certified material availability, gauge, construction, measurements, finishing, quality requirements, quantity, and delivery timing.\n\nThe agreed route is confirmed before sampling or production begins."},{"label":"Linking & Finishing","reply":"Linking provides structural integrity and determines how cleanly the garment is assembled.\n\nAfter linking, washing, blocking, and finishing develop the intended shape, handfeel, surface, and dimensional stability. These stages are controlled against the approved sample and measurement specification.\n\nCareful finishing is particularly important in cashmere because even a technically correct garment can feel or present poorly if the final process is not handled precisely."},{"label":"Handfeel Development","reply":"Handfeel is developed through the interaction of fibre quality, yarn count, gauge, stitch density, knitting tension, washing, and finishing.\n\nKanchan Cashmere reviews these variables together rather than treating softness as a final cosmetic adjustment.\n\nWhere the target handfeel is critical, swatches and prototypes are used to compare weight, surface, drape, and recovery before bulk production is approved."},{"label":"Quality Details","reply":"Luxury quality is built through small but measurable details.\n\nKanchan Cashmere reviews proportion, measurements, stitch consistency, seam execution, linking, surface appearance, finishing, labels, and packing against the approved standard.\n\nThese details influence not only appearance, but also comfort, durability, fit, and the buyer’s final presentation.\n\nControls cover certified material verification, knitting, linking, measurements, washing, finishing, labels, accessories, packing, and shipment readiness.\n\nKanchan Cashmere applies AQL 2.5 as its standard final inspection framework unless otherwise agreed in writing."}]},"/pages/kanchan-heritage":{"heading":"Kanchan Heritage","pills":[{"label":"Nepalese Heritage","reply":"Kanchan Cashmere heritage is rooted in Nepal long relationship with fine fibres, hand skills and patient craftsmanship.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Our Journey","reply":"Since 2008, Kanchan Cashmere has developed from a focused Kathmandu operation into an international manufacturing partner.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Atelier Craft","reply":"The atelier approach values technical attention, hand finishing, small details and direct responsibility for the finished garment.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Explore Our Story","reply":"Read more about the company journey, values and development.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly.","href":"/pages/our-story","cta":"View Our Story"}]},"/pages/kanchan-philosophy":{"heading":"Kanchan Philosophy","pills":[{"label":"Quiet Luxury","reply":"Quiet luxury is expressed through material quality, proportion, handfeel, workmanship and restraint rather than visible excess.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Care & Longevity","reply":"Appropriate washing, drying, storage and maintenance help preserve cashmere shape, softness and useful life.\n\nAlways follow the garment care label because construction, trims, colour, and finishing can affect the correct method.\n\nCareful handling helps preserve shape, softness, and long-term product value."},{"label":"Material Integrity","reply":"Material integrity requires the right yarn, construction, gauge, finish and quality control for the intended garment.\n\nKanchan Cashmere sources yarns and accessories through approved partners. Any certification claim is confirmed against the specific article, supplier documentation, lot and programme requirements.\n\nMaterial selection and any related claim are aligned with the specific supplier documentation and programme requirements."},{"label":"Explore Collections","reply":"Explore the Kanchan Cashmere collections.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly.","href":"/pages/kci-shop","cta":"View Collections"}]},"/pages/kanchan-innovation":{"heading":"Innovation","pills":[{"label":"Knit Innovation","reply":"Knit innovation at Kanchan Cashmere includes new structures, gauge combinations, yarn blends, surface effects, shaping methods, and finishing directions.\n\nInnovation is approached through technical testing rather than novelty alone. The idea must be visually relevant, structurally stable, repeatable in production, and suitable for the selected yarn.\n\nSwatches and prototypes are used to validate the concept before a bulk commitment is made."},{"label":"Technical Development","reply":"Technical development converts a creative concept into a measurable and production-ready garment.\n\nKanchan Cashmere reviews yarn, gauge, stitch structure, shaping, measurements, construction, finishing, and quality requirements before the style moves into sampling.\n\nThis process reduces avoidable revisions and helps ensure that the approved design can be produced consistently in bulk.\n\nTechnical feasibility is reviewed against certified material availability, gauge, construction, measurements, finishing, quality requirements, quantity, and delivery timing.\n\nThe agreed route is confirmed before sampling or production begins."},{"label":"New Materials","reply":"New material directions are reviewed for fibre quality, handfeel, performance, gauge suitability, colour availability, certification, continuity, and commercial feasibility.\n\nKanchan Cashmere does not adopt a material only because it is new. The yarn must support the intended product, production method, and buyer positioning.\n\nWhere required, swatches and wear-related checks are completed before the material is approved for a wider programme."},{"label":"Custom Programmes","reply":"Please share the design direction, yarn objective, quantity and delivery plan.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly.","href":"/pages/kci-contact","cta":"Discuss Development"}]},"/pages/kanchan-people":{"heading":"Our People","pills":[{"label":"Our People","reply":"Kanchan Cashmere garments are shaped by knitters, linkers, washers, finishers, quality specialists, packers and production coordinators.\n\nKanchan Cashmere combines Nepalese craftsmanship, certified sourcing, technical discipline, and restrained luxury positioning.\n\nThe objective is long-term product value supported by dependable execution rather than unsupported claims."},{"label":"Specialist Skills","reply":"Many knitwear skills require repeated practice, judgement and technical understanding that cannot be replaced by machinery alone.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"Workplace Values","reply":"A calm, organised and respectful working environment supports focus, workmanship and dependable quality.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"Ethical Production","reply":"Explore Kanchan Cashmere approach to people, responsibility and production.\n\nTechnical feasibility is reviewed against certified material availability, gauge, construction, measurements, finishing, quality requirements, quantity, and delivery timing.\n\nThe agreed route is confirmed before sampling or production begins.","href":"/pages/kci-ethical-production","cta":"View Ethical Production"}]},"/pages/kci-why-nepal":{"heading":"Why Nepal","pills":[{"label":"Why Nepal","reply":"Nepal offers a distinctive combination of cashmere knowledge, skilled handwork, adaptable development, and authentic craft heritage.\n\nFor luxury knitwear, this allows close attention to linking, finishing, handwork, and small garment details that are difficult to standardise through machinery alone.\n\nKanchan Cashmere combines these strengths with 3GG–16GG computerized knitting, certified sourcing, export-oriented systems, and structured quality control."},{"label":"Skilled Craftsmanship","reply":"Skilled craftsmanship remains one of Nepal’s strongest advantages in luxury knitwear production.\n\nExperienced knitters, linkers, finishers, washers, and quality specialists contribute knowledge developed through years of practical work.\n\nAt Kanchan Cashmere, these skills support garment construction, finishing quality, measurement accuracy, and refined handfeel."},{"label":"Production Advantages","reply":"Kanchan Cashmere combines Nepalese craft strengths with modern production capability.\n\nComputerized knitting from 3GG to 16GG, certified yarn and accessories, structured quality control, flexible development support, and experienced finishing teams allow both compact and larger programmes to be managed effectively.\n\nThis combination gives international buyers one integrated route from development to shipment."},{"label":"Partner With Kanchan Cashmere","reply":"Whether launching a new collection or expanding an established programme, Kanchan Cashmere can support development from concept through production.\n\nBuyers may provide a technical pack, reference garment, sketch, or design direction. Our team reviews certified sourcing, gauge, construction, timing, and production feasibility.\n\nPlease share the collection direction, expected quantity, size range, and delivery window to begin.","href":"/pages/kci-contact","cta":"Contact Kanchan Cashmere"}]},"/pages/kci-cashmere-care":{"heading":"Cashmere Care","pills":[{"label":"Washing Cashmere","reply":"Use cool water and a specialist wool or cashmere detergent. Wash gently without rubbing or twisting, and follow the garment care label.\n\nAlways follow the garment care label because construction, trims, colour, and finishing can affect the correct method.\n\nCareful handling helps preserve shape, softness, and long-term product value."},{"label":"Drying & Reshaping","reply":"Remove excess water without wringing, reshape the garment and dry it flat away from direct heat or sunlight.\n\nAlways follow the garment care label because construction, trims, colour, and finishing can affect the correct method.\n\nCareful handling helps preserve shape, softness, and long-term product value."},{"label":"Pilling Care","reply":"Light pilling can occur naturally through friction. Remove it carefully with a suitable cashmere comb or fabric-care tool.\n\nAlways follow the garment care label because construction, trims, colour, and finishing can affect the correct method.\n\nCareful handling helps preserve shape, softness, and long-term product value."},{"label":"Storage","reply":"Store cashmere clean, folded and dry. Avoid hanging heavy knitwear for long periods.\n\nAlways follow the garment care label because construction, trims, colour, and finishing can affect the correct method.\n\nCareful handling helps preserve shape, softness, and long-term product value."}]},"/pages/kci-sizeguide":{"heading":"Size Guide","pills":[{"label":"Women's Sizing","reply":"Compare the published measurements with a similar garment that fits well. Product-specific fit may vary by silhouette and construction.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"Men's Sizing","reply":"Compare the published measurements with a well-fitting garment and allow for the intended regular, relaxed or oversized fit.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"How to Measure","reply":"Measure a similar garment laid flat and compare chest, body length, shoulder, sleeve and other relevant points with the size guide.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"Size Assistance","reply":"Please share the product name, your usual size and preferred fit.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly.","href":"/pages/kci-contact","cta":"Contact Support"}]},"/apps/track123":{"heading":"Order Tracking","pills":[{"label":"Track My Order","reply":"Use the tracking number supplied in your shipment confirmation to view the latest carrier update.\n\nDelivery and tracking remain subject to the selected carrier, destination, customs procedures, and local conditions.\n\nFor order-specific support, provide the order reference and tracking number without sharing sensitive payment information."},{"label":"Tracking Not Updated","reply":"Tracking can take time to update after dispatch or while a shipment is moving between carrier facilities.\n\nDelivery and tracking remain subject to the selected carrier, destination, customs procedures, and local conditions.\n\nFor order-specific support, provide the order reference and tracking number without sharing sensitive payment information."},{"label":"Delivery Question","reply":"Delivery timing depends on destination, carrier service and customs clearance. Please share the order reference and tracking number.\n\nDelivery and tracking remain subject to the selected carrier, destination, customs procedures, and local conditions.\n\nFor order-specific support, provide the order reference and tracking number without sharing sensitive payment information."},{"label":"Contact Support","reply":"Please share the order reference and tracking number.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel.","href":"/pages/kci-contact","cta":"Contact Kanchan Cashmere"}]},"/pages/kci-faq":{"heading":"Customer Support","pills":[{"label":"Orders","reply":"For order-specific support, please provide the order reference and the email address used at checkout.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"Shipping","reply":"Delivery timing depends on destination, carrier service and customs clearance.\n\nDelivery and tracking remain subject to the selected carrier, destination, customs procedures, and local conditions.\n\nFor order-specific support, provide the order reference and tracking number without sharing sensitive payment information."},{"label":"Product Care","reply":"Follow the care label, wash gently in cool water, reshape and dry flat, and store clean and folded.\n\nAlways follow the garment care label because construction, trims, colour, and finishing can affect the correct method.\n\nCareful handling helps preserve shape, softness, and long-term product value."},{"label":"Contact Support","reply":"Please share your question and order reference where applicable.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel.","href":"/pages/kci-contact","cta":"Contact Kanchan Cashmere"}]},"/pages/kci-contact":{"heading":"Contact Kanchan Cashmere","pills":[{"label":"Product Enquiry","reply":"Please share the product name or link and your question.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel."},{"label":"Private Label Enquiry","reply":"Please share the style direction, yarn preference, expected quantity and target delivery date.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel."},{"label":"Order Support","reply":"Please provide the order reference, email used for the order and a concise description of the issue.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"Email Kanchan Cashmere","reply":"You can contact Kanchan Cashmere at info@kanchancashmere.com.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly.","href":"mailto:info@kanchancashmere.com","cta":"Email Kanchan Cashmere"}]},"/pages/kci-shipping":{"heading":"Shipping & Delivery","pills":[{"label":"Delivery Times","reply":"Delivery timing depends on destination, carrier service, dispatch timing and customs clearance.\n\nDelivery and tracking remain subject to the selected carrier, destination, customs procedures, and local conditions.\n\nFor order-specific support, provide the order reference and tracking number without sharing sensitive payment information."},{"label":"International Shipping","reply":"International delivery is handled through the available carrier services for the destination and order.\n\nDelivery and tracking remain subject to the selected carrier, destination, customs procedures, and local conditions.\n\nFor order-specific support, provide the order reference and tracking number without sharing sensitive payment information."},{"label":"Duties & Taxes","reply":"Import duties and local taxes depend on the destination and applicable regulations.\n\nDelivery and tracking remain subject to the selected carrier, destination, customs procedures, and local conditions.\n\nFor order-specific support, provide the order reference and tracking number without sharing sensitive payment information."},{"label":"Track Order","reply":"Use the tracking number supplied in your shipment confirmation.\n\nDelivery and tracking remain subject to the selected carrier, destination, customs procedures, and local conditions.\n\nFor order-specific support, provide the order reference and tracking number without sharing sensitive payment information.","href":"/apps/track123","cta":"Open Tracking"}]},"/pages/kci-refund":{"heading":"Returns & Exchanges","pills":[{"label":"Return Eligibility","reply":"Return eligibility depends on the published policy, product condition, timing and product-specific exclusions.\n\nEligibility and procedure follow the published Returns & Exchanges policy and the condition of the item.\n\nContact support with the order reference before sending any item back."},{"label":"Exchange Process","reply":"Please contact support with the order reference, item and requested exchange. Availability and conditions must be confirmed.\n\nEligibility and procedure follow the published Returns & Exchanges policy and the condition of the item.\n\nContact support with the order reference before sending any item back."},{"label":"Return Instructions","reply":"Do not send a return without following the published instructions and receiving any required confirmation.\n\nEligibility and procedure follow the published Returns & Exchanges policy and the condition of the item.\n\nContact support with the order reference before sending any item back."},{"label":"Contact Support","reply":"Please share the order reference and reason for the return or exchange.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel.","href":"/pages/kci-contact","cta":"Contact Kanchan Cashmere"}]},"/pages/kci-terms":{"heading":"Business Terms","pills":[{"label":"MOQ & Sampling","reply":"Standard MOQ is 30 pieces per style and 10 pieces per colour. Sampling requirements, charges and timelines are confirmed for each programme.\n\nTechnical feasibility is reviewed against certified material availability, gauge, construction, measurements, finishing, quality requirements, quantity, and delivery timing.\n\nThe agreed route is confirmed before sampling or production begins."},{"label":"Payment Terms","reply":"Payment terms follow the current Kanchan Cashmere commercial policy and signed agreement. KCC does not negotiate or alter payment terms.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"Production Lead Time","reply":"Kanchan Cashmere’s standard minimum order quantity is 30 pieces per style, with a minimum of 10 pieces per colour.\n\nSample development normally requires 7–14 working days once certified materials, measurements, design direction, and technical inputs are confirmed. Bulk production typically requires 35–45 days, with a practical tolerance of ±5 days, from cleared advance payment, yarn readiness, final specification approval, and written production confirmation.\n\nThe final timeline is reviewed programme by programme and confirmed in writing before development or bulk production begins."},{"label":"Quality & Claims","reply":"Quality requirements, inspection standards and claim procedures follow the signed agreement, approved specifications and published B2B terms.\n\nControls cover certified material verification, knitting, linking, measurements, washing, finishing, labels, accessories, packing, and shipment readiness.\n\nKanchan Cashmere applies AQL 2.5 as its standard final inspection framework unless otherwise agreed in writing."}]},"/pages/kci-privacy-policy":{"heading":"Privacy","pills":[{"label":"Information Collected","reply":"The privacy policy explains information collected through the website, orders, enquiries and related services.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"How Data Is Used","reply":"Information is used for legitimate operational purposes such as processing orders, responding to enquiries and meeting legal obligations.\n\nKanchan Cashmere presents this guidance in the context of the actual product, order, or programme.\n\nWhere specific confirmation is required, the relevant material, technical, commercial, or policy record is reviewed directly."},{"label":"Cookies","reply":"The website may use cookies and similar technologies for functionality, analytics and service improvement as described in the policy.\n\nThe published policy, order record, or signed agreement remains the controlling document.\n\nKCC provides general guidance and does not replace the applicable legal or commercial terms."},{"label":"Contact","reply":"For a privacy-related question, please contact Kanchan Cashmere with a clear description of the request.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel.","href":"/pages/kci-contact","cta":"Contact Kanchan Cashmere"}]},"/pages/kci-tos":{"heading":"Terms of Service","pills":[{"label":"Website Terms","reply":"The Terms of Service govern use of the website and related services.\n\nThe published policy, order record, or signed agreement remains the controlling document.\n\nKCC provides general guidance and does not replace the applicable legal or commercial terms."},{"label":"Orders & Payments","reply":"Order acceptance, pricing, payment and fulfilment are subject to the applicable published terms and order confirmation.\n\nThe published policy, order record, or signed agreement remains the controlling document.\n\nKCC provides general guidance and does not replace the applicable legal or commercial terms."},{"label":"Intellectual Property","reply":"Website content, brand assets and other protected materials remain subject to the intellectual-property provisions in the Terms of Service.\n\nThe published policy, order record, or signed agreement remains the controlling document.\n\nKCC provides general guidance and does not replace the applicable legal or commercial terms."},{"label":"Contact","reply":"For clarification regarding the Terms of Service, please contact Kanchan Cashmere.\n\nPlease share the relevant design, certified material direction, quantity, size range, colour plan, and delivery window where applicable.\n\nKanchan Cashmere will review the information and confirm the most appropriate next step through the official channel.","href":"/pages/kci-contact","cta":"Contact Kanchan Cashmere"}]}};

  /* Current navigation and page architecture.
     These contexts cover the Library, Buyer Studio and Buyer Services destinations. */
  const kccProjectCta = {
    label: "Start a Project",
    reply: "Share the design direction or technical pack, certified material preference, target quantity, size range, colour plan and required delivery window. Kanchan Cashmere will review technical feasibility before confirming the development route.",
    href: "/pages/start-project",
    cta: "Start a Project"
  };
  const kccContactCta = {
    label: "Contact Kanchan Cashmere",
    reply: "For a specific product, programme or policy question, share the relevant reference and a concise description. The appropriate Kanchan Cashmere team will review it through the official contact channel.",
    href: "/pages/kci-contact",
    cta: "Contact Kanchan Cashmere"
  };
  const kccContext = (heading, pills) => ({ heading, pills: pills.slice(0, 4) });

  Object.assign(KCC_PAGE_CONTEXT, {
    "/pages/kci-business": kccContext("Private Buyer Portal", [
      { label: "Studio Overview", reply: "The Private Buyer Portal brings together design and development, materials and yarns, swatch references, manufacturing and quality, responsible production and the commercial framework in one buyer-focused environment." },
      { label: "Design & Development", reply: "Kanchan Cashmere supports design interpretation, yarn and gauge direction, stitch development, swatching, proto sampling, fit review and production-ready technical refinement." },
      { label: "Materials & Swatches", reply: "Buyers can review approved yarn directions and the Swatch Gallery as development references. Exact article, colour, certification, allocation and availability are confirmed for each programme." },
      kccProjectCta
    ]),
    "/pages/kci-buyer-studio": kccContext("Private Buyer Portal", [
      { label: "Studio Overview", reply: "The Private Buyer Portal is Kanchan Cashmere’s central environment for buyer development, material direction, swatches, manufacturing, quality and commercial guidance." },
      { label: "Swatch Gallery", reply: "Use the Swatch Gallery to review structures and development directions across relevant gauges. Final feasibility is confirmed against yarn, construction and programme requirements.", href: "/pages/kci-swatch-library", cta: "Open Swatch Gallery" },
      { label: "Commercial Framework", reply: "Standard MOQ is 30 pieces per style and 10 pieces per colour. Sampling normally requires 7–14 working days; bulk production normally requires 35–45 working days, with a practical tolerance of ±5 days, after required confirmations." },
      kccProjectCta
    ]),
    "/pages/start-project": kccContext("Start a Project", [
      { label: "Information to Prepare", reply: "Prepare the style reference or technical pack, certified material direction, gauge or target weight, size range, quantity by colour, finishing and packaging requirements, and target delivery window." },
      { label: "Sampling Route", reply: "Sampling normally requires 7–14 working days after the design direction, measurements, yarn and technical inputs are confirmed. Complex structures may require a swatch or construction trial first." },
      { label: "MOQ & Production", reply: "Standard MOQ is 30 pieces per style and 10 pieces per colour. Bulk production normally requires 35–45 working days, with a practical tolerance of ±5 days, after cleared payment, yarn readiness and written approvals." },
      kccContactCta
    ]),
    "/pages/start-a-project": kccContext("Start a Project", [
      { label: "Information to Prepare", reply: "Prepare the style reference or technical pack, certified material direction, gauge or target weight, size range, quantity by colour, finishing and packaging requirements, and target delivery window." },
      { label: "Sampling Route", reply: "Sampling normally requires 7–14 working days after the design direction, measurements, yarn and technical inputs are confirmed." },
      { label: "MOQ & Production", reply: "Standard MOQ is 30 pieces per style and 10 pieces per colour. The final production schedule is confirmed programme by programme." },
      kccContactCta
    ]),
    "/pages/kci-luxury-knitwear-manufacturing": kccContext("Luxury Knitwear Manufacturing", [
      { label: "Manufacturing Capability", reply: "Kanchan Cashmere combines computerized knitting from 3GG to 16GG with specialist linking, washing, blocking, finishing, handwork and structured quality control in Kathmandu." },
      { label: "Product Scope", reply: "Programmes may include sweaters, cardigans, dresses, trousers, scarves, shawls, outerwear, accessories and other technically feasible luxury knitwear." },
      { label: "Production Timeline", reply: "Bulk production normally requires 35–45 working days, with a practical tolerance of ±5 days, after cleared payment, yarn readiness, final specifications and written production approval." },
      kccProjectCta
    ]),
    "/pages/kci-quality-assurance": kccContext("Quality Assurance", [
      { label: "AQL 2.5", reply: "Kanchan Cashmere applies AQL 2.5 as its standard final inspection framework unless another written standard is agreed for the programme." },
      { label: "Quality Checkpoints", reply: "Controls cover certified material verification, knitting, linking, measurements, washing, finishing, labels, accessories, packing and shipment readiness." },
      { label: "Approved Specification", reply: "Final quality is assessed against the approved sample, measurements, construction, colour, finish, labels, packaging and buyer-specific written requirements." },
      kccProjectCta
    ]),
    "/pages/kci-certified-yarns": kccContext("Certified Yarns", [
      { label: "Yarn Partners", reply: "Public yarn partners include Cariaggi, Consinee and Top Line. Exact supplier selection depends on the required article, composition, count, colour, certification and availability." },
      { label: "Material Directions", reply: "Available development directions include pure cashmere, recycled cashmere, baby cashmere, brushed cashmere, cashmere-silk and selected luxury blends, subject to current supplier documentation." },
      { label: "Certification Scope", reply: "Certification applies to the specific yarn article, supplier documentation and programme scope. KCC does not extend a certification claim beyond the verified record." },
      kccProjectCta
    ]),
    "/pages/kci-packaging-solutions": kccContext("Packaging Solutions", [
      { label: "Packaging Programme", reply: "Packaging can be coordinated according to the product, brand presentation, destination, shipment method and agreed sustainability requirements." },
      { label: "Labels & Accessories", reply: "Custom labels, hangtags and approved accessories are reviewed for specification, compliance, lead time, MOQ and supplier availability before production." },
      { label: "Shipment Readiness", reply: "Packing is checked against the approved assortment, folding, labelling, carton, documentation and shipment instructions before release." },
      kccProjectCta
    ]),
    "/pages/kci-excellences": kccContext("Our Excellences", [
      { label: "Manufacturing Excellence", reply: "Manufacturing excellence combines technical knitting, specialist craftsmanship, process discipline and realistic production planning." },
      { label: "Quality Assurance", reply: "Quality is controlled from material verification and development through measurements, finishing, AQL 2.5 final inspection and shipment readiness.", href: "/pages/kci-standards", cta: "View Quality Assurance" },
      { label: "Certified Yarns", reply: "Certified material selection is aligned to the specific yarn article, supplier documentation, lot, colour availability and programme requirements. A supplier scope certificate does not by itself establish that every delivered yarn or finished garment carries that claim; programme-specific documentation is confirmed where required.", href: "/pages/kci-sourcing", cta: "View Certified Yarns" },
      { label: "Responsible Production", reply: "Responsible production is supported through verified inputs, considered processes, disciplined quality control and programme-specific documentation." }
    ]),
    "/pages/the-library": kccContext("The Library", [
      { label: "Materials", reply: "Explore fibre, yarn count, composition, certification and material-selection principles for luxury knitwear development.", href: "/pages/library-materials", cta: "Explore Materials" },
      { label: "Development", reply: "Explore the route from concept, yarn and gauge selection through swatches, prototypes, fit review and approval.", href: "/pages/library-development", cta: "Explore Development" },
      { label: "Manufacturing", reply: "Explore knitting, linking, washing, finishing and production-control fundamentals.", href: "/pages/library-manufacturing", cta: "Explore Manufacturing" },
      { label: "Browse All Categories", reply: "The Library contains ten knowledge categories: Materials, Development, Manufacturing, Knit Engineering, Quality, Sustainability, Business & Sourcing, Care & Maintenance, Inspiration and Why Nepal." }
    ]),
    "/pages/kci-library-materials": kccContext("Library · Materials", [
      { label: "Cashmere & Blends", reply: "Material selection considers fibre composition, yarn count, gauge, target weight, handfeel, drape, structure, performance and commercial requirements." },
      { label: "Certified Yarns", reply: "Certification claims must remain aligned with the specific yarn article, supplier documentation, lot and programme scope. Finished-product or labelled claims are confirmed only where the required supporting documentation is available.", href: "/pages/kci-sourcing", cta: "View Certified Yarns" },
      { label: "Yarn & Gauge", reply: "Yarn count and gauge are assessed together because they affect weight, stitch definition, stability, drape, consumption and surface character." },
      kccProjectCta
    ]),
    "/pages/kci-library-development": kccContext("Library · Development", [
      { label: "From Brief to Proto", reply: "Development moves through brief review, material and gauge direction, swatching where required, proto sampling, measurements, fit comments and final approval." },
      { label: "Sampling Timeline", reply: "Sampling normally requires 7–14 working days after required technical inputs and material direction are confirmed." },
      { label: "Approval Discipline", reply: "Bulk production should begin only after the approved sample, measurements, yarn, colour, construction, labels, packaging and commercial terms are confirmed in writing." },
      kccProjectCta
    ]),
    "/pages/kci-library-manufacturing": kccContext("Library · Manufacturing", [
      { label: "Knitting to Finishing", reply: "Manufacturing includes knitting, linking, washing, blocking, finishing, measurement control, labels, packing and final inspection." },
      { label: "3GG–16GG", reply: "Gauge selection influences structure, weight, stitch definition, drape, production method and yarn consumption." },
      { label: "Production Control", reply: "Consistent production depends on approved specifications, yarn-lot control, in-process checks and disciplined final inspection." },
      kccProjectCta
    ]),
    "/pages/kci-library-knit-engineering": kccContext("Library · Knit Engineering", [
      { label: "Structure & Gauge", reply: "Knit engineering coordinates yarn, gauge, stitch structure, tension, shaping and finishing to achieve the intended appearance and performance." },
      { label: "Fully Fashioned Construction", reply: "Fully fashioned development uses shaped knitted components and controlled linking to support proportion, finish and material efficiency." },
      { label: "Complex Structures", reply: "Cable, rib, Milano, tuck, pointelle, jacquard, intarsia, lace and other structures are validated according to yarn behaviour and technical feasibility." },
      kccProjectCta
    ]),
    "/pages/kci-library-quality": kccContext("Library · Quality", [
      { label: "Quality Framework", reply: "Quality begins with the approved specification and continues through material, knitting, construction, measurements, washing, finishing and packing controls." },
      { label: "AQL 2.5", reply: "AQL 2.5 is Kanchan Cashmere’s standard final inspection framework unless otherwise agreed in writing." },
      { label: "Fit & Measurement", reply: "Fit and measurement control should reference the approved sample and agreed tolerance table for the specific style." },
      { label: "Quality Assurance", reply: "Review Kanchan Cashmere’s operational quality checkpoints.", href: "/pages/kci-standards", cta: "View Quality Assurance" }
    ]),
    "/pages/kci-library-sustainability": kccContext("Library · Sustainability", [
      { label: "Verified Claims", reply: "Responsible material and certification claims must be supported by the specific supplier or programme documentation." },
      { label: "Responsible Production", reply: "Responsible production includes considered material selection, process control, durability, waste awareness and programme-appropriate packaging." },
      { label: "Traceability", reply: "Traceability depends on maintaining clear supplier, yarn article, lot, production and shipment records for the agreed programme." },
      kccContactCta
    ]),
    "/pages/kci-library-business-sourcing": kccContext("Library · Business & Sourcing", [
      { label: "MOQ & Costing", reply: "Standard MOQ is 30 pieces per style and 10 pieces per colour. Costing depends on yarn, consumption, construction, workmanship, finishing, labels, packaging and volume." },
      { label: "Supplier & Yarn Selection", reply: "Sourcing decisions consider certification, quality, article continuity, colour availability, lead time, allocation and target commercial position." },
      { label: "Lead-Time Planning", reply: "Programme timing should allow for yarn readiness, sampling, approvals, bulk production, quality control and shipment preparation." },
      kccProjectCta
    ]),
    "/pages/kci-library-care-maintenance": kccContext("Library · Care & Maintenance", [
      { label: "Washing", reply: "Follow the garment care label. Where suitable, use cool water and specialist wool or cashmere detergent, handle gently and avoid rubbing or twisting." },
      { label: "Drying & Storage", reply: "Reshape and dry flat away from direct heat. Store cashmere clean, dry and folded rather than hanging heavy knitwear." },
      { label: "Pilling", reply: "Light pilling may occur naturally through friction and can be removed carefully with an appropriate cashmere comb or fabric-care tool." },
      { label: "Care Guide", reply: "Product-specific construction, trims and finishing can affect the correct care method.", href: "/pages/kci-cashmere-care", cta: "View Cashmere Care" }
    ]),
    "/pages/kci-library-inspiration": kccContext("Library · Inspiration", [
      { label: "Material Direction", reply: "Inspiration becomes commercially useful when material, gauge, structure, proportion, colour and finishing are translated into a technically clear direction." },
      { label: "Design References", reply: "A mood board, sketch, reference garment or image can establish direction, but the final development must be original and technically validated." },
      { label: "Seasonal Development", reply: "Seasonal development balances creative direction with yarn availability, lead time, target market, quantity and production feasibility." },
      kccProjectCta
    ]),
    "/pages/kci-library-why-nepal": kccContext("Library · Why Nepal", [
      { label: "Nepalese Craft", reply: "Nepal offers skilled knitwear handwork, adaptable development and a longstanding relationship with cashmere production." },
      { label: "Modern Capability", reply: "Kanchan Cashmere combines Nepalese craft strengths with computerized knitting from 3GG to 16GG, export systems and structured quality control." },
      { label: "Integrated Development", reply: "International buyers can work through one route from design and material direction to sampling, production, quality and shipment preparation." },
      kccProjectCta
    ])
  });

  // Handle aliases retained so navigation or page-handle refinements do not
  // silently remove page-aware KCC guidance.
  KCC_PAGE_CONTEXT["/pages/kci-library"] = KCC_PAGE_CONTEXT["/pages/the-library"];
  KCC_PAGE_CONTEXT["/pages/kci-library-home"] = KCC_PAGE_CONTEXT["/pages/the-library"];
  KCC_PAGE_CONTEXT["/pages/library-materials"] = KCC_PAGE_CONTEXT["/pages/kci-library-materials"];
  KCC_PAGE_CONTEXT["/pages/library-development"] = KCC_PAGE_CONTEXT["/pages/kci-library-development"];
  KCC_PAGE_CONTEXT["/pages/library-manufacturing"] = KCC_PAGE_CONTEXT["/pages/kci-library-manufacturing"];
  KCC_PAGE_CONTEXT["/pages/library-knit-engineering"] = KCC_PAGE_CONTEXT["/pages/kci-library-knit-engineering"];
  KCC_PAGE_CONTEXT["/pages/library-quality"] = KCC_PAGE_CONTEXT["/pages/kci-library-quality"];
  KCC_PAGE_CONTEXT["/pages/library-sustainability"] = KCC_PAGE_CONTEXT["/pages/kci-library-sustainability"];
  KCC_PAGE_CONTEXT["/pages/library-business-sourcing"] = KCC_PAGE_CONTEXT["/pages/kci-library-business-sourcing"];
  KCC_PAGE_CONTEXT["/pages/library-care-maintenance"] = KCC_PAGE_CONTEXT["/pages/kci-library-care-maintenance"];
  KCC_PAGE_CONTEXT["/pages/library-inspiration"] = KCC_PAGE_CONTEXT["/pages/kci-library-inspiration"];
  KCC_PAGE_CONTEXT["/pages/library-whynepal"] = KCC_PAGE_CONTEXT["/pages/kci-library-why-nepal"];
  KCC_PAGE_CONTEXT["/pages/kci-library-business"] = KCC_PAGE_CONTEXT["/pages/kci-library-business-sourcing"];
  KCC_PAGE_CONTEXT["/pages/kci-library-care"] = KCC_PAGE_CONTEXT["/pages/kci-library-care-maintenance"];
  KCC_PAGE_CONTEXT["/pages/quality-assurance"] = KCC_PAGE_CONTEXT["/pages/kci-quality-assurance"];
  KCC_PAGE_CONTEXT["/pages/certified-yarns"] = KCC_PAGE_CONTEXT["/pages/kci-certified-yarns"];
  KCC_PAGE_CONTEXT["/pages/packaging-solutions"] = KCC_PAGE_CONTEXT["/pages/kci-packaging-solutions"];
  KCC_PAGE_CONTEXT["/pages/luxury-knitwear-manufacturing"] = KCC_PAGE_CONTEXT["/pages/kci-luxury-knitwear-manufacturing"];
  KCC_PAGE_CONTEXT["/pages/kci-standards"] = KCC_PAGE_CONTEXT["/pages/kci-quality-assurance"];
  KCC_PAGE_CONTEXT["/pages/kci-sourcing"] = KCC_PAGE_CONTEXT["/pages/kci-certified-yarns"];
  KCC_PAGE_CONTEXT["/pages/kci-packing-solutions"] = KCC_PAGE_CONTEXT["/pages/kci-packaging-solutions"];
  KCC_PAGE_CONTEXT["/pages/kci-manufacturing"] = KCC_PAGE_CONTEXT["/pages/kci-luxury-knitwear-manufacturing"];
  KCC_PAGE_CONTEXT["/pages/kci-production-excellence"] = KCC_PAGE_CONTEXT["/pages/kci-luxury-knitwear-manufacturing"];

  // Current Our Excellences navigation.
  KCC_PAGE_CONTEXT["/pages/kci-materials"] = KCC_PAGE_CONTEXT["/pages/kci-materials"] || KCC_PAGE_CONTEXT["/pages/kci-certified-yarns"];
  KCC_PAGE_CONTEXT["/pages/kci-craftsmanship"] = KCC_PAGE_CONTEXT["/pages/kci-craftsmanship"] || KCC_PAGE_CONTEXT["/pages/kci-luxury-knitwear-manufacturing"];
  KCC_PAGE_CONTEXT["/pages/kci-traceability"] = KCC_PAGE_CONTEXT["/pages/kci-traceability"] || KCC_PAGE_CONTEXT["/pages/kci-library-sustainability"];
  KCC_PAGE_CONTEXT["/pages/kci-responsibility"] = KCC_PAGE_CONTEXT["/pages/kci-responsibility"] || KCC_PAGE_CONTEXT["/pages/kci-library-sustainability"];

  // Current The Kanchan navigation; existing detailed contexts remain primary
  // wherever the same page already has purpose-written KCC content.
  KCC_PAGE_CONTEXT["/pages/kci-the-kanchan"] = KCC_PAGE_CONTEXT["/pages/kci-the-kanchan"] || KCC_PAGE_CONTEXT["/pages/our-story"];
  KCC_PAGE_CONTEXT["/pages/kanchan-heritage"] = KCC_PAGE_CONTEXT["/pages/kanchan-heritage"] || KCC_PAGE_CONTEXT["/pages/our-story"];
  KCC_PAGE_CONTEXT["/pages/kanchan-philosophy"] = KCC_PAGE_CONTEXT["/pages/kanchan-philosophy"] || KCC_PAGE_CONTEXT["/pages/kci-essence"];
  KCC_PAGE_CONTEXT["/pages/kanchan-innovation"] = KCC_PAGE_CONTEXT["/pages/kanchan-innovation"] || KCC_PAGE_CONTEXT["/pages/kci-vision"];
  KCC_PAGE_CONTEXT["/pages/kanchan-people"] = KCC_PAGE_CONTEXT["/pages/kanchan-people"] || KCC_PAGE_CONTEXT["/pages/our-story"];

  const KCC_HOME_ACTIONS = [
    {
      label: "Explore Collections",
      href: "/pages/kci-shop"
    },
    {
      label: "Our Craftsmanship",
      reply: "Every Kanchan Cashmere garment begins with material integrity, considered construction, and the judgement of skilled craftspeople.\n\nOur production combines precise computerized knitting from 3GG to 16GG with specialist linking, washing, blocking, finishing, and handwork in Nepal. Each stage is controlled to develop the intended proportion, surface, handfeel, and dimensional stability.\n\nLuxury is expressed through quiet precision: clean linking, balanced shaping, measured finishing, and quality control that respects both the fibre and the buyer’s approved standard."
    },
    {
      label: "Private Label & Production",
      reply: "Kanchan Cashmere develops and manufactures refined private-label knitwear for boutique retailers, independent designers, and established luxury brands.\n\nWe support the complete programme from design interpretation, certified yarn and accessory selection, swatch development, and proto sampling through fit approval, bulk production, AQL 2.5 quality control, custom labelling, packaging coordination, and shipment preparation.\n\nStandard production begins from 30 pieces per style and 10 pieces per colour. Sampling normally requires 7–14 working days, while bulk production is planned within 35–45 days, with a practical tolerance of ±5 days, after yarn readiness, approvals, and commercial confirmation."
    },
    {
      label: "Speak with Kanchan Cashmere",
      href: "/pages/kci-contact"
    }
  ];

  function homepagePromptItems() {
    if (normalizedPath() !== "/") return null;
    if (!kccIsGerman()) return KCC_HOME_ACTIONS;
    return KCC_HOME_ACTIONS.map((item) => Object.assign({}, item, {
      label: localizedKccText(item.label),
      cta: item.cta ? localizedKccText(item.cta) : item.cta
    }));
  }

  function currentPageContext() { return KCC_PAGE_CONTEXT[normalizedPath()] || null; }
  function pageContextPromptItems() {
    const c = currentPageContext();
    if (!c || !Array.isArray(c.pills)) return null;
    const items = c.pills.slice(0, 4);
    if (!kccIsGerman()) return items;
    return items.map((item) => Object.assign({}, item, {
      label: localizedKccText(item.label || ""),
      cta: item.cta ? localizedKccText(item.cta) : item.cta
    }));
  }
  function pageContextPromptByLabel(label) {
    const k = String(label || "").trim().toLowerCase();
    const rawContext = currentPageContext();
    const rawItems = rawContext && Array.isArray(rawContext.pills)
      ? rawContext.pills.slice(0, 4)
      : (normalizedPath() === "/" ? KCC_HOME_ACTIONS : []);
    for (const item of rawItems) {
      const en = String(item && item.label || "").trim().toLowerCase();
      const de = String(localizedKccText(item && item.label || "")).trim().toLowerCase();
      if (en === k || de === k) {
        return Object.assign({}, item, {
          label: kccIsGerman() ? localizedKccText(item.label || "") : item.label,
          cta: item.cta && kccIsGerman() ? localizedKccText(item.cta) : item.cta
        });
      }
    }
    return null;
  }
  function buildContextReplyHtml(item) {
    if (!item) return "";
    const paragraphs = String(item.reply || "")
      .split(/\n\s*\n/)
      .map((part) => String(part || "").trim())
      .filter(Boolean)
      .map((part) => `<p class="kcc-contextParagraph">${safeText(part)}</p>`)
      .join("");
    if (!item.href) return `<div class="kcc-contextReply">${paragraphs}</div>`;
    return `<div class="kcc-contextReply">${paragraphs}</div><a class="kcc-collectionCta" href="${safeText(localizedInternalHref(item.href))}">${safeText(localizedKccText(item.cta || "Learn More"))} <span aria-hidden="true">→</span></a>`;
  }

  function shopifyPageMarker() {
    try {
      const bodyClass = document.body ? String(document.body.className || "").toLowerCase() : "";
      const htmlClass = document.documentElement ? String(document.documentElement.className || "").toLowerCase() : "";
      const og = document.querySelector('meta[property="og:type"]');
      const ogType = og ? String(og.getAttribute("content") || "").toLowerCase() : "";
      const marker = `${bodyClass} ${htmlClass}`;
      if (ogType === "product" || /(?:^|\s)(?:template-)?product(?:\s|$|--)/.test(marker)) return "product";
      if (/(?:^|\s)(?:template-)?collection(?:\s|$|--)/.test(marker)) return "collection";
    } catch (_) {}
    return "";
  }

  const KCC_BUYER_PATHS = new Set([
    // Buyer Studio / operational B2B intake
    "/pages/buyer-studio",
    "/pages/kci-buyer-studio",
    "/pages/kci-business",
    "/pages/start-project",
    "/pages/start-a-project",
    "/pages/production-portal",
    "/pages/swatch-gallery",
    "/pages/kci-swatch-library",

    // Current Buyer Services / footer
    "/pages/kci-buyer-partnership",
    "/pages/buyer-partnerships",
    "/pages/kci-private-label",
    "/pages/private-label",
    "/pages/kci-design-studio",
    "/pages/kci-sampling-development",
    "/pages/sampling-development",
    "/pages/kci-development-process",
    "/pages/development-process",
    "/pages/kci-luxury-knitwear-manufacturing",
    "/pages/luxury-knitwear-manufacturing",
    "/pages/cashmere-production",
    "/pages/kci-manufacturing",
    "/pages/manufacturing-excellence",
    "/pages/kci-production-excellence",
    "/pages/kci-packaging-solutions",
    "/pages/kci-packing-solutions",
    "/pages/packaging-solutions",
    "/pages/kci-ethical-production",
    "/pages/ethical-production",
    "/pages/kci-terms",
    "/pages/terms-conditions-b2b",
    "/pages/kci-sample-request",
    "/pages/kci-work-with-us",
    "/pages/custom-made",
    "/pages/product-services",
    "/pages/capabilities",
    "/pages/kci-capabilities",

    // Current Our Excellences / technical buyer-facing pages
    "/pages/kci-excellences",
    "/pages/kci-materials",
    "/pages/materials",
    "/pages/kci-certified-yarns",
    "/pages/certified-yarns",
    "/pages/kci-sourcing",
    "/pages/kci-craftsmanship",
    "/pages/kci-quality-knitwear",
    "/pages/kci-quality-assurance",
    "/pages/quality-assurance",
    "/pages/kci-standards",
    "/pages/standards",
    "/pages/kci-traceability",
    "/pages/traceability",
    "/pages/kci-responsibility",
    "/pages/responsibility",
    "/pages/kci-why-nepal",
    "/pages/why-nepal",
    "/pages/production-of-cashmere"
  ]);

  const KCC_PRIVATE_PATHS = new Set([
    // Brand / The Kanchan / footer company pages
    "/pages/kci-about",
    "/pages/our-story",
    "/pages/kci-essence",
    "/pages/kci-sustainability",
    "/pages/kci-vision",
    "/pages/kci-the-kanchan",
    "/pages/kanchan-heritage",
    "/pages/kanchan-philosophy",
    "/pages/kanchan-innovation",
    "/pages/kanchan-people",

    // The Library master + all knowledge categories
    "/pages/the-library",
    "/pages/kci-library",
    "/pages/kci-library-home",
    "/pages/kci-library-materials",
    "/pages/library-materials",
    "/pages/kci-library-development",
    "/pages/library-development",
    "/pages/kci-library-manufacturing",
    "/pages/library-manufacturing",
    "/pages/kci-library-knit-engineering",
    "/pages/library-knit-engineering",
    "/pages/kci-library-quality",
    "/pages/library-quality",
    "/pages/kci-library-sustainability",
    "/pages/library-sustainability",
    "/pages/kci-library-business-sourcing",
    "/pages/kci-library-business",
    "/pages/library-business-sourcing",
    "/pages/kci-library-care-maintenance",
    "/pages/kci-library-care",
    "/pages/library-care-maintenance",
    "/pages/kci-library-inspiration",
    "/pages/library-inspiration",
    "/pages/kci-library-why-nepal",
    "/pages/library-whynepal",

    // Customer Care / information / policies
    "/pages/cashmere-care",
    "/pages/kci-cashmere-care",
    "/pages/pilling-remover",
    "/pages/kci-sizeguide",
    "/pages/size-guide",
    "/pages/kci-faq",
    "/pages/faqs",
    "/pages/kci-contact",
    "/pages/delivery-policy",
    "/pages/kci-shipping",
    "/pages/shipping",
    "/pages/track-trace",
    "/pages/order-tracking",
    "/pages/track-order",
    "/pages/kci-refund",
    "/pages/returns",
    "/pages/kci-privacy-policy",
    "/pages/kci-tos"
  ]);

  const KCC_EDITORIAL_COLLECTIONS = new Set([
    "/collections/our-story",
    "/collections/the-source-of-our-cashmere",
    "/collections/sustainability",
    "/collections/sustainability-1",
    "/collections/our-world"
  ]);

  function isSwatchBuyerRoute(path) {
    const p = String(path || normalizedPath());
    if (p === "/collections/swatch-library") return true;
    return /^\/products\/(?:cashmere-swatch|swatch-\d+)(?:\/|$)/.test(p);
  }

  function isBuyerPage() {
    const p = normalizedPath();
    if (KCC_BUYER_PATHS.has(p) || isSwatchBuyerRoute(p)) return true;

    // Preserve controlled compatibility for future B2B handles without
    // turning ordinary content pages into Buyer Concierge.
    if (/^\/pages\/(?:buyer|b2b|wholesale)(?:-|\/|$)/.test(p)) return true;

    // Purpose-written B2B editorial articles only.
    if (/^\/blogs\/news\/.*(?:cashmere-program|cashmere-manufactur|knit-production|sweater-orders|sweaters-in-bulk|boutique-luxury-brands|serious-cashmere-brands|serious-brands|precision-in-luxury|develop-a-cashmere-collection|architecture-of-luxury|nepal-for-luxury-cashmere|italian-yarns-nepali-craftsmanship|art-of-cashmere-production)/.test(p)) return true;

    return false;
  }

  // Backward-compatible name used elsewhere in KCC.
  function isProgrammePage() {
    return isBuyerPage();
  }

  function pageFamily() {
    const p = normalizedPath();
    const marker = shopifyPageMarker();

    // 1. Home is always resolved first — EN / and DE /de both normalize to /.
    if (p === "/") return "home";

    // 2. Buyer swatches are deliberate exceptions to normal commerce routing.
    if (isSwatchBuyerRoute(p)) return "buyer";

    // 3. Actual product context has priority over a surrounding collection URL.
    if (marker === "product" || /\/products\//.test(p)) return "product";

    // 4. Editorial collections are knowledge/brand content, not retail shopping.
    if (KCC_EDITORIAL_COLLECTIONS.has(p)) return "private";

    // 5. Retail collections.
    if (marker === "collection" || /^\/collections(?:\/|$)/.test(p)) return "collection";

    // 6. Current Buyer Studio, Buyer Services and Our Excellences.
    if (isBuyerPage()) return "buyer";

    // 7. Explicit private/customer/knowledge routes and all other pages.
    if (KCC_PRIVATE_PATHS.has(p)) return "private";

    // Search, cart, account, ordinary blogs and unmapped pages are intentionally
    // Private Concierge rather than Collection Concierge.
    return "private";
  }

  function pageRole() {
    const family = pageFamily();
    if (family === "buyer") return "buyer";
    if (family === "product" || family === "collection") return "d2c";
    return "hybrid";
  }

  function visibleConciergeLabel(role, forBubble) {
    const family = pageFamily();
    const de = kccIsGerman();

    if (family === "home") return de ? "Alles fragen" : "Ask Anything";
    if (family === "buyer") return de ? "Käufer Concierge" : "Buyer Concierge";
    if (family === "product") return de ? "Produkt Concierge" : "Product Concierge";
    if (family === "collection") return de ? "Kollektion Concierge" : "Collection Concierge";
    return de ? "Privater Concierge" : "Private Concierge";
  }

  function isBuyerTermsPage() {
    const p = normalizedPath();
    return p === "/pages/kci-terms" || p === "/pages/terms-conditions-b2b";
  }

  function isProgrammeIntent(text) {
    const s = String(text || "").toLowerCase();
    const kw = [
      "moq",
      "fob",
      "bulk",
      "program",
      "programme",
      "sampling",
      "sample",
      "lead time",
      "leadtime",
      "production",
      "development",
      "costing",
      "tech pack",
      "techpack",
      "nm",
      "gg",
      "gauge",
      "pcs",
      "qty",
      "quantity",
      "incoterm",
      "tt",
      "advance",
      "custom design",
      "custom designs",
      "private label",
      "place order",
      "place an order",
      "want to order",
      "we want to place",
      "mindestbestellmenge", "mindestmenge", "produktion", "muster", "bemusterung",
      "lieferzeit", "vorlaufzeit", "großhandel", "grosshandel", "private label",
      "stück", "stueck", "menge", "garn", "maschenfeinheit", "kollektionsentwicklung",
      "angebot", "kalkulation", "bestellung", "auftrag"
    ];
    return kw.some((k) => s.includes(k));
  }

  function isD2CIntent(text) {
    const s = String(text || "").toLowerCase();
    const kw = [
      "shop", "buy", "add to bag", "add to cart", "product", "collection",
      "sweater", "jumper", "cardigan", "scarf", "shawl", "wrap", "poncho",
      "dress", "robe", "size", "fit", "warm", "care", "wash", "pilling",
      "gift", "delivery", "shipping", "return", "refund", "exchange", "my order",
      "kaufen", "einkaufen", "produkt", "kollektion", "pullover", "strickjacke",
      "schal", "größe", "groesse", "passform", "pflege", "waschen", "pilling",
      "geschenk", "lieferung", "versand", "rückgabe", "rueckgabe", "erstattung",
      "umtausch", "meine bestellung"
    ];
    return kw.some((k) => s.includes(k));
  }

  let kccIntent = "support"; // "support" | "programmes"
  let kccRole = "hybrid"; // "buyer" | "d2c" | "hybrid"

  function setRoleContext(nextRole) {
    const role = nextRole === "buyer" || nextRole === "d2c" || nextRole === "hybrid"
      ? nextRole
      : pageRole();
    kccRole = role;
    kccIntent = role === "buyer" ? "programmes" : "support";
    try {
      const de = kccIsGerman();
      panel.setAttribute("data-kcc-role", role);
      const uiLabel = visibleConciergeLabel(role, false);
      const mappedContext = currentPageContext();

      // Header subtitle is the active KCC mode. Page-specific context belongs in
      // the greeting/pills, so Buyer Studio never masquerades as the mode name.
      if (SUB) SUB.textContent = uiLabel;
      const family = pageFamily();
      if (CUE) CUE.textContent = family === "buyer"
        ? (de ? "Programme • Sampling • Produktion" : "Programmes • Sampling • Production")
        : family === "product"
          ? (de ? "Produkt • Größe • Pflege" : "Product • Sizing • Care")
          : family === "collection"
            ? (de ? "Kollektion • Größe • Pflege" : "Collection • Sizing • Care")
            : family === "home"
              ? (de ? "Kollektionen • Handwerk • Private Label" : "Collections • Craftsmanship • Private Label")
              : (de ? "Information • Pflege • Kontakt" : "Information • Care • Contact");

      if (INPUT) INPUT.placeholder = family === "buyer"
        ? (de ? "Fragen Sie zu Sampling oder Produktion …" : "Ask about sampling or production…")
        : family === "product"
          ? (de ? "Fragen Sie zu diesem Produkt …" : "Ask about this piece…")
          : family === "collection"
            ? (de ? "Fragen Sie zu Modellen, Größen oder Pflege …" : "Ask about styles, sizing or care…")
            : (de ? "Fragen Sie KCC ..." : "Ask KCC anything…");
      panel.setAttribute("aria-label", `Kanchan Cashmere ${uiLabel}`);
      panel.setAttribute("data-kcc-page-mode", role);
      const bubbleRole = bubble && bubble.querySelector
        ? bubble.querySelector('[data-kcc-bubble-role="1"]')
        : null;
      const bubbleRoleLabel = visibleConciergeLabel(role, true);
      if (bubbleRole) bubbleRole.textContent = bubbleRoleLabel;
      if (bubble) bubble.setAttribute("aria-label", `${de ? "KCC öffnen" : "Open KCC"} ${bubbleRoleLabel}`);
      applyBubblePresentation();
      trackKccEvent(`Mode ${bubbleRoleLabel}`, `mode:${normalizedPath()}:${bubbleRoleLabel}`);
    } catch (_) {}
  }

  function inferTurnRole(text) {
    const family = pageFamily();

    // Buyer pages remain Buyer Concierge regardless of casual product wording.
    if (family === "buyer") return "buyer";

    // Strong B2B intent may escalate from Home/Private/Product/Collection.
    if (isProgrammeIntent(text) || hasB2BProductionIntent(text)) return "buyer";

    // Product / collection context remains D2C unless the question is B2B.
    if (family === "product" || family === "collection") return "d2c";

    // Explicit retail intent on Home/Private can temporarily use D2C answer logic,
    // while the visible page-mode label remains tied to the actual page family.
    if (isD2CIntent(text)) return "d2c";

    return "hybrid";
  }

  function applyHeaderContext(forceProgramme) {
    setRoleContext(forceProgramme ? "buyer" : pageRole());
    enforceLocalizedKccLinks(panel);
  }

  /* ---------------------------------------------------------------------------
     BUBBLE VISIBILITY (SCROLL-REVEAL + FORCE-HIDE WHEN PANEL OPEN)
  --------------------------------------------------------------------------- */
  let panelOpen = false;

  function bubbleEnabledFromTheme() {
    try {
      const live = getThemeCfg();
      const byTheme = !(live && live.ux && live.ux.bubbleEnabled === false);
      const byLiquid =
        !(document.documentElement && document.documentElement.hasAttribute("data-kcc-hide-bubble")) &&
        !(document.body && document.body.classList && document.body.classList.contains("kcc-hide-bubble"));
      return byTheme && byLiquid;
    } catch (_) {
      return true;
    }
  }

  function enforceBubbleLabel() {
    try {
      const lbl =
        bubble && bubble.querySelector ? bubble.querySelector('[data-kcc-bubble-label="1"]') : null;
      if (lbl) lbl.textContent = BUBBLE_LABEL_LOCK;
      bubble.setAttribute("data-kcc-label", BUBBLE_LABEL_LOCK);
      applyBubblePresentation();
    } catch (_) {}
  }

  function applyBubblePresentation() {
    if (!bubble || !bubble.style) return;
    let mobile = false;
    try {
      mobile = !!(window.matchMedia && window.matchMedia("(max-width: 767px)").matches);
    } catch (_) {
      mobile = (window.innerWidth || 0) <= 767;
    }

    let label = "";
    try {
      const labelNode = bubble.querySelector('[data-kcc-bubble-role="1"]');
      label = labelNode ? String(labelNode.textContent || "").trim().toLowerCase() : "";
    } catch (_) {}
    const desktopWidths = {
      "ask anything": "190px",
      "product concierge": "224px",
      "buyer concierge": "210px",
      "private concierge": "216px",
      "collection concierge": "238px",
      "alles fragen": "190px",
      "produkt concierge": "224px",
      "kollektion concierge": "238px"
    };
    const width = mobile ? "52px" : (desktopWidths[label] || "224px");
    try {
      bubble.style.setProperty("width", width, "important");
      bubble.style.setProperty("min-width", width, "important");
      bubble.style.setProperty("height", "52px", "important");
      bubble.style.setProperty("min-height", "52px", "important");
      bubble.style.setProperty("padding", mobile ? "5px" : "5px 15px 5px 5px", "important");
      bubble.style.setProperty("border-radius", "999px", "important");
      bubble.style.setProperty("background", "#ffffff", "important");
      bubble.style.setProperty("background-image", "none", "important");
      bubble.style.setProperty("text-indent", "0", "important");
    } catch (_) {}
  }

  try {
    window.addEventListener("resize", applyBubblePresentation, { passive: true });
    window.addEventListener("orientationchange", applyBubblePresentation, { passive: true });
  } catch (_) {}

  function bubbleForceHide() {
    try {
      bubble.setAttribute("data-kcc-hidden", "1");
      bubble.setAttribute("aria-hidden", "true");
      bubble.style.setProperty("display", "none", "important");
      bubble.style.setProperty("visibility", "hidden", "important");
      bubble.style.setProperty("opacity", "0", "important");
      bubble.style.setProperty("pointer-events", "none", "important");
    } catch (_) {}
  }

  function bubbleReleaseForce() {
    try {
      bubble.removeAttribute("data-kcc-hidden");
      bubble.removeAttribute("aria-hidden");
    } catch (_) {}
  }

  const __KCC_BUBBLE_REVEAL__ = {
    revealed: false,
    threshold: 24,
    raf: 0,
    timed: false,
    timer: 0,
    autoHideTimer: 0,
    autoHidden: false,
    visibleMs: 8000,
    scrollIdleTimer: 0,
    lastWakeY: 0,
    wakeDistance: 120,
    scrollIdleMs: 320
  };

  function bubbleSoftShow() {
    try {
      bubble.style.setProperty("display", "flex", "important");
      bubble.style.setProperty("visibility", "visible", "important");
      bubble.style.setProperty("opacity", "1", "important");
      bubble.style.setProperty("pointer-events", "auto", "important");
      trackKccEvent("Launcher Displayed", "launcher");
    } catch (_) {}
  }

  function bubbleSoftHide() {
    try {
      bubble.style.setProperty("display", "none", "important");
      bubble.style.setProperty("visibility", "hidden", "important");
      bubble.style.setProperty("opacity", "0", "important");
      bubble.style.setProperty("pointer-events", "none", "important");
    } catch (_) {}
  }

  function clearBubbleAutoHideTimer() {
    try {
      if (__KCC_BUBBLE_REVEAL__.autoHideTimer) {
        window.clearTimeout(__KCC_BUBBLE_REVEAL__.autoHideTimer);
      }
    } catch (_) {}
    __KCC_BUBBLE_REVEAL__.autoHideTimer = 0;
  }

  function scheduleBubbleAutoHide() {
    clearBubbleAutoHideTimer();
    if (panelOpen || !__KCC_BUBBLE_REVEAL__.revealed) return;

    __KCC_BUBBLE_REVEAL__.autoHideTimer = window.setTimeout(() => {
      if (panelOpen) return;
      __KCC_BUBBLE_REVEAL__.autoHidden = true;
      __KCC_BUBBLE_REVEAL__.revealed = false;
      bubbleSoftHide();
      trackKccEvent("Launcher Auto Hidden");
    }, __KCC_BUBBLE_REVEAL__.visibleMs);
  }

  function wakeBubbleFromActivity() {
    if (!__kcc_mounted || panelOpen || !bubbleEnabledFromTheme()) return;
    __KCC_BUBBLE_REVEAL__.autoHidden = false;
    __KCC_BUBBLE_REVEAL__.timed = true;
    evalBubbleReveal();
  }

  let __kcc_mounted = false;

  function evalBubbleReveal() {
    if (!__kcc_mounted) return;

    enforceBubbleLabel();

    if (!bubbleEnabledFromTheme()) {
      __KCC_BUBBLE_REVEAL__.revealed = false;
      bubbleForceHide();
      return;
    }

    if (panelOpen) {
      bubbleForceHide();
      return;
    }

    const y = window.scrollY || window.pageYOffset || 0;

    if (__KCC_BUBBLE_REVEAL__.autoHidden) {
      __KCC_BUBBLE_REVEAL__.revealed = false;
      bubbleReleaseForce();
      bubbleSoftHide();
      return;
    }

    if (__KCC_BUBBLE_REVEAL__.timed || y >= __KCC_BUBBLE_REVEAL__.threshold) {
      const wasVisible = __KCC_BUBBLE_REVEAL__.revealed;
      __KCC_BUBBLE_REVEAL__.revealed = true;
      bubbleReleaseForce();
      bubbleSoftShow();
      if (!wasVisible) scheduleBubbleAutoHide();
    } else {
      __KCC_BUBBLE_REVEAL__.revealed = false;
      clearBubbleAutoHideTimer();
      bubbleReleaseForce();
      bubbleSoftHide();
    }
  }

  function onScrollBubbleReveal() {
    if (!__kcc_mounted || panelOpen) return;

    // Do not reveal or repaint the launcher while the page is actively moving.
    if (__KCC_BUBBLE_REVEAL__.raf) return;
    __KCC_BUBBLE_REVEAL__.raf = requestAnimationFrame(() => {
      __KCC_BUBBLE_REVEAL__.raf = 0;

      if (__KCC_BUBBLE_REVEAL__.scrollIdleTimer) {
        window.clearTimeout(__KCC_BUBBLE_REVEAL__.scrollIdleTimer);
      }

      __KCC_BUBBLE_REVEAL__.scrollIdleTimer = window.setTimeout(() => {
        __KCC_BUBBLE_REVEAL__.scrollIdleTimer = 0;
        if (panelOpen || !bubbleEnabledFromTheme()) return;

        const stoppedY = window.scrollY || window.pageYOffset || 0;
        const moved = Math.abs(stoppedY - __KCC_BUBBLE_REVEAL__.lastWakeY);

        if (__KCC_BUBBLE_REVEAL__.autoHidden && moved >= __KCC_BUBBLE_REVEAL__.wakeDistance) {
          __KCC_BUBBLE_REVEAL__.lastWakeY = stoppedY;
          wakeBubbleFromActivity();
          return;
        }

        if (!__KCC_BUBBLE_REVEAL__.autoHidden) {
          evalBubbleReveal();
        }
      }, __KCC_BUBBLE_REVEAL__.scrollIdleMs);
    });
  }

  function applyVisibility() {
    try {
      evalBubbleReveal();
    } catch (_) {}
  }

  /* ---------------------------------------------------------------------------
     MOUNT ONCE (Ready Gate) — reveal hook after mounted (prevents blink)
  --------------------------------------------------------------------------- */
  async function mount() {
    if (__kcc_mounted) return;
    if (document.getElementById("kcc-ui-hook")) {
      __kcc_mounted = true;
      return;
    }

    await kccReadyGate();

    (document.body || document.documentElement).appendChild(hook);

    hook.removeAttribute("hidden");
    hook.setAttribute("data-kcc-mounted", "1");
    bubble.setAttribute("data-kcc-ready", "1");
    __kcc_mounted = true;

    // Theme coordination hooks (for theme.liquid gating)
    try {
      window.__KCI_KCC_READY__ = true;
      document.documentElement.classList.add("kcc-ready");
      document.dispatchEvent(new CustomEvent("kci:kcc:ready"));
    } catch (_) {}

    try {
      applyHeaderContext(false);
      enforceLocalizedKccLinks(panel);
      installLocaleNavigationGuard();
      installKccGermanUiObserver();
      installKccComposerLocaleGuard();
      translateKccUi(panel);
      lockKccComposerLocale();
      setNetState("idle");
      window.addEventListener("scroll", onScrollBubbleReveal, { passive: true });
      window.addEventListener("resize", applyBubblePresentation, { passive: true });
      applyVisibility();
      __KCC_BUBBLE_REVEAL__.lastWakeY = window.scrollY || window.pageYOffset || 0;
      const revealDelay = 1000;
      if (!__KCC_BUBBLE_REVEAL__.timer) {
        __KCC_BUBBLE_REVEAL__.timer = window.setTimeout(() => {
          __KCC_BUBBLE_REVEAL__.timed = true;
          applyVisibility();
        }, revealDelay);
      }
    } catch (_) {}
  }

  function mountSoon() { mount().catch(() => {}); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountSoon, { once: true });
  } else {
    mountSoon();
  }
  window.addEventListener("load", mountSoon, { once: true });

  /* ---------------------------------------------------------------------------
     OPEN/CLOSE + Focus Trap
  --------------------------------------------------------------------------- */
  let greetedAtLoad = false;
  let __kcc_last_focus = null;

  function timeHello() {
    const h = new Date().getHours();
    if (kccIsGerman()) {
      if (h < 12) return "Guten Morgen";
      if (h < 17) return "Guten Tag";
      return "Guten Abend";
    }
    if (h < 12) return "Good morning";
    if (h < 17) return "Good afternoon";
    return "Good evening";
  }

  function scrollToBottom() {
    try {
      requestAnimationFrame(() => {
        try { SCROLL.scrollTop = SCROLL.scrollHeight; } catch (_) {}
      });
    } catch (_) {}
  }

  function appendBot(text, extraClass) {
    const w = el("div", `kcc-msg${extraClass ? ` ${extraClass}` : ""}`);
    w.innerHTML = `<div>${escapeHtml(text)}</div>`;
    SCROLL.appendChild(w);
    enforceLocalizedKccLinks(w);
    scrollToBottom();
  }

  function appendUser(text) {
    const u = el("div", "kcc-userline");
    u.textContent = text;
    SCROLL.appendChild(u);
    scrollToBottom();
  }

  function appendBotHtml(html) {
    const w = el("div", "kcc-msg");
    w.innerHTML = `<div>${html || ""}</div>`;
    SCROLL.appendChild(w);
    enforceLocalizedKccLinks(w);
    scrollToBottom();
  }

  function appendShowcaseHtml(html) {
    if (!html || !SCROLL) return;
    const wrap = el("section", "kcc-showcase");
    wrap.setAttribute("data-kcc-d2c-showcase", "1");
    wrap.setAttribute("aria-label", kccCopy("Selected Kanchan Cashmere pieces", "Ausgewählte Kanchan Cashmere Modelle"));
    wrap.innerHTML = html;
    SCROLL.appendChild(wrap);
    enforceLocalizedKccLinks(wrap);
    initShowcaseCarousels(wrap);
    try { requestAnimationFrame(() => wrap.classList.add("kcc-is-ready")); } catch (_) { wrap.classList.add("kcc-is-ready"); }
  }

  function initShowcaseCarousels(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll("[data-kcc-carousel]").forEach((shell) => {
      const rail = shell.querySelector("[data-kcc-rail]");
      const prev = shell.querySelector("[data-kcc-prev]");
      const next = shell.querySelector("[data-kcc-next]");
      if (!rail || !prev || !next) return;
      const update = () => {
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const overflow = max > 3;
        prev.hidden = !overflow || rail.scrollLeft <= 3;
        next.hidden = !overflow || rail.scrollLeft >= max - 3;
      };
      const move = (direction) => {
        const amount = Math.max(120, Math.round(rail.clientWidth * .78));
        try { rail.scrollBy({ left: direction * amount, behavior: "smooth" }); }
        catch (_) { rail.scrollLeft += direction * amount; }
      };
      prev.addEventListener("click", () => move(-1));
      next.addEventListener("click", () => move(1));
      rail.addEventListener("scroll", update, { passive: true });
      rail.addEventListener("keydown", (event) => {
        if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
          event.preventDefault();
          move(event.key === "ArrowLeft" ? -1 : 1);
        }
      });
      try { new ResizeObserver(update).observe(rail); } catch (_) {}
      requestAnimationFrame(update);
    });
  }

  function moneyFromProduct(product) {
    try {
      if (!product) return "";
      const raw = product.price != null
        ? product.price
        : (product.price_min != null ? product.price_min : (product.min_price != null ? product.min_price : ""));
      if (raw === "" || raw == null) return "";
      let amount;
      if (typeof raw === "string") {
        const cleaned = raw.replace(/[^0-9.,-]/g, "").replace(/,/g, "").trim();
        if (!cleaned) return "";
        amount = Number(cleaned);
      } else if (typeof raw === "number") {
        if (!Number.isFinite(raw)) return "";
        amount = Number.isInteger(raw) ? raw / 100 : raw;
      } else return "";
      if (!Number.isFinite(amount) || amount <= 0 || amount > 100000) return "";
      return `$${amount.toFixed(2).replace(/\.00$/, "")}`;
    } catch (_) {}
    return "";
  }

  function productImageFromProduct(product) {
    try {
      if (product && Array.isArray(product.images) && product.images.length) {
        const img = product.images[0];
        if (typeof img === "string") return img;
        if (img && img.src) return img.src;
        if (img && img.url) return img.url;
      }
      if (product && typeof product.image === "string") return product.image;
      if (product && product.image && product.image.src) return product.image.src;
      if (product && product.image && product.image.url) return product.image.url;
      if (product && typeof product.featured_image === "string") return product.featured_image;
      if (product && product.featured_image && product.featured_image.url) return product.featured_image.url;
      if (product && product.featured_image && product.featured_image.src) return product.featured_image.src;
    } catch (_) {}
    return "";
  }

  function buildProductUrl(product) {
    if (product && product.url) return localizedInternalHref(String(product.url));
    const handle = product && product.handle ? String(product.handle) : "";
    return handle ? localizedInternalHref(`/products/${handle}`) : "#";
  }

  function safeText(s) {
    return escapeHtml(String(s || "").trim());
  }

  function normalizeProductTitle(title) {
    return String(title || "")
      .toLowerCase()
      .replace(/\|\s*kci\s*\d+/g, "")
      .replace(/\bkci\s*\d+\b/g, "")
      .replace(/\b\d+\b/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function dedupeProducts(products) {
    const seen = new Set();
    return (products || []).filter((p) => {
      const key = normalizeProductTitle(p && p.title);
      if (!key) return true;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  const KCC_DE_PRODUCT_TITLE_TERMS = Object.freeze([
    [/\bWomen's\b/gi, "Damen"],
    [/\bWomen\b/gi, "Damen"],
    [/\bMen's\b/gi, "Herren"],
    [/\bMen\b/gi, "Herren"],
    [/\bTurtle Neck\b/gi, "Rollkragen"],
    [/\bTurtleneck\b/gi, "Rollkragen"],
    [/\bCrew Neck\b/gi, "Rundhals"],
    [/\bRound Neck\b/gi, "Rundhals"],
    [/\bV Neck\b/gi, "V-Ausschnitt"],
    [/\bV-Neck\b/gi, "V-Ausschnitt"],
    [/\bSweater\b/gi, "Pullover"],
    [/\bPullover\b/gi, "Pullover"],
    [/\bCardigan\b/gi, "Cardigan"],
    [/\bLong Dress\b/gi, "Langes Kleid"],
    [/\bDress\b/gi, "Kleid"],
    [/\bScarf\b/gi, "Schal"],
    [/\bShawl\b/gi, "Shawl"],
    [/\bWrap\b/gi, "Stola"],
    [/\bCoat\b/gi, "Mantel"],
    [/\bHooded\b/gi, "mit Kapuze"],
    [/\bHoodie\b/gi, "Hoodie"],
    [/\bCable\b/gi, "Zopfmuster"],
    [/\bRibbed\b/gi, "Gerippt"],
    [/\bItalian Cashmere\b/gi, "Italienisches Cashmere"],
    [/\bLuxurious Cashmere\b/gi, "Luxuriöses Cashmere"],
    [/\bRecycled Cashmere\b/gi, "Recyceltes Cashmere"],
    [/\bCashmere\b/gi, "Cashmere"]
  ]);

  function germanizeProductTitleFallback(title) {
    let value = String(title || "").trim();
    if (!kccIsGerman() || !value) return value;
    KCC_DE_PRODUCT_TITLE_TERMS.forEach(([pattern, replacement]) => {
      value = value.replace(pattern, replacement);
    });
    return value.replace(/\s+/g, " ").trim();
  }

  function titleForCard(product) {
    const source = String(product && product.title ? product.title : "Cashmere Piece")
      .replace(/\s*\|\s*Kanchan Cashmere\s*\d+\s*$/i, "")
      .trim();
    return kccIsGerman() ? germanizeProductTitleFallback(source) : source;
  }

  function cleanedTag(tag) {
    return String(tag || "")
      .replace(/_/g, " ")
      .replace(/\bleadies\b/gi, "Ladies")
      .replace(/\s+/g, " ")
      .trim();
  }

  function productDescriptor(product, productTerm) {
    const typeMap = {
      poncho: kccCopy("Cashmere poncho", "Cashmere-Poncho"),
      sweater: kccCopy("Cashmere sweater", "Cashmere-Pullover"),
      pullover: kccCopy("Cashmere pullover", "Cashmere-Pullover"),
      cardigan: kccCopy("Cashmere cardigan", "Cashmere-Cardigan"),
      scarf: kccCopy("Cashmere scarf", "Cashmere-Schal"),
      wrap: kccCopy("Cashmere wrap", "Cashmere-Stola"),
      dress: kccCopy("Cashmere knit dress", "Cashmere-Strickkleid"),
      robe: kccCopy("Cashmere robe", "Cashmere-Robe"),
      hoodie: kccCopy("Cashmere hoodie", "Cashmere-Hoodie"),
      coat: kccCopy("Cashmere coat", "Cashmere-Mantel"),
      shawl: kccCopy("Cashmere shawl", "Cashmere-Shawl")
    };

    const canonical = String(productTerm || "").toLowerCase();
    if (canonical && typeMap[canonical]) return typeMap[canonical];

    const productType = cleanedTag(product && product.product_type);
    if (productType) return kccIsGerman() ? localizeProductMetaText(localizedKccText(productType)) : productType;

    const tags = Array.isArray(product && product.tags) ? product.tags.map(cleanedTag).filter(Boolean) : [];
    const preferred = tags.find((t) => !/^(accessories|new|sale)$/i.test(t));
    if (preferred) return kccIsGerman() ? localizeProductMetaText(localizedKccText(preferred)) : preferred;

    return kccCopy("Refined knitwear", "Raffinierte Strickware");
  }

  function buildProductCardsHtml(message, products, collectionHandle, collectionLabel, ctaUrl, ctaLabel, productTerm) {
    const intro = `<div>${safeText(message)}</div>`;

    const cards = dedupeProducts(products)
      .slice(0, 4)
      .map((p) => {
        const title = safeText(titleForCard(p));
        const meta = safeText(productDescriptor(p, productTerm));
        const price = safeText(moneyFromProduct(p));
        const url = safeText(buildProductUrl(p));
        const img = safeText(productImageFromProduct(p));

        const imgHtml = img
          ? `<img src="${img}" alt="${title}" loading="lazy">`
          : "";

        return `
          <a class="kcc-card" href="${url}">
            <div class="kcc-cardImg">${imgHtml}</div>
            <div class="kcc-cardBody">
              <div class="kcc-cardTitle">${title}</div>
              <div class="kcc-cardMeta">${meta}</div>
              ${price ? `<div class="kcc-cardPrice">${price}</div>` : ``}
              <div class="kcc-cardCta">${safeText(kccCopy("View Piece", "Produkt ansehen"))} <span aria-hidden="true">→</span></div>
            </div>
          </a>
        `;
      })
      .join("");

    const resolvedCtaUrl = localizedInternalHref(ctaUrl || (collectionHandle ? `/collections/${safeText(collectionHandle)}` : ""));
    const resolvedCtaLabel = ctaLabel || (
      collectionHandle
        ? kccCopy(
            `View all ${safeText(collectionLabel || collectionHandle)}`,
            `Alle ${safeText(collectionLabel || collectionHandle)} ansehen`
          )
        : ""
    );
    const cta =
      resolvedCtaUrl && resolvedCtaLabel
        ? `<a class="kcc-collectionCta" href="${resolvedCtaUrl}">${resolvedCtaLabel} <span aria-hidden="true">→</span></a>`
        : "";

    const promptHtml = buildActionPromptsHtml(productRefinementPrompts(productTerm));
    return `
      ${intro}
      <div class="kcc-cardWrap">${cards}</div>
      ${cta}
      ${promptHtml}
    `;
  }

  function localizeProductMetaText(text) {
    const raw = String(text || "").trim();
    if (!kccIsGerman() || !raw) return raw;

    // Common source metadata only; full conversational descriptions remain
    // Worker-owned so they are natural German rather than mechanical translation.
    const exact = {
      "Refined knitwear": "Raffinierte Strickware",
      "Cashmere": "Cashmere",
      "Accessories": "Accessoires",
      "Women": "Damen",
      "Men": "Herren"
    };
    return exact[raw] || raw;
  }

  function stripHtml(s) {
    return String(s || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  }

  const KCC_SWATCH_KEYWORDS = {
    cable: "cable",
    cables: "cable",
    "cable knit": "cable",

    pointelle: "pointelle",

    rib: "rib",
    ribs: "rib",
    "rib knit": "rib",

    jacquard: "jacquard",
    intarsia: "jacquard",
    "jacquard / intarsia": "jacquard",

    lace: "lace",
    "lace knit": "lace",

    mesh: "mesh",
    eyelet: "mesh",
    "mesh / eyelet": "mesh",

    stripe: "stripe",
    striped: "stripe",

    minimal: "plain",
    plain: "plain",
    basic: "plain",
    jersey: "plain",
    "plain / minimal knit": "plain",

    texture: "texture",
    textured: "texture",
    innovative: "texture",
    experimental: "texture",
    zopf: "cable",
    zopfmuster: "cable",
    rippe: "rib",
    rippen: "rib",
    spitze: "lace",
    netz: "mesh",
    lochmuster: "mesh",
    streifen: "stripe",
    schlicht: "plain",
    glatt: "plain",
    textur: "texture"
  };

  const KCC_SWATCH_CATEGORY_MAP = {
    cable: ["cable", "cable knit"],
    pointelle: ["pointelle"],
    rib: ["rib", "rib knit"],
    jacquard: ["jacquard", "jacquard / intarsia", "intarsia"],
    lace: ["lace", "lace knit"],
    mesh: ["mesh", "eyelet", "mesh / eyelet"],
    stripe: ["stripe", "striped"],
    plain: ["plain", "minimal", "plain / minimal knit", "jersey"],
    texture: ["texture", "innovative", "experimental", "other / experimental"]
  };

  function detectSwatchKeyword(text) {
    const s = String(text || "").toLowerCase();
    for (const key in KCC_SWATCH_KEYWORDS) {
      if (s.includes(key)) return KCC_SWATCH_KEYWORDS[key];
    }
    return "";
  }

  function hasSwatchBrowseIntent(text) {
    const s = String(text || "").toLowerCase().trim();
    if (!s) return false;
    const seeSignals = ["show", "see", "view", "browse", "explore", "look at", "zeigen", "ansehen", "durchsuchen", "entdecken"];
    const hasSwatchWord = s.includes("swatch") || s.includes("swatches") || s.includes("strickmuster");
    const keyword = detectSwatchKeyword(s);
    if (hasSwatchWord && seeSignals.some((w) => s.includes(w))) return true;
    if (hasSwatchWord && keyword) return true;
    if (/^swatches?\b/.test(s)) return true;
    if (/^(?:show|zeige|zeig)\s+(cable|pointelle|rib|jacquard|intarsia|texture|mesh|eyelet|lace|stripe|minimal|plain|jersey|zopf|zopfmuster|rippe|rippen|textur|netz|lochmuster|spitze|streifen)\b/.test(s)) return true;
    return false;
  }

  function titleCaseWords(text) {
    return String(text || "")
      .replace(/-/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .split(" ")
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }

  function absolutizeUrl(url) {
    try { return new URL(url, location.origin).toString(); } catch (_) { return String(url || ""); }
  }

  function normalizeSwatchDomItem(node) {
    if (!node) return null;
    const link = node.querySelector("a");
    const img = node.querySelector("img");
    const name = String(node.getAttribute("data-name") || "").trim();
    const number = String(node.getAttribute("data-number") || "").trim();
    const category = String(node.getAttribute("data-category") || "").trim();
    const categoryLabel = String(node.getAttribute("data-category-label") || "").trim();

    return {
      title: titleCaseWords(name || number || "Swatch"),
      swatch_name: titleCaseWords(name || ""),
      swatch_number: String(number || "").toUpperCase(),
      swatch_category: category,
      swatch_category_label: categoryLabel || titleCaseWords(category),
      handle: "",
      url: link ? absolutizeUrl(link.getAttribute("href") || "") : "#",
      image: img ? { url: absolutizeUrl(img.getAttribute("src") || "") } : null,
      images: img ? [{ url: absolutizeUrl(img.getAttribute("src") || "") }] : [],
      product_type: "swatch",
      body_html: "",
      tags: []
    };
  }

  function readSwatchDomFromDocument(doc) {
    try {
      const nodes = doc ? doc.querySelectorAll("[data-kci-swl-item]") : [];
      return Array.from(nodes || []).map(normalizeSwatchDomItem).filter(Boolean);
    } catch (_) {
      return [];
    }
  }

  async function fetchSwatchDomItems() {
    const current = readSwatchDomFromDocument(document);
    if (current.length) return current;

    const pageUrl = storefrontDataUrl("/pages/kci-swatch-library");
    const res = await fetch(pageUrl, {
      method: "GET",
      credentials: "same-origin",
      headers: { accept: "text/html" }
    });
    if (!res.ok) return [];
    const html = await res.text().catch(() => "");
    if (!html) return [];
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return readSwatchDomFromDocument(doc);
  }

  function swatchKeywordVariants(keyword) {
    const variants = KCC_SWATCH_CATEGORY_MAP[keyword] || [];
    return Array.from(new Set([keyword].concat(variants).map((x) => String(x || "").toLowerCase()).filter(Boolean)));
  }

  function swatchHaystack(product) {
    return [
      product && product.title ? product.title : "",
      product && product.swatch_name ? product.swatch_name : "",
      product && product.swatch_number ? product.swatch_number : "",
      product && product.swatch_category ? product.swatch_category : "",
      product && product.swatch_category_label ? product.swatch_category_label : ""
    ].join(" ").toLowerCase();
  }

  function swatchMatchesKeyword(product, keyword) {
    if (!keyword) return true;
    const hay = swatchHaystack(product);
    return swatchKeywordVariants(keyword).some((variant) => hay.includes(variant));
  }

  function scoreSwatch(product, keyword, queryText) {
    const hay = swatchHaystack(product);
    let score = 0;
    if (keyword && swatchMatchesKeyword(product, keyword)) score += 5;

    const name = String(product && product.swatch_name ? product.swatch_name : product && product.title ? product.title : "").toLowerCase();
    const number = String(product && product.swatch_number ? product.swatch_number : "").toLowerCase();
    const query = String(queryText || "").toLowerCase();

    if (query && hay.includes(query)) score += 3;
    if (keyword && name.includes(keyword)) score += 2;
    if (query && (name.includes(query) || number.includes(query))) score += 1;

    return score;
  }

  function swatchCategory(product, fallbackKeyword) {
    const label = String(product && product.swatch_category_label ? product.swatch_category_label : "").trim();
    if (label) return kccIsGerman() ? localizedKccText(label) : label;
    const keyword = fallbackKeyword || "";
    if (!keyword) return kccCopy("Cashmere swatch", "Cashmere-Swatch");
    const pretty = keyword === "plain" ? "Plain / Minimal Knit" : titleCaseWords(keyword);
    return kccIsGerman() ? localizedKccText(pretty) : pretty;
  }

  function swatchSpecLine(product) {
    const parts = [];
    const number = String(product && product.swatch_number ? product.swatch_number : "").trim();
    if (number) parts.push(number.toUpperCase());
    return parts.join(" · ");
  }

  function buildSwatchCardsHtml(message, products, keyword) {
    const intro = `<div>${safeText(message)}</div>`;
    const cards = dedupeProducts(products)
      .slice(0, 4)
      .map((p) => {
        const title = safeText(String(p && (p.swatch_name || p.title) ? (p.swatch_name || p.title) : "Swatch"));
        const meta = safeText(swatchCategory(p, keyword));
        const spec = safeText(swatchSpecLine(p));
        const url = safeText(buildProductUrl(p));
        const img = safeText(productImageFromProduct(p));
        const imgHtml = img ? `<img src="${img}" alt="${title}" loading="lazy">` : "";
        return `
          <a class="kcc-card" href="${url}">
            <div class="kcc-cardImg">${imgHtml}</div>
            <div class="kcc-cardBody">
              <div class="kcc-cardTitle">${title}</div>
              <div class="kcc-cardMeta">${meta}</div>
              ${spec ? `<div class="kcc-cardSpec">${spec}</div>` : ``}
              <div class="kcc-cardCta">${safeText(kccCopy("View Swatch", "Swatch ansehen"))} <span aria-hidden="true">→</span></div>
            </div>
          </a>
        `;
      })
      .join("");

    const ctaLabel = keyword
      ? kccCopy(`View more ${safeText(keyword)} swatches`, `Weitere ${safeText(keyword)}-Swatches ansehen`)
      : kccCopy("View Swatch Library", "Swatch-Galerie ansehen");

    const promptHtml = buildActionPromptsHtml(swatchRefinementPrompts(keyword));
    return `
      ${intro}
      <div class="kcc-cardWrap">${cards}</div>
      <a class="kcc-collectionCta" href="${safeText(localizedInternalHref("/pages/kci-swatch-library"))}">${ctaLabel} <span aria-hidden="true">→</span></a>
      ${promptHtml}
    `;
  }


  function buildActionPromptsHtml(items) {
    const safeItems = (items || []).filter(Boolean).slice(0, 3);
    if (!safeItems.length) return "";
    const chips = safeItems.map((item) => {
      const label = safeText(item);
      return `<span class="kcc-promptChip" data-kcc-prompt="${label}">${label}</span>`;
    }).join("");
    return `<div class="kcc-promptRow">${chips}</div>`;
  }

  function productRefinementPrompts(productTerm) {
    const key = String(productTerm || "").toLowerCase();
    if (kccIsGerman()) {
      const de = {
        sweater: ["Leichte Pullover", "Zopfmuster-Pullover", "Klassische Pullover"],
        pullover: ["Leichte Pullover", "Zopfmuster-Pullover", "Klassische Pullover"],
        cardigan: ["Klassische Cardigans", "Leichte Cardigans", "Zopfmuster-Cardigans"],
        scarf: ["Schals als Geschenk", "Klassische Schals", "Reise-Schals"],
        poncho: ["Leichte Ponchos", "Klassische Ponchos", "Winter-Ponchos"],
        wrap: ["Reise-Wraps", "Klassische Wraps", "Wraps als Geschenk"],
        dress: ["Klassische Strickkleider", "Leichte Strickkleider", "Winter-Strickkleider"],
        robe: ["Klassische Roben", "Reise-Roben", "Roben als Geschenk"],
        hoodie: ["Klassische Hoodies", "Zip-Hoodies", "Leichte Hoodies"],
        coat: ["Klassische Mäntel", "Wintermäntel", "Layering-Mäntel"],
        shawl: ["Shawls als Geschenk", "Klassische Shawls", "Reise-Shawls"]
      };
      return de[key] || ["Klassische Modelle", "Leichte Modelle", "Bestseller"];
    }
    const byType = {
      sweater: ["Lightweight sweaters", "Cable knit sweaters", "Classic sweaters"],
      pullover: ["Lightweight pullovers", "Cable pullovers", "Classic pullovers"],
      cardigan: ["Classic cardigans", "Lightweight cardigans", "Cable cardigans"],
      scarf: ["Gift-ready scarves", "Classic scarves", "Travel scarves"],
      poncho: ["Lightweight ponchos", "Classic ponchos", "Winter ponchos"],
      wrap: ["Travel wraps", "Classic wraps", "Gift-ready wraps"],
      dress: ["Classic knit dresses", "Lightweight knit dresses", "Winter knit dresses"],
      robe: ["Classic robes", "Travel robes", "Gift-ready robes"],
      hoodie: ["Classic hoodies", "Zip hoodies", "Lightweight hoodies"],
      coat: ["Classic coats", "Winter coats", "Layering coats"],
      shawl: ["Gift-ready shawls", "Classic shawls", "Travel shawls"]
    };
    return byType[key] || ["Classic styles", "Lightweight styles", "Best sellers"];
  }

  function swatchRefinementPrompts(keyword) {
    const current = String(keyword || "").toLowerCase();
    const all = kccIsGerman()
      ? [
          { key: "cable", label: "Zopfmuster-Swatches" },
          { key: "pointelle", label: "Pointelle-Swatches" },
          { key: "rib", label: "Rippen-Swatches" },
          { key: "jacquard", label: "Jacquard-Swatches" },
          { key: "texture", label: "Textur-Swatches" }
        ]
      : [
          { key: "cable", label: "Cable swatches" },
          { key: "pointelle", label: "Pointelle swatches" },
          { key: "rib", label: "Rib swatches" },
          { key: "jacquard", label: "Jacquard swatches" },
          { key: "texture", label: "Texture swatches" }
        ];
    return all.filter((x) => x.key !== current).slice(0, 3).map((x) => x.label);
  }

  async function tryLocalSwatchDiscovery(userText) {
    if (isProgrammePage()) return null;
    if (!hasSwatchBrowseIntent(userText)) return null;

    const keyword = detectSwatchKeyword(userText);
    let products = await fetchSwatchDomItems();
    if (!products.length) return null;

    let pool = products.slice();
    if (keyword) {
      const matched = pool.filter((p) => swatchMatchesKeyword(p, keyword));
      if (matched.length) pool = matched;
    }

    let ranked = pool
      .map((p) => ({ product: p, score: scoreSwatch(p, keyword, userText) }))
      .sort((a, b) => b.score - a.score);

    let chosen = dedupeProducts(ranked.map((x) => x.product)).slice(0, 4);
    if (!chosen.length) chosen = dedupeProducts(products).slice(0, 4);
    if (!chosen.length) return null;

    const label = keyword ? `${keyword} swatches` : "cashmere swatches";
    const message = keyword
      ? kccCopy(
          `Here are a few refined ${safeText(keyword)} knit swatches worth exploring.`,
          `Hier finden Sie einige ausgewählte ${safeText(keyword)}-Strick-Swatches zur Inspiration.`
        )
      : kccCopy(
          "Here are a few cashmere knit swatches worth exploring.",
          "Hier finden Sie einige ausgewählte Cashmere-Strick-Swatches zur Inspiration."
        );

    return { mode: "swatches", message, products: chosen, keyword };
  }


  const KCC_PRODUCT_TERMS = Object.freeze({
    sweater: "sweater",
    sweaters: "sweater",
    jumper: "sweater",
    jumpers: "sweater",
    pullover: "pullover",
    pullovers: "pullover",
    strickpullover: "pullover",
    strickpulloveren: "pullover",
    cardigan: "cardigan",
    cardigans: "cardigan",
    strickjacke: "cardigan",
    strickjacken: "cardigan",
    strickcardigan: "cardigan",
    scarf: "scarf",
    scarves: "scarf",
    schal: "scarf",
    schals: "scarf",
    halswärmer: "scarf",
    halswaermer: "scarf",
    poncho: "poncho",
    ponchos: "poncho",
    cape: "poncho",
    wrap: "wrap",
    wraps: "wrap",
    stola: "wrap",
    stolas: "wrap",
    stole: "wrap",
    dress: "dress",
    dresses: "dress",
    kleid: "dress",
    kleider: "dress",
    strickkleid: "dress",
    strickkleider: "dress",
    kaschmirkleid: "dress",
    robe: "robe",
    robes: "robe",
    hoodie: "hoodie",
    hoodies: "hoodie",
    coat: "coat",
    coats: "coat",
    mantel: "coat",
    mäntel: "coat",
    maentel: "coat",
    cashmeremantel: "coat",
    shawl: "shawl",
    shawls: "shawl"
  });

  const KCC_STYLE_KEYWORDS = [
    "cashmere",
    "cable",
    "rib",
    "ribbed",
    "honeycomb",
    "pointelle",
    "jacquard",
    "stripe",
    "striped",
    "mesh",
    "lace",
    "turtleneck",
    "mock neck",
    "v neck",
    "crew neck",
    "round neck",
    "zip",
    "oversized",
    "lightweight",
    "winter",
    "soft",
    "classic",
    "fine gauge",
    "zopf", "zopfmuster", "rippe", "gerippt", "streifen", "gestreift",
    "spitze", "lochmuster", "rollkragen", "rundhals", "v-ausschnitt",
    "reißverschluss", "reissverschluss", "oversized", "leicht", "winter",
    "weich", "klassisch", "feinstrick"
  ];

  function detectProductTermFromText(text) {
    const s = String(text || "").toLowerCase();
    for (const key in KCC_PRODUCT_TERMS) {
      if (s.includes(key)) return KCC_PRODUCT_TERMS[key];
    }
    return "";
  }

  function extractStyleKeywords(text) {
    const s = String(text || "").toLowerCase();
    const out = [];
    KCC_STYLE_KEYWORDS.forEach((kw) => {
      if (s.includes(kw)) out.push(kw);
    });
    return out;
  }

  function scoreProductAgainstKeywords(product, keywords) {
    const haystack = [
      product && product.title ? product.title : "",
      product && product.handle ? product.handle : "",
      Array.isArray(product && product.tags) ? product.tags.join(" ") : "",
      product && product.product_type ? product.product_type : "",
      product && product.body_html ? String(product.body_html).replace(/<[^>]*>/g, " ") : ""
    ]
      .join(" ")
      .toLowerCase();

    let score = 0;
    (keywords || []).forEach((kw) => {
      if (haystack.includes(kw)) score += 2;
    });

    const q = String(product && product.title ? product.title : "").toLowerCase();
    if ((keywords || []).some((kw) => q.includes(kw))) score += 1;

    return score;
  }

  function hasB2BProductionIntent(text) {
    const s = String(text || "").toLowerCase().trim();
    if (!s) return false;

    const b2bSignals = [
      "do you produce",
      "can you produce",
      "can you make",
      "do you make",
      "do you manufacture",
      "can you manufacture",
      "manufacture",
      "manufacturing",
      "production",
      "bulk",
      "moq",
      "minimum order",
      "sampling",
      "sample",
      "lead time",
      "private label",
      "custom",
      "program",
      "programme",
      "buyer",
      "fob",
      "cif",
      "order quantity",
      "place order",
      "place an order",
      "want to order",
      "we want to order",
      "we want to place",
      "cashmere sweater order",
      "quotation",
      "quote",
      "costing",
      "tech pack",
      "techpack",
      "swatch",
      "produzieren", "herstellen", "fertigen", "fertigung", "produktion",
      "großhandel", "grosshandel", "bulk", "mindestbestellmenge", "mindestmenge",
      "sampling", "muster", "lieferzeit", "private label", "sonderanfertigung",
      "programm", "käufer", "kaeufer", "bestellmenge", "bestellung", "auftrag",
      "angebot", "kalkulation", "tech pack", "garn", "gauge"
    ];

    return b2bSignals.some((term) => s.includes(term));
  }

  function hasProductDiscoveryIntent(text) {
    const s = String(text || "").toLowerCase().trim();
    if (!s) return false;

    const productTerm = detectProductTermFromText(s);

    const browseSignals = [
      "show",
      "find",
      "looking for",
      "look for",
      "explore",
      "browse",
      "see",
      "shop",
      "view",
      "search",
      "under",
      "below",
      "less than",
      "price",
      "have",
      "zeigen", "finden", "suche", "suchen", "entdecken", "ansehen",
      "shoppen", "durchsuchen", "unter", "weniger als", "preis", "haben"
    ];

    if (productTerm && browseSignals.some((w) => s.includes(w))) return true;
    return (
      /^(sweaters?|cardigans?|scarves?|ponchos?|wraps?|dresses?|robes?|hoodies?|coats?|pullovers?|shawls?|strickjacken?|schals?|stolas?|kleider?|strickkleider?|mäntel?|maentel)\b/.test(s) ||
      !!detectProductTermFromText(s)
    );
  }

  function isKccDisplayableProduct(product) {
    const hay = [
      product && product.title ? product.title : "",
      product && product.handle ? product.handle : "",
      Array.isArray(product && product.tags) ? product.tags.join(" ") : "",
      product && product.product_type ? product.product_type : "",
      product && product.body_html ? String(product.body_html).replace(/<[^>]*>/g, " ") : ""
    ]
      .join(" ")
      .toLowerCase();

    const blocked = [
      "swatch",
      "sample",
      "sms",
      "proto",
      "development",
      "program",
      "programme",
      "b2b",
      "buyer studio",
      "production portal",
      "lookbook",
      "tech pack",
      "techpack"
    ];

    return !blocked.some((word) => hay.includes(word));
  }

  function detectMaxPriceCents(text) {
    const s = String(text || "").toLowerCase().replace(",", ".");
    const patterns = [
      /(?:under|below|less than|upto|up to)\s*(?:usd|\$|€)?\s*(\d+(?:\.\d{1,2})?)/i,
      /(?:usd|\$|€)\s*(\d+(?:\.\d{1,2})?)\s*(?:or less|max)/i,
      /(?:unter|weniger als|bis|maximal|höchstens|hoechstens)\s*(?:usd|\$|€)?\s*(\d+(?:\.\d{1,2})?)/i,
      /(?:usd|\$|€)\s*(\d+(?:\.\d{1,2})?)\s*(?:oder weniger|maximal|höchstens|hoechstens)/i
    ];
    let m = null;
    for (const pattern of patterns) {
      m = s.match(pattern);
      if (m) break;
    }
    if (!m) return 0;
    const n = Number(m[1]);
    if (!Number.isFinite(n) || n <= 0) return 0;
    return Math.round(n * 100);
  }

  const KCC_DE_SEARCH_NORMALIZATION = Object.freeze({
    "zopfmuster": "cable",
    "zopf": "cable",
    "gerippt": "ribbed",
    "rippe": "rib",
    "rippen": "rib",
    "streifen": "stripe",
    "gestreift": "striped",
    "lochmuster": "pointelle",
    "spitze": "lace",
    "rollkragen": "turtleneck",
    "rundhals": "crew neck",
    "v-ausschnitt": "v neck",
    "reißverschluss": "zip",
    "reissverschluss": "zip",
    "leicht": "lightweight",
    "leichte": "lightweight",
    "leichten": "lightweight",
    "weiche": "soft",
    "weich": "soft",
    "klassisch": "classic",
    "klassische": "classic",
    "feinstrick": "fine gauge"
  });

  function normalizeGermanSearchTerms(text) {
    let value = String(text || "").toLowerCase();
    Object.keys(KCC_DE_SEARCH_NORMALIZATION).forEach((de) => {
      value = value.replace(new RegExp(`\\b${de}\\b`, "g"), KCC_DE_SEARCH_NORMALIZATION[de]);
    });
    return value.replace(/\\s+/g, " ").trim();
  }

  function buildSearchQuery(userText, productTerm) {
    const rawOriginal = String(userText || "").trim().toLowerCase();
    if (!rawOriginal) return productTerm || "";

    let raw = kccIsGerman() ? normalizeGermanSearchTerms(rawOriginal) : rawOriginal;

    raw = raw
      .replace(/\b(show me|show|find me|find|browse|explore|see|view|shop|search for|search|zeigen|zeige|zeig|finden|finde|suche|suchen|entdecken|ansehen|durchsuchen|shoppen)\b/g, " ")
      .replace(/\b(do you have|have you got|have|haben sie|habt ihr|gibt es)\b/g, " ")
      .replace(/\b(please|bitte|mir|mich)\b/g, " ")
      .replace(/\b(unter|weniger als|bis|maximal)\s*(?:usd|\$|€)?\s*\d+(?:[.,]\d{1,2})?\b/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    const canonicalProduct = productTerm || detectProductTermFromText(rawOriginal);
    const canonicalStyle = extractStyleKeywords(rawOriginal)
      .map((kw) => kccIsGerman() ? (KCC_DE_SEARCH_NORMALIZATION[kw] || kw) : kw)
      .filter(Boolean);

    const bits = [];
    if (rawOriginal.includes("cashmere") || rawOriginal.includes("kaschmir")) bits.push("cashmere");
    if (canonicalProduct) bits.push(canonicalProduct);
    canonicalStyle.forEach((kw) => bits.push(kw));

    if (!canonicalProduct && raw) bits.push(raw);

    const joined = Array.from(new Set(bits))
      .join(" ")
      .replace(/\s+/g, " ")
      .trim();

    return joined || canonicalProduct || raw || rawOriginal;
  }

  function normalizeSuggestProduct(p) {
    if (!p) return null;
    const image = (p.featured_image && (p.featured_image.url || p.featured_image.src))
      || (p.image && (p.image.url || p.image.src))
      || "";
    return {
      title: p.title || "",
      handle: p.handle || "",
      url: p.url || (p.handle ? `/products/${p.handle}` : "#"),
      image: image ? { url: image } : null,
      images: image ? [{ url: image }] : [],
      price: p.price != null ? p.price : (p.price_min != null ? p.price_min : ""),
      product_type: p.product_type || "",
      body_html: p.body || p.body_html || "",
      tags: Array.isArray(p.tags) ? p.tags : []
    };
  }

  function storefrontDataPath(path) {
    const raw = String(path || "");
    if (!raw) return raw;
    if (/^https?:\/\//i.test(raw)) return raw;

    // Use Shopify's localized storefront data routes. This lets translated
    // product/collection titles and descriptions flow into KCC on /de.
    if (kccIsGerman()) {
      if (raw === "/de" || raw.startsWith("/de/")) return raw;
      return `/de${raw.startsWith("/") ? raw : `/${raw}`}`;
    }
    return raw.startsWith("/") ? raw : `/${raw}`;
  }

  function storefrontDataUrl(path) {
    return `${location.origin}${storefrontDataPath(path)}`;
  }

  const __KCC_DATA__ = { cache: new Map(), controllers: new Set() };
  const KCC_DATA_TTL = 5 * 60 * 1000;

  async function fetchKccJson(url, init, ttl) {
    const key = String(url || "");
    const now = Date.now();
    const cached = __KCC_DATA__.cache.get(key);
    if (cached && cached.expires > now) {
      if (cached.value) return cached.value;
      if (cached.promise) return cached.promise;
    }

    const controller = new AbortController();
    __KCC_DATA__.controllers.add(controller);
    const request = fetch(key, Object.assign({}, init || {}, { signal: controller.signal }))
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        const value = { ok: res.ok, status: res.status, data };
        if (res.ok) {
          __KCC_DATA__.cache.set(key, { value, expires: Date.now() + (ttl || KCC_DATA_TTL) });
        } else {
          __KCC_DATA__.cache.delete(key);
        }
        return value;
      })
      .catch((error) => {
        __KCC_DATA__.cache.delete(key);
        throw error;
      })
      .finally(() => __KCC_DATA__.controllers.delete(controller));

    __KCC_DATA__.cache.set(key, { promise: request, expires: now + (ttl || KCC_DATA_TTL) });
    return request;
  }

  function abortKccDataRequests() {
    try {
      __KCC_DATA__.controllers.forEach((controller) => controller.abort());
      __KCC_DATA__.controllers.clear();
    } catch (_) {}
  }

  function getKccSessionJson(key) {
    try {
      const raw = sessionStorage.getItem(`kcc_cache_${key}`);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || parsed.expires <= Date.now()) return null;
      return parsed.value;
    } catch (_) { return null; }
  }

  function setKccSessionJson(key, value, ttl) {
    try {
      sessionStorage.setItem(`kcc_cache_${key}`, JSON.stringify({
        value,
        expires: Date.now() + (ttl || KCC_DATA_TTL)
      }));
    } catch (_) {}
  }

  async function fetchSuggestProducts(query, limit) {
    if (!query) return [];
    let url = `${storefrontDataUrl("/search/suggest.json")}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${limit || 12}&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag`;
    let result = await fetchKccJson(url, {
      method: "GET",
      credentials: "same-origin",
      headers: { accept: "application/json" }
    });
    if (result.status === 422) {
      url = `${storefrontDataUrl("/search/suggest.json")}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${limit || 12}&resources[options][unavailable_products]=last`;
      result = await fetchKccJson(url, {
        method: "GET",
        credentials: "same-origin",
        headers: { accept: "application/json" }
      });
    }
    if (!result.ok) return [];
    const data = result.data || {};
    const products = data && data.resources && data.resources.results && Array.isArray(data.resources.results.products)
      ? data.resources.results.products
      : [];
    return products.map(normalizeSuggestProduct).filter(Boolean);
  }

  async function fetchCatalogProducts(limit) {
    const url = `${storefrontDataUrl("/products.json")}?limit=${limit || 80}`;
    const result = await fetchKccJson(url, {
      method: "GET",
      credentials: "omit",
      headers: { accept: "application/json" }
    });
    if (!result.ok) return [];
    const data = result.data || {};
    return Array.isArray(data && data.products) ? data.products : [];
  }

  function currentPathHandle(kind) {
    try {
      const p = normalizedPath();
      const re = kind === "product" ? /\/products\/([^/?#]+)/ : /^\/collections\/([^/?#]+)/;
      const m = p.match(re);
      return m && m[1] ? decodeURIComponent(m[1]) : "";
    } catch (_) {
      return "";
    }
  }

  async function fetchCollectionProducts(handle, limit) {
    if (!handle || handle === "all") return fetchCatalogProducts(limit || 6);
    const result = await fetchKccJson(
      `${storefrontDataUrl(`/collections/${encodeURIComponent(handle)}/products.json`)}?limit=${limit || 6}`,
      { method: "GET", credentials: "same-origin", headers: { accept: "application/json" } }
    );
    if (!result.ok) return [];
    const data = result.data || {};
    return Array.isArray(data && data.products) ? data.products : [];
  }

  const KCC_COLLECTION_DESTINATIONS = [
    { label: "Women", labelDe: "Damen", handles: ["women"], keywords: ["women"] },
    { label: "Men", labelDe: "Herren", handles: ["men-clothing", "men"], keywords: ["men"] },
    { label: "Accessories", labelDe: "Accessoires", handles: ["accessories", "accessories-poncho", "accessories-cashmere-socks"], keywords: ["accessor"] },
    { label: "Baby & Child", labelDe: "Baby & Kind", handles: ["cashmere-for-babies", "baby-child", "baby"], keywords: ["baby", "child"] },
    { label: "Recycled Cashmere", labelDe: "Recyceltes Cashmere", handles: ["recycled-cashmere", "recycled"], keywords: ["recycled"] },
    { label: "Best Sellers", labelDe: "Bestseller", handles: ["best-sellers", "best-selling", "frontpage", "all"], keywords: ["best", "seller"] }
  ];

  function germanizeCollectionTitleFallback(title) {
    if (!kccIsGerman()) return String(title || "");
    const map = {
      "Women": "Damen",
      "Men": "Herren",
      "Accessories": "Accessoires",
      "Baby & Child": "Baby & Kind",
      "Best Sellers": "Bestseller",
      "Recycled Cashmere": "Recyceltes Cashmere",
      "Home": "Wohnen"
    };
    const value = String(title || "").trim();
    return map[value] || value;
  }

  function collectionImageUrl(collection) {
    try {
      const image = collection && collection.image;
      if (typeof image === "string") return image;
      if (image && image.src) return image.src;
      if (image && image.url) return image.url;
    } catch (_) {}
    return "";
  }

  async function fetchCollectionDirectory() {
    try {
      const result = await fetchKccJson(`${storefrontDataUrl("/collections.json")}?limit=250`, {
        method: "GET", credentials: "same-origin", headers: { accept: "application/json" }
      }, 15 * 60 * 1000);
      if (!result.ok) return [];
      const data = result.data || {};
      return Array.isArray(data && data.collections) ? data.collections : [];
    } catch (_) {
      return [];
    }
  }

  async function resolveCollectionDestinations() {
    const collectionCacheKey = `collection_destinations_${kccIsGerman() ? "de" : "en"}`;
    const sessionValue = getKccSessionJson(collectionCacheKey);
    if (Array.isArray(sessionValue) && sessionValue.length) return sessionValue;
    const directory = await fetchCollectionDirectory();
    const byHandle = new Map(
      directory.map((c) => [String(c && c.handle || "").toLowerCase(), c]).filter((x) => x[0])
    );

    const resolved = await Promise.all(KCC_COLLECTION_DESTINATIONS.map(async (destination) => {
      let collection = null;
      let handle = "";
      for (const candidate of destination.handles) {
        if (byHandle.has(candidate)) {
          collection = byHandle.get(candidate);
          handle = candidate;
          break;
        }
      }
      if (!collection && Array.isArray(destination.keywords)) {
        collection = directory.find((item) => {
          const hay = `${String(item && item.handle || "")} ${String(item && item.title || "")}`.toLowerCase();
          return destination.keywords.some((keyword) => hay.includes(keyword));
        }) || null;
        if (collection) handle = String(collection.handle || "").toLowerCase();
      }
      if (!handle) handle = destination.handles[0];

      let image = collectionImageUrl(collection);
      if (!image) {
        try {
          const firstProducts = await fetchCollectionProducts(handle, 1);
          image = firstProducts.length ? productImageFromProduct(firstProducts[0]) : "";
        } catch (_) {}
      }
      if (!image) return null;

      return {
        label: kccIsGerman() ? (destination.labelDe || destination.label) : destination.label,
        handle,
        url: localizedInternalHref(handle === "all" ? "/collections/all" : `/collections/${handle}`),
        image
      };
    }));
    const seenImages = new Set();
    const finalDestinations = resolved.filter((item) => {
      if (!item || !item.image || seenImages.has(item.image)) return false;
      seenImages.add(item.image);
      return true;
    }).slice(0, 6);
    if (finalDestinations.length) setKccSessionJson(collectionCacheKey, finalDestinations, 15 * 60 * 1000);
    return finalDestinations;
  }

  function buildCollectionRailHtml(collections) {
    const tiles = (collections || []).map((collection) => `
      <a class="kcc-collectionTile" href="${safeText(collection.url)}">
        <div class="kcc-collectionImage">
          <img src="${safeText(collection.image)}" alt="${safeText(collection.label)}" loading="lazy" decoding="async">
        </div>
        <div class="kcc-collectionName">${safeText(collection.label)}</div>
      </a>
    `).join("");
    return `<div class="kcc-railShell" data-kcc-carousel>
      <button class="kcc-railNav" data-kcc-prev type="button" aria-label="${safeText(kccCopy("Previous collections", "Vorherige Kollektionen"))}">‹</button>
      <div class="kcc-collectionRail" data-kcc-rail tabindex="0" aria-label="${safeText(kccCopy("Explore Kanchan Cashmere collections", "Kanchan Cashmere Kollektionen entdecken"))}">${tiles}</div>
      <button class="kcc-railNav" data-kcc-next type="button" aria-label="${safeText(kccCopy("Next collections", "Nächste Kollektionen"))}">›</button>
    </div>`;
  }

  function buildProductRailHtml(products, label) {
    const tiles = dedupeProducts((products || []).filter(isKccDisplayableProduct)).slice(0, 6).map((product) => {
      const title = safeText(titleForCard(product));
      const image = safeText(productImageFromProduct(product));
      const price = safeText(moneyFromProduct(product));
      const url = safeText(buildProductUrl(product));
      if (!image) return "";
      return `
        <a class="kcc-contextTile" href="${url}">
          <div class="kcc-contextImage"><img src="${image}" alt="${title}" loading="lazy" decoding="async"></div>
          <div class="kcc-contextName">${title}</div>
          ${price ? `<div class="kcc-contextMeta">${price}</div>` : ``}
        </a>`;
    }).join("");
    return `<div class="kcc-railShell" data-kcc-carousel>
      <button class="kcc-railNav" data-kcc-prev type="button" aria-label="${safeText(kccCopy("Previous pieces", "Vorherige Modelle"))}">‹</button>
      <div class="kcc-contextRail" data-kcc-rail tabindex="0" aria-label="${safeText(label || "Selected cashmere pieces")}">${tiles}</div>
      <button class="kcc-railNav" data-kcc-next type="button" aria-label="${safeText(kccCopy("Next pieces", "Nächste Modelle"))}">›</button>
    </div>`;
  }

  function buildSwatchRailHtml(swatches) {
    const tiles = (swatches || []).slice(0, 6).map((swatch) => {
      const title = safeText(String(swatch && (swatch.swatch_name || swatch.title) || "Cashmere Swatch"));
      const image = safeText(productImageFromProduct(swatch));
      const meta = safeText(swatchCategory(swatch, ""));
      const url = safeText(buildProductUrl(swatch));
      if (!image) return "";
      return `
        <a class="kcc-contextTile" href="${url}">
          <div class="kcc-contextImage"><img src="${image}" alt="${title}" loading="lazy" decoding="async"></div>
          <div class="kcc-contextName">${title}</div>
          <div class="kcc-contextMeta">${meta}</div>
        </a>`;
    }).join("");
    return `<div class="kcc-railShell" data-kcc-carousel>
      <button class="kcc-railNav" data-kcc-prev type="button" aria-label="${safeText(kccCopy("Previous swatches", "Vorherige Swatches"))}">‹</button>
      <div class="kcc-contextRail" data-kcc-rail tabindex="0" aria-label="${safeText(kccCopy("Selected knit swatches", "Ausgewählte Strick-Swatches"))}">${tiles}</div>
      <button class="kcc-railNav" data-kcc-next type="button" aria-label="${safeText(kccCopy("Next swatches", "Nächste Swatches"))}">›</button>
    </div>`;
  }

  function buildCurrentPieceHtml(product) {
    if (!product) return "";
    const title = safeText(titleForCard(product));
    const image = safeText(productImageFromProduct(product));
    const price = safeText(moneyFromProduct(product));
    const url = safeText(buildProductUrl(product));
    if (!image) return "";
    return `<a class="kcc-currentPiece" href="${url}">
      <div class="kcc-currentPieceImage"><img src="${image}" alt="${title}" loading="eager" decoding="async"></div>
      <div>
        <div class="kcc-currentPieceTitle">${title}</div>
        ${price ? `<div class="kcc-currentPiecePrice">${price}</div>` : ``}
        <div class="kcc-currentPieceCta">${safeText(kccCopy("View current piece", "Aktuelles Modell ansehen"))} <span aria-hidden="true">→</span></div>
      </div>
    </a>`;
  }

  async function fetchCurrentProductWithRecommendations(handle) {
    if (!handle) return [];
    const productResult = await fetchKccJson(`${storefrontDataUrl(`/products/${encodeURIComponent(handle)}.js`)}`, {
      method: "GET", credentials: "same-origin", headers: { accept: "application/json" }
    });
    if (!productResult.ok) return [];
    const product = productResult.data || null;
    if (!product) return [];
    let recommendations = [];
    if (product.id) {
      try {
        const recResult = await fetchKccJson(
          `${storefrontDataUrl("/recommendations/products.json")}?product_id=${encodeURIComponent(product.id)}&limit=5&intent=related`,
          { method: "GET", credentials: "same-origin", headers: { accept: "application/json" } }
        );
        if (recResult.ok) {
          const data = recResult.data || {};
          recommendations = Array.isArray(data && data.products) ? data.products : [];
        }
      } catch (_) {}
    }
    return [product].concat(recommendations);
  }

  let d2cShowcaseLoaded = false;
  let buyerShowcaseLoaded = false;
  let privateShowcaseLoaded = false;
  let openingExperienceComplete = false;
  function localizedCollectionHandleLabel(handle) {
    const h = String(handle || "").toLowerCase();
    const known = {
      women: ["Women", "Damen"],
      "men-clothing": ["Men", "Herren"],
      men: ["Men", "Herren"],
      accessories: ["Accessories", "Accessoires"],
      "cashmere-for-babies": ["Baby & Child", "Baby & Kind"],
      "baby-child": ["Baby & Child", "Baby & Kind"],
      "recycled-cashmere": ["Recycled Cashmere", "Recyceltes Cashmere"],
      "best-sellers": ["Best Sellers", "Bestseller"],
      "best-selling": ["Best Sellers", "Bestseller"]
    };
    if (known[h]) return kccCopy(known[h][0], known[h][1]);
    return h.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  }

  async function renderD2CWelcomeShowcase() {
    if (currentPageContext()) return;
    if (d2cShowcaseLoaded || kccRole !== "d2c" || !SCROLL) return;
    if (SCROLL.querySelector("[data-kcc-d2c-showcase]")) return;
    d2cShowcaseLoaded = true;

    const productHandle = currentPathHandle("product");
    const collectionHandle = currentPathHandle("collection");
    let products = [];
    let eyebrow = kccCopy("The Collection", "Die Kollektion");
    let heading = kccCopy("Selected for you", "Für Sie ausgewählt");
    let description = kccCopy(
      "A considered edit of Kanchan Cashmere pieces available to explore.",
      "Eine kuratierte Auswahl an Kanchan Cashmere Modellen."
    );
    let ctaUrl = localizedInternalHref("/collections/all");
    let ctaLabel = kccCopy("Explore the collection", "Kollektion entdecken");

    try {
      if (productHandle) {
        products = await fetchCurrentProductWithRecommendations(productHandle);
        eyebrow = kccCopy("Current Piece", "Aktuelles Modell");
        heading = kccCopy("The piece and related styles", "Das Modell und passende Styles");
        description = kccCopy(
          "View the current piece alongside a small edit of complementary cashmere styles.",
          "Entdecken Sie das aktuelle Modell zusammen mit einer kleinen Auswahl passender Cashmere-Styles."
        );
        ctaUrl = localizedInternalHref(`/products/${encodeURIComponent(productHandle)}`);
        ctaLabel = kccCopy("View current piece", "Aktuelles Modell ansehen");
      } else if (collectionHandle) {
        products = await fetchCollectionProducts(collectionHandle, 8);
        const cleanCollection = localizedCollectionHandleLabel(collectionHandle);
        eyebrow = kccCopy("Current Collection", "Aktuelle Kollektion");
        heading = germanizeCollectionTitleFallback(cleanCollection) || kccCopy("Selected pieces", "Ausgewählte Modelle");
        description = kccCopy(
          "A focused edit from the collection currently in view.",
          "Eine kuratierte Auswahl aus der aktuell angezeigten Kollektion."
        );
        ctaUrl = localizedInternalHref(`/collections/${encodeURIComponent(collectionHandle)}`);
        ctaLabel = kccCopy("Explore full collection", "Gesamte Kollektion entdecken");
      } else {
        const collections = await resolveCollectionDestinations();
        if (collections.length) {
          appendShowcaseHtml(`
            <div class="kcc-showcaseEyebrow">${safeText(kccCopy("Explore Kanchan Cashmere", "Kanchan Cashmere entdecken"))}</div>
            <div class="kcc-showcaseTitle">${safeText(kccCopy("The Collections", "Die Kollektionen"))}</div>
            <div class="kcc-showcaseText">${safeText(kccCopy("Move through our principal cashmere collections, each selected as a distinct starting point.", "Entdecken Sie unsere wichtigsten Cashmere-Kollektionen, jeweils als eigenständigen Ausgangspunkt kuratiert."))}</div>
            ${buildCollectionRailHtml(collections)}
          `);
          return;
        }
        products = await fetchCatalogProducts(8);
      }
    } catch (_) {
      products = [];
    }

    const chosen = dedupeProducts((products || []).filter(isKccDisplayableProduct)).slice(0, 6);
    if (!chosen.length || kccRole !== "d2c") {
      d2cShowcaseLoaded = false;
      return;
    }

    if (productHandle) {
      const current = chosen[0];
      const related = chosen.slice(1);
      appendShowcaseHtml(`
        <div class="kcc-showcaseEyebrow">${safeText(kccCopy("Current Piece", "Aktuelles Modell"))}</div>
        ${buildCurrentPieceHtml(current)}
        ${related.length ? `<div class="kcc-relatedLabel">${safeText(kccCopy("Related Pieces", "Ähnliche Modelle"))}</div>${buildProductRailHtml(related, kccCopy("Related cashmere pieces", "Ähnliche Cashmere-Modelle"))}` : ``}
      `);
      return;
    }

    appendShowcaseHtml(`
      <div class="kcc-showcaseEyebrow">${safeText(kccIsGerman() ? localizedKccText(eyebrow) : eyebrow)}</div>
      <div class="kcc-showcaseTitle">${safeText(kccIsGerman() ? localizedKccText(heading) : heading)}</div>
      <div class="kcc-showcaseText">${safeText(kccIsGerman() ? localizedKccText(description) : description)}</div>
      ${buildProductRailHtml(chosen, kccIsGerman() ? localizedKccText(heading) : heading)}
      <a class="kcc-collectionCta" href="${safeText(localizedInternalHref(ctaUrl))}">${safeText(kccIsGerman() ? localizedKccText(ctaLabel) : ctaLabel)} <span aria-hidden="true">→</span></a>
    `);
  }

  async function renderBuyerWelcomeShowcase() {
    if (currentPageContext() && !isBuyerTermsPage()) return;
    if (buyerShowcaseLoaded || kccRole !== "buyer" || !SCROLL) return;
    buyerShowcaseLoaded = true;
    if (isBuyerTermsPage()) {
      appendShowcaseHtml(`
        <div class="kcc-showcaseEyebrow">${safeText(kccCopy("Buyer Guidance", "Käuferberatung"))}</div>
        <div class="kcc-showcaseTitle">${safeText(kccCopy("Business Terms", "Geschäftsbedingungen"))}</div>
        <div class="kcc-showcaseText">${safeText(kccCopy("Review the commercial framework for sampling, production, delivery and quality.", "Prüfen Sie die kommerziellen Rahmenbedingungen für Sampling, Produktion, Lieferung und Qualität."))}</div>
      `);
      return;
    }
    let swatches = [];
    try { swatches = await fetchSwatchDomItems(); } catch (_) { swatches = []; }
    const selected = (swatches || []).filter((item) => productImageFromProduct(item)).slice(0, 6);
    if (!selected.length || kccRole !== "buyer") {
      buyerShowcaseLoaded = false;
      return;
    }
    appendShowcaseHtml(`
      <div class="kcc-showcaseEyebrow">${safeText(kccCopy("Development Direction", "Entwicklungsrichtung"))}</div>
      <div class="kcc-showcaseTitle">${safeText(kccCopy("Selected Knit Swatches", "Ausgewählte Strick-Swatches"))}</div>
      <div class="kcc-showcaseText">${safeText(kccCopy("Explore a concise edit of structures as a starting point for sampling and programme development.", "Entdecken Sie eine kuratierte Auswahl an Strukturen als Ausgangspunkt für Sampling und Programmentwicklung."))}</div>
      ${buildSwatchRailHtml(selected)}
      <a class="kcc-collectionCta" href="${safeText(localizedInternalHref("/pages/kci-swatch-library"))}">${safeText(kccCopy("View Swatch Library", "Swatch-Galerie ansehen"))} <span aria-hidden="true">→</span></a>
    `);
  }

  async function renderPrivateWelcomeShowcase() {
    if (currentPageContext()) return;
    if (privateShowcaseLoaded || kccRole !== "hybrid" || !SCROLL) return;
    privateShowcaseLoaded = true;
    let collections = [];
    try { collections = await resolveCollectionDestinations(); } catch (_) { collections = []; }
    if (!collections.length || kccRole !== "hybrid") {
      privateShowcaseLoaded = false;
      return;
    }
    appendShowcaseHtml(`
      <div class="kcc-showcaseTitle">${safeText(kccCopy("Explore Kanchan Cashmere", "Kanchan Cashmere entdecken"))}</div>
      <div class="kcc-showcaseText">${safeText(kccCopy("Discover our collections, craftsmanship and private-label capabilities through a considered starting edit.", "Entdecken Sie unsere Kollektionen, Handwerkskunst und Private-Label-Kompetenz über eine kuratierte Auswahl."))}</div>
      ${buildCollectionRailHtml(collections)}
    `);
  }

  async function tryLocalProductDiscovery(userText) {
    if (kccRole === "buyer") return null;
    if (isProgrammeIntent(userText)) return null;
    if (hasB2BProductionIntent(userText)) return null;
    const requestText = String(userText || "").toLowerCase();
    const currentCollection = currentPathHandle("collection");
    const currentProduct = currentPathHandle("product");

    if (currentCollection && (/(this|current)\s+collection|explore\s+this\s+collection/.test(requestText) || /(diese|aktuelle)\s+kollektion|kollektion\s+entdecken/.test(requestText))) {
      const products = await fetchCollectionProducts(currentCollection, 12);
      if (products.length) {
        const label = localizedCollectionHandleLabel(currentCollection);
        return {
          mode: "products",
          message: kccCopy(`Here is a focused edit from the ${safeText(label)} collection.`, `Hier ist eine kuratierte Auswahl aus der Kollektion ${safeText(label)}.`),
          products: dedupeProducts(products).slice(0, 6),
          collectionHandle: currentCollection,
          collectionLabel: label,
          ctaUrl: `/collections/${encodeURIComponent(currentCollection)}`,
          ctaLabel: kccCopy("View full collection", "Gesamte Kollektion ansehen")
        };
      }
    }

    if (currentProduct && /similar|related|complementary|ähnlich|aehnlich|verwandt|passend/.test(requestText)) {
      const products = await fetchCurrentProductWithRecommendations(currentProduct);
      if (products.length > 1) {
        return {
          mode: "products",
          message: kccCopy("Here are several related pieces selected around the product currently in view.", "Hier finden Sie mehrere passende Modelle rund um das aktuell angezeigte Produkt."),
          products: dedupeProducts(products.slice(1)).slice(0, 6),
          collectionHandle: "",
          collectionLabel: kccCopy("related pieces", "ähnliche Modelle"),
          ctaUrl: "/collections/all",
          ctaLabel: kccCopy("Explore all collections", "Alle Kollektionen entdecken")
        };
      }
    }
    if (!hasProductDiscoveryIntent(userText)) return null;

    const productTerm = detectProductTermFromText(userText);
    const searchQuery = buildSearchQuery(userText, productTerm);

    let products = await fetchSuggestProducts(searchQuery, 12);
    if (!products.length && productTerm && searchQuery !== productTerm) {
      products = await fetchSuggestProducts(productTerm, 12);
    }
    if (!products.length) {
      products = await fetchCatalogProducts(80);
    }
    if (!products.length) return null;

    const keywords = extractStyleKeywords(userText);
    const maxPriceCents = detectMaxPriceCents(userText);

    let pool = Array.isArray(products) ? products.filter(isKccDisplayableProduct) : [];
    if (productTerm) {
      const termNeedle = productTerm.toLowerCase();
      const narrowed = pool.filter((p) => {
        const hay = [p.title || "", p.handle || "", p.product_type || "", Array.isArray(p.tags) ? p.tags.join(" ") : ""]
          .join(" ")
          .toLowerCase();
        return hay.includes(termNeedle);
      });
      if (narrowed.length) pool = narrowed;
    }
    if (maxPriceCents > 0) {
      pool = pool.filter((p) => {
        const cents = Number(p && p.price != null ? p.price : 0);
        return Number.isFinite(cents) && cents > 0 && cents <= maxPriceCents;
      });
    }
    if (!pool.length) return null;

    let ranked = pool.map((p) => ({
      product: p,
      score: scoreProductAgainstKeywords(p, keywords.concat(productTerm ? [productTerm] : []))
    }));

    ranked = ranked.sort((a, b) => b.score - a.score);

    let chosen = ranked
      .filter((x) => ((keywords.length || productTerm) ? x.score > 0 : true))
      .map((x) => x.product);

    chosen = dedupeProducts(chosen).slice(0, 4);
    if (!chosen.length) chosen = dedupeProducts(pool).slice(0, 4);
    if (!chosen.length) return null;

    const collectionLabel = productTerm ? `${productTerm}${productTerm.endsWith("s") ? "" : "s"}` : "pieces";
    const labelText = collectionLabel.replace(/-/g, " ");
    let message = (keywords.length || productTerm)
      ? `Here are a few refined ${safeText(labelText.replace(/s$/, ""))} styles worth exploring.`
      : `Here are a few ${safeText(labelText.replace(/s$/, ""))} styles worth exploring.`;

    if (maxPriceCents > 0) {
      const under = `$${(maxPriceCents / 100).toFixed(0)}`;
      message = (keywords.length || productTerm)
        ? `Here are a few refined ${safeText(labelText.replace(/s$/, ""))} styles within ${under} or below.`
        : `Here are a few ${safeText(labelText.replace(/s$/, ""))} styles within ${under} or below.`;
    }

    return {
      mode: "products",
      message,
      products: chosen,
      collectionHandle: "",
      collectionLabel: labelText,
      ctaUrl: `/search?q=${encodeURIComponent(searchQuery)}&options[prefix]=last`,
      ctaLabel: `View all ${safeText(labelText)}`
    };
  }

  function lastBotText() {
    try {
      const msgs = SCROLL ? SCROLL.querySelectorAll(".kcc-msg > div") : null;
      if (!msgs || !msgs.length) return "";
      return (msgs[msgs.length - 1].textContent || "").trim();
    } catch (_) {
      return "";
    }
  }

  function clearGreetingDecor() {
    try {
      const d = SCROLL.querySelector("[data-kcc-greet-decor]");
      if (d) d.remove();
    } catch (_) {}
  }

  function renderGreetingDecor(options) {
    clearGreetingDecor();

    const family = pageFamily();
    const productHandle = currentPathHandle("product");
    const collectionHandle = currentPathHandle("collection");
    const pagePrompts = pageContextPromptItems();

    let prompts = null;

    if (family === "home") {
      prompts = homepagePromptItems() || KCC_HOME_ACTIONS;
    } else if (pagePrompts) {
      prompts = pagePrompts;
    } else if (family === "buyer" && isBuyerTermsPage()) {
      prompts = ["MOQ & Sampling", "Payment Terms", "Lead Times", "Quality & Claims"];
    } else if (family === "buyer") {
      prompts = ["Explore Swatches", "Request Sampling", "MOQ & Lead Time", "Yarn Options"];
    } else if (family === "product" && productHandle) {
      prompts = ["Find My Size", "How Does It Feel?", "Similar Pieces", "Cashmere Care"];
    } else if (family === "collection" && collectionHandle) {
      prompts = ["Explore This Collection", "Best Sellers", "Find My Size", "Cashmere Care"];
    } else {
      prompts = [
        { label: "Explore Collections", href: "/pages/kci-shop" },
        { label: "Our Craftsmanship", href: "/pages/kci-craftsmanship" },
        { label: "The Library", href: "/pages/the-library" },
        { label: "Contact Kanchan Cashmere", href: "/pages/kci-contact" }
      ];
    }

    const wrap = el("div");
    wrap.setAttribute("data-kcc-greet-decor", "1");
    wrap.style.marginTop = "2px";

    const divider = el("div", "kcc-divider");
    const list = el("div", "kcc-prompts");

    prompts.forEach((item) => {
      const isObj = item && typeof item === "object";
      const isContextAction = isObj && item.reply;
      const isLink = isObj && item.href && !isContextAction;
      const rawLabel = isObj ? String(item.label || "") : String(item || "");
      const label = kccIsGerman() ? localizedKccText(rawLabel) : rawLabel;
      const s = document.createElement(isLink ? "a" : "span");
      s.textContent = label;

      if (isLink) {
        s.setAttribute("href", localizedInternalHref(String(item.href)));
        s.setAttribute("aria-label", label);
        s.setAttribute("target", "_self");
        s.addEventListener("click", () => trackKccEvent(`KCC Action ${label}`));
      } else {
        s.setAttribute("role", "button");
        s.setAttribute("tabindex", "0");
        const setTxt = () => {
          try { if (INPUT) INPUT.value = ""; } catch (_) {}
          try { doSend(label); } catch (_) {}
        };
        s.addEventListener("click", setTxt);
        s.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setTxt();
          }
        });
      }

      list.appendChild(s);
    });

    wrap.appendChild(divider);
    wrap.appendChild(list);

    try {
      SCROLL.appendChild(wrap);
      if (options && options.preserveTop) SCROLL.scrollTop = 0;
      else scrollToBottom();
    } catch (_) {}
  }

  async function renderOpeningExperience() {
    if (openingExperienceComplete) return;
    openingExperienceComplete = true;

    const family = pageFamily();

    try {
      if (family === "buyer") {
        await renderBuyerWelcomeShowcase();
      } else if (family === "product" || family === "collection") {
        await renderD2CWelcomeShowcase();
      } else {
        // Home and Private pages use the restrained collection/brand showcase.
        await renderPrivateWelcomeShowcase();
      }
    } catch (_) {}

    renderGreetingDecor({ preserveTop: true });

    try {
      requestAnimationFrame(() => { if (SCROLL) SCROLL.scrollTop = 0; });
    } catch (_) {}
  }

  function greetUniversal() {
    const hello = timeHello();
    const family = pageFamily();
    const mapped = currentPageContext();
    const de = kccIsGerman();
    const mappedHeading = mapped && mapped.heading ? localizedKccText(mapped.heading) : "";

    let text = "";

    if (family === "home") {
      text = de
        ? `${hello} — willkommen bei Kanchan Cashmere. Entdecken Sie unsere Kollektionen, Handwerkskunst oder Private-Label-Möglichkeiten.`
        : `${hello} — welcome to Kanchan Cashmere. Explore our collections, craftsmanship, or private-label capabilities.`;
    } else if (family === "product") {
      text = de
        ? `${hello} — willkommen bei Kanchan Cashmere. Entdecken Sie dieses Modell, finden Sie Ihre passende Größe oder erhalten Sie Beratung zu Pflege und ähnlichen Styles.`
        : `${hello} — welcome to the Product Concierge. Explore this piece, sizing, care, or related styles.`;
    } else if (family === "collection") {
      text = de
        ? `${hello} — willkommen bei Kanchan Cashmere. Entdecken Sie diese Kollektion, finden Sie Ihre passende Größe oder erhalten Sie Beratung zu Pflege und Lieferung.`
        : `${hello} — welcome to the Collection Concierge. Explore this collection, sizing, care, or delivery.`;
    } else if (family === "buyer") {
      if (mappedHeading) {
        text = de
          ? `${hello} — willkommen bei ${mappedHeading}. Wählen Sie unten ein Thema oder fragen Sie den Käufer Concierge direkt.`
          : `${hello} — welcome to ${mapped.heading}. Select a topic below or ask the Buyer Concierge directly.`;
      } else if (isBuyerTermsPage()) {
        text = de
          ? `${hello} — willkommen beim Käufer Concierge. Informieren Sie sich über MOQ, Zahlung, Lieferzeiten, Qualität oder Reklamationen.`
          : `${hello} — welcome to the Buyer Concierge. Review MOQ, payment, lead times, quality, or claims.`;
      } else {
        text = de
          ? `${hello} — willkommen beim Käufer Concierge. Entdecken Sie Sampling, Garne, Entwicklung, Produktion oder kommerzielle Rahmenbedingungen.`
          : `${hello} — welcome to the Buyer Concierge. Explore sampling, yarns, development, production, or commercial guidance.`;
      }
    } else if (mappedHeading) {
      text = de
        ? `${hello} — willkommen bei ${mappedHeading}. Wählen Sie unten ein Thema oder fragen Sie KCC direkt.`
        : `${hello} — welcome to ${mapped.heading}. Select a topic below or ask KCC anything.`;
    } else {
      text = de
        ? `${hello} — willkommen bei Kanchan Cashmere. Fragen Sie KCC zu unserem Unternehmen, Handwerk, Pflege, Versand oder weiteren Informationen.`
        : `${hello} — welcome to Kanchan Cashmere. Ask KCC about our company, craftsmanship, care, delivery, or general information.`;
    }

    if (lastBotText() === text) return;
    appendBot(text, "kcc-greeting");
  }

  function greetAtLoadOnce() {
    if (greetedAtLoad) return;
    greetedAtLoad = true;
    try { if (SCROLL && SCROLL.children && SCROLL.children.length === 0) greetUniversal(); } catch (_) {}
  }
  applyHeaderContext(false);
  greetAtLoadOnce();

  function addTyping() {
    const w = el("div", "kcc-msg");
    w.setAttribute("data-kcc-typing", "1");
    w.innerHTML = `<div style="opacity:.75">…</div>`;
    SCROLL.appendChild(w);
    scrollToBottom();
  }
  function removeTyping() {
    const t = SCROLL.querySelector('[data-kcc-typing="1"]');
    if (t) t.remove();
  }

  function getFocusableInPanel() {
    try {
      const nodes = panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      return Array.prototype.slice.call(nodes).filter((n) => {
        if (!n) return false;
        const cs = window.getComputedStyle(n);
        return cs && cs.visibility !== "hidden" && cs.display !== "none";
      });
    } catch (_) {
      return [];
    }
  }

  function focusFirst() {
    const f = getFocusableInPanel();
    const mobile = shouldLockPageScroll();
    const closeControl = panel.querySelector('[data-kcc-close="1"]');
    const target = mobile
      ? (closeControl || f[0] || panel)
      : (INPUT && f.includes(INPUT) ? INPUT : f[0]);
    try { (target || panel).focus({ preventScroll: true }); }
    catch (_) { try { (target || panel).focus(); } catch (_) {} }
  }

  function onTrapKeydown(e) {
    if (!panelOpen) return;
    if (!e || e.key !== "Tab") return;

    const focusables = getFocusableInPanel();
    if (!focusables.length) {
      e.preventDefault();
      try { panel.focus(); } catch (_) {}
      return;
    }

    const active = document.activeElement;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey) {
      if (active === first || active === panel) { e.preventDefault(); last.focus(); }
    } else {
      if (active === last) { e.preventDefault(); first.focus(); }
    }
  }

  async function openPanel() {
    await mount().catch(() => {});
    await kccReadyGate().catch(() => {});

    applyHeaderContext(false);

    __kcc_last_focus = document.activeElement || bubble;

    const ep = (CFG.ai && (CFG.ai.endpoint || CFG.ai.fallbackEndpoint)) || "";
    panel.removeAttribute("hidden");
    panel.setAttribute("aria-hidden", "false");
    panel.classList.add("open");
    panelOpen = true;
    clearBubbleAutoHideTimer();
    try {
      if (__KCC_BUBBLE_REVEAL__.scrollIdleTimer) {
        window.clearTimeout(__KCC_BUBBLE_REVEAL__.scrollIdleTimer);
        __KCC_BUBBLE_REVEAL__.scrollIdleTimer = 0;
      }
    } catch (_) {}
    trackKccEvent("Opened");

    lockScroll();
    bubbleForceHide();

    try {
      panel.setAttribute("tabindex", "-1");
      document.addEventListener("keydown", onTrapKeydown, true);
    } catch (_) {}

    try { if (SCROLL && SCROLL.children && SCROLL.children.length === 0) greetUniversal(); } catch (_) {}
    Promise.resolve().then(renderOpeningExperience).catch(() => {});

    try { requestAnimationFrame(() => focusFirst()); } catch (_) {}

    if (!ep) appendBot(kccFallback("noEndpoint"));
  }

  function closePanel() {
    abortKccDataRequests();
    panel.classList.remove("open");
    panel.setAttribute("hidden", "hidden");
    panel.setAttribute("aria-hidden", "true");
    panelOpen = false;
    __KCC_BUBBLE_REVEAL__.autoHidden = false;
    __KCC_BUBBLE_REVEAL__.lastWakeY = window.scrollY || window.pageYOffset || 0;

    try { document.removeEventListener("keydown", onTrapKeydown, true); } catch (_) {}

    unlockScroll();
    releaseLegacyKccScrollLock();
    __KCC_BUBBLE_REVEAL__.revealed = false;
    applyVisibility();

    try { document.dispatchEvent(new CustomEvent("kcc:closed")); } catch (_) {}

    try {
      const target = bubble;
      requestAnimationFrame(() => {
        try { target.focus({ preventScroll: true }); }
        catch (_) { try { target.focus(); } catch (_) {} }
      });
    } catch (_) {}

    try { if (__KCC_NET__.state !== "error") setNetState("idle"); } catch (_) {}
  }

  function syncPanelScrollLock() {
    if (!panelOpen) return;
    if (shouldLockPageScroll()) lockScroll();
    else unlockScroll();
  }

  try {
    window.addEventListener("resize", syncPanelScrollLock, { passive: true });
    window.addEventListener("orientationchange", syncPanelScrollLock, { passive: true });
  } catch (_) {}

  bubble.addEventListener("click", (e) => {
    e.preventDefault();
    clearBubbleAutoHideTimer();
    if (!panelOpen) openPanel();
  });


  panel.addEventListener("click", (e) => {
    const t = e.target;
    const contentLink = t && t.closest
      ? t.closest(".kcc-currentPiece,.kcc-contextTile,.kcc-collectionTile,.kcc-collectionCta")
      : null;
    if (contentLink) trackKccEvent("Content Selected");
    // Supports both .kcc-close and [data-kcc-close]
    if (t && t.closest && (t.closest("[data-kcc-close]") || t.closest(".kcc-close"))) {
      e.preventDefault();
      closePanel();
      return;
    }
    if (t && t.closest && t.closest("[data-kcc-reset]")) {
      e.preventDefault();
      try {
        SCROLL.innerHTML = "";
          d2cShowcaseLoaded = false;
        buyerShowcaseLoaded = false;
        privateShowcaseLoaded = false;
        openingExperienceComplete = false;
        applyHeaderContext(false);
        greetUniversal();
        Promise.resolve().then(renderOpeningExperience).catch(() => {});
        setNetState("idle");
      } catch (_) {}
      return;
    }
    const chip = t && t.closest ? t.closest("[data-kcc-prompt]") : null;
    if (chip) {
      e.preventDefault();
      trackKccEvent("Prompt Selected");
      const promptText = String(chip.getAttribute("data-kcc-prompt") || "").trim();
      if (promptText) {
        try { if (INPUT) INPUT.value = promptText; } catch (_) {}
        doSend(promptText);
      }
    }
  });

  document.addEventListener("keydown", (e) => {
    if ((e.key === "Escape" || e.key === "Esc") && panelOpen) closePanel();
  });

  /* ---------------------------------------------------------------------------
     WORKER PAYLOAD (SILENT INTENT ONLY)
  --------------------------------------------------------------------------- */
  function buildPayload(messageText) {
    const pageCtx = Object.assign(
      {
        url: location.href,
        path: location.pathname,
        title: document.title || "",
        ref: document.referrer || "",
        ts: nowISO(),
        locale: kccIsGerman() ? "de-DE" : "en",
        normalizedPath: normalizedPath(),
        pageRole: kccRole,
        pageFamily: pageFamily(),
        conciergeMode: visibleConciergeLabel(kccRole, false),
      },
      CFG.page && typeof CFG.page === "object" ? CFG.page : {}
    );

    return {
      v: "47.18.67",
      brand: CFG.brand || "Kanchan Cashmere",
      locale: kccIsGerman() ? "de-DE" : "en",
      language: kccIsGerman() ? "German" : "English",
      responseLanguage: kccIsGerman() ? "de" : "en",
      storefrontLocale: kccIsGerman() ? "de" : "en",
      systemInstruction: kccIsGerman()
        ? "Respond entirely in professional German for this /de storefront turn unless the visitor explicitly asks for English. Keep brand names, product names, yarn article names, counts and certification abbreviations unchanged."
        : "Respond in professional English.",
      intent: kccIntent, // "support" | "programmes"
      role: kccRole, // "buyer" | "d2c" | "hybrid"
      message: String(messageText || ""),
      context: pageCtx,
    };
  }

  async function callWorker(messageText) {
    const ai = CFG.ai || {};
    const endpoint = ai.endpoint || "";
    const fallbackEndpoint = ai.fallbackEndpoint || endpoint;
    const timeoutMs = ai.timeoutMs || 20000;

    const payload = buildPayload(messageText);

    const doFetch = async (url, signal) => {
      netBegin();
      const res = await fetch(url, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(payload),
        signal,
        credentials: "omit",
      });
      if (!res.ok) throw new Error("HTTP " + res.status);
      const data = await res.json().catch(() => ({}));
      const out =
        (data && (data.reply || data.text || data.answer || data.message)) ||
        (typeof data === "string" ? data : "");
      netSuccess();
      return out;
    };

    if (endpoint) {
      const ac = new AbortController();
      const to = setTimeout(() => ac.abort(), timeoutMs);
      try {
        const out = await doFetch(endpoint, ac.signal);
        clearTimeout(to);
        return out;
      } catch (_) { clearTimeout(to); }
    }

    if (fallbackEndpoint && fallbackEndpoint !== endpoint) {
      const ac2 = new AbortController();
      const to2 = setTimeout(() => ac2.abort(), timeoutMs);
      try {
        const out2 = await doFetch(fallbackEndpoint, ac2.signal);
        clearTimeout(to2);
        return out2;
      } catch (_) { clearTimeout(to2); }
    }

    netFail();
    return "";
  }

  /* ---------------------------------------------------------------------------
     GREETING DETECTION
  --------------------------------------------------------------------------- */
  function normalizeForGreeting(raw) {
    let s = String(raw || "");
    try { s = s.normalize("NFKC"); } catch (_) {}
    return s
      .replace(/\u00A0/g, " ")
      .replace(/[\u200B-\u200D\uFEFF]/g, "")
      .toLowerCase()
      .replace(/[.!?,;:]+/g, "")
      .replace(/\bgoog\b/g, "good")
      .replace(/\bgud\b/g, "good")
      .replace(/\bmornin\b/g, "morning")
      .replace(/\bevenin\b/g, "evening")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 80);
  }

  function isGreeting(raw) {
    const s = normalizeForGreeting(raw);
    return [
      "hi", "hello", "hey", "hiya", "heya", "yo", "namaste", "namaskar",
      "good morning", "good afternoon", "good evening", "good night",
      "gm", "ga", "ge",
      "how are you", "how r u", "how are u", "how are you doing",
      "how is it going", "how's it going",
      "hallo", "guten morgen", "guten tag", "guten abend", "gute nacht",
      "wie geht es dir", "wie geht es ihnen", "wie gehts", "servus", "grüß gott", "gruss gott"
    ].includes(s);
  }

  /* ---------------------------------------------------------------------------
     SEND
  --------------------------------------------------------------------------- */
  async function doSend(raw) {
    if (!raw) return;
    trackKccEvent("Question Submitted");

    if (/^\/(new|reset)\b/i.test(raw)) {
      SCROLL.innerHTML = "";
      d2cShowcaseLoaded = false;
      buyerShowcaseLoaded = false;
      privateShowcaseLoaded = false;
      openingExperienceComplete = false;
      applyHeaderContext(false);
      greetUniversal();
      Promise.resolve().then(renderOpeningExperience).catch(() => {});
      setNetState("idle");
      return;
    }

    const swatchBrowse = hasSwatchBrowseIntent(raw);
    setRoleContext(swatchBrowse ? "buyer" : inferTurnRole(raw));
    appendUser(raw);

    const pageAction = pageContextPromptByLabel(raw);
    if (pageAction) {
      trackKccEvent(`Context Pill ${pageAction.label}`);

      // EN keeps the proven local instant reply.
      if (!kccIsGerman()) {
        appendBotHtml(buildContextReplyHtml(pageAction));
        return;
      }

      // DE must never render the English hard-coded local reply.
      // Send the approved factual context to the Worker and require German output.
      addTyping();
      const workerPrompt = germanWorkerPromptFromContext(pageAction);
      callWorker(workerPrompt)
        .then((reply) => {
          removeTyping();
          const cleaned = String(reply || "").trim();
          if (cleaned) {
            appendBot(cleaned);
          } else {
            appendBot(kccCopy(
              "Please contact Kanchan Cashmere for the most precise guidance.",
              "Bitte kontaktieren Sie Kanchan Cashmere für eine genaue Auskunft."
            ));
          }

          if (pageAction.href) {
            const cta = localizedKccText(pageAction.cta || "Learn More");
            appendBotHtml(
              `<a class="kcc-collectionCta" href="${safeText(localizedInternalHref(pageAction.href))}">${safeText(cta)} <span aria-hidden="true">→</span></a>`
            );
          }
        })
        .catch(() => {
          removeTyping();
          netFail();
          appendBot(kccCopy("Please try again or contact Kanchan Cashmere directly.", "Bitte versuchen Sie es erneut oder kontaktieren Sie Kanchan Cashmere direkt."));
        });
      return;
    }

    // Typed greetings are Worker-owned and continue through the Worker path.
    addTyping();

    let alreadyReplied = false;

    if (!swatchBrowse && hasB2BProductionIntent(raw)) {
      callWorker(raw)
        .then((reply) => {
          if (alreadyReplied) return;
          alreadyReplied = true;
          removeTyping();
          const cleaned = String(reply || "").trim();
          appendBot(cleaned || kccFallback("polite"));
        })
        .catch(() => {
          if (alreadyReplied) return;
          alreadyReplied = true;
          removeTyping();
          netFail();
          appendBot(kccFallback("briefError"));
        });
      return;
    }

    const uiFallback = setTimeout(() => {
      if (alreadyReplied) return;
      alreadyReplied = true;
      removeTyping();
      netFail();
      appendBot(kccFallback("briefError"));
    }, (CFG.ai && CFG.ai.timeoutMs ? CFG.ai.timeoutMs : 20000) + 150);

    try {
      const localSwatches = await tryLocalSwatchDiscovery(raw);
      if (localSwatches && !alreadyReplied) {
        alreadyReplied = true;
        clearTimeout(uiFallback);
        removeTyping();
        netSuccess();
        appendBotHtml(
          buildSwatchCardsHtml(
            localSwatches.message,
            localSwatches.products,
            localSwatches.keyword
          )
        );
        return;
      }

      const localDiscovery = await tryLocalProductDiscovery(raw);
      if (localDiscovery && !alreadyReplied) {
        alreadyReplied = true;
        clearTimeout(uiFallback);
        removeTyping();
        netSuccess();

        appendBotHtml(
          buildProductCardsHtml(
            localDiscovery.message,
            localDiscovery.products,
            localDiscovery.collectionHandle,
            localDiscovery.collectionLabel,
            localDiscovery.ctaUrl,
            localDiscovery.ctaLabel,
            detectProductTermFromText(raw)
          )
        );
        return;
      }
    } catch (_) {
      // silent fallthrough to worker
    }

    callWorker(raw)
      .then((reply) => {
        if (alreadyReplied) return;
        alreadyReplied = true;
        clearTimeout(uiFallback);
        removeTyping();

        const cleaned = String(reply || "").trim();
        appendBot(cleaned || kccFallback("polite"));
      })
      .catch(() => {
        if (alreadyReplied) return;
        alreadyReplied = true;
        clearTimeout(uiFallback);
        removeTyping();
        netFail();
        appendBot(kccFallback("briefError"));
      });
  }

  function sendFromInput() {
    const v = (INPUT && INPUT.value ? INPUT.value : "").trim();
    if (!v) return;
    INPUT.value = "";
    doSend(v);
  }

  const SEND = $("#kcc-send", panel);
  if (SEND) SEND.addEventListener("click", (e) => (e.preventDefault(), sendFromInput()));
  if (INPUT) {
    INPUT.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        sendFromInput();
      }
    });
  }
  if (COMPOSE) {
    COMPOSE.addEventListener("submit", (e) => e.preventDefault(), true);
    COMPOSE.setAttribute("role", "group");
  }

  /* ---------------------------------------------------------------------------
     Route-change refresh
  --------------------------------------------------------------------------- */
  let __kcc_last_url = location.href;
  hookHistory(() => {
    const nowUrl = location.href;
    if (nowUrl === __kcc_last_url) return;
    __kcc_last_url = nowUrl;

    try {
      abortKccDataRequests();
      if (panelOpen) closePanel();
      applyHeaderContext(false);
      if (__KCC_NET__.state !== "error") setNetState("idle");
      __KCC_BUBBLE_REVEAL__.autoHidden = false;
      __KCC_BUBBLE_REVEAL__.timed = true;
      applyVisibility();
    } catch (_) {}
  });

  /* ---------------------------------------------------------------------------
     Config refresh — NO setInterval
  --------------------------------------------------------------------------- */
  function applyBubbleEnabledFromTheme() {
    try {
      applyVisibility();
      if (!bubble.getAttribute("data-kcc-ready")) bubble.setAttribute("data-kcc-ready", "1");
    } catch (_) {}
  }

  setTimeout(() => { try { applyBubbleEnabledFromTheme(); } catch (_) {} }, 650);

  try {
    window.addEventListener("kcc:config", applyBubbleEnabledFromTheme, { passive: true });
    document.addEventListener("kcc:config", applyBubbleEnabledFromTheme, { passive: true });
  } catch (_) {}

  try {
    document.addEventListener("visibilitychange", () => { if (!document.hidden) applyBubbleEnabledFromTheme(); });
    window.addEventListener("focus", applyBubbleEnabledFromTheme, { passive: true });
  } catch (_) {}

  setTimeout(() => { try { applyVisibility(); } catch (_) {} }, 120);
})();
